/* eslint-disable */
import { WTableFormat, WRowFormat, WCellFormat } from '../format/index';
import { CharacterRangeType, FontScriptType } from '../../base/types';
import { WParagraphFormat, WCharacterFormat, WBorder, WBorders } from '../format/index';
import { isNullOrUndefined, createElement, classList } from '@syncfusion/ej2-base';
import { Dictionary } from '../../base/dictionary';
import { HelperMethods } from '../editor/editor-helper';
import { WebLayoutViewer } from './viewer';
import { Revision } from '../track-changes/track-changes';
/**
 * @private
 */
export class Rect {
    get right() {
        return this.x + this.width;
    }
    get bottom() {
        return this.y + this.height;
    }
    constructor(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    /**
     * @param currentBound
     * @private
     */
    isIntersecting(currentBound) {
        if (currentBound.y > this.bottom || this.y > currentBound.bottom ||
            currentBound.x > this.right || this.x > currentBound.right) {
            return false;
        }
        return true;
    }
    /**
     * @private
     */
    clone() {
        return new Rect(this.x, this.y, this.width, this.height);
    }
}
/**
 * @private
 */
export class Padding {
    constructor(right, left, top, bottom) {
        this.right = 10;
        this.left = 10;
        this.top = 10;
        this.bottom = 10;
        this.right = right;
        this.left = left;
        this.top = top;
        this.bottom = bottom;
    }
}
/**
 * @private
 */
export class Margin {
    constructor(leftMargin, topMargin, rightMargin, bottomMargin) {
        this.left = leftMargin;
        this.top = topMargin;
        this.right = rightMargin;
        this.bottom = bottomMargin;
    }
    clone() {
        return new Margin(this.left, this.top, this.right, this.bottom);
    }
    destroy() {
        this.left = undefined;
        this.right = undefined;
        this.top = undefined;
        this.bottom = undefined;
    }
}
/**
 * @private
 */
export class Widget {
    constructor() {
        /**
         * @private
         */
        this.childWidgets = [];
        /**
         * @private
         */
        this.x = 0;
        /**
         * @private
         */
        this.y = 0;
        /**
         * @private
         */
        this.width = 0;
        /**
         * @private
         */
        this.height = 0;
        /**
         * @private
         */
        this.index = 0;
    }
    get indexInOwner() {
        if (this instanceof BodyWidget && this.page) {
            if (this.containerWidget instanceof FootNoteWidget) {
                return this.containerWidget.bodyWidgets.indexOf(this);
            }
            else {
                return this.page.bodyWidgets.indexOf(this);
            }
        }
        else if (this.containerWidget && this.containerWidget.childWidgets) {
            return this.containerWidget.childWidgets.indexOf(this);
        }
        else if (this instanceof FootNoteWidget) {
            return 0;
        }
        return -1;
    }
    get firstChild() {
        return this.childWidgets.length > 0 ? this.childWidgets[0] : undefined;
    }
    get lastChild() {
        if (this.childWidgets) {
            return this.childWidgets.length > 0 ?
                this.childWidgets[this.childWidgets.length - 1] : undefined;
        }
        return undefined;
    }
    get previousWidget() {
        let widget = this;
        let index = this.indexInOwner;
        if (widget instanceof BodyWidget) {
            widget = index > 0 ? widget.page.bodyWidgets[index - 1] : undefined;
        }
        else {
            widget = index > 0 ? widget.containerWidget.childWidgets[index - 1] : undefined;
        }
        return widget;
    }
    get nextWidget() {
        let widget = this;
        let index = this.indexInOwner;
        if (index === -1) {
            return undefined;
        }
        if (widget instanceof BodyWidget) {
            widget = index < widget.page.bodyWidgets.length - 1 ?
                widget.page.bodyWidgets[index + 1] : undefined;
        }
        else {
            widget = index < widget.containerWidget.childWidgets.length - 1 ?
                widget.containerWidget.childWidgets[index + 1] : undefined;
        }
        return widget;
    }
    get previousRenderedWidget() {
        let widget = this;
        let index = this.indexInOwner;
        if (index < 0) {
            return undefined;
        }
        if (widget instanceof BodyWidget) {
            if (index > 0 && !(widget.containerWidget instanceof FootNoteWidget)) {
                widget = widget.page.bodyWidgets[index - 1];
            }
            else if ((widget.containerWidget instanceof FootNoteWidget) && !widget.page.documentHelper.owner.editorModule.isDeleteOrBackSpace) {
                const isEndnote = widget.containerWidget.footNoteType === 'Endnote';
                const isFirstInContainer = index === 0;
                if (isEndnote && isFirstInContainer && !isNullOrUndefined(widget.page.previousPage)
                    && !isNullOrUndefined(widget.page.previousPage.endnoteWidget) && !isNullOrUndefined(widget.page.previousPage.endnoteWidget.bodyWidgets[widget.page.previousPage.endnoteWidget.bodyWidgets.length - 1])) {
                    widget = widget.page.previousPage.endnoteWidget.bodyWidgets[widget.page.previousPage.endnoteWidget.bodyWidgets.length - 1];
                }
                else if (index <= 0) {
                    widget = undefined;
                }
                else {
                    widget = widget.containerWidget.bodyWidgets[index - 1];
                }
            }
            else {
                let page = widget.page.previousPage;
                widget = page && page.bodyWidgets.length > 0 ? page.bodyWidgets[page.bodyWidgets.length - 1] : undefined;
            }
        }
        else if (widget instanceof FootNoteWidget) {
            let page = widget.page;
            while (page.previousPage) {
                page = page.previousPage;
                widget = page.footnoteWidget;
                if (!isNullOrUndefined(widget)) {
                    break;
                }
            }
        }
        else {
            if (index > 0) {
                widget = widget.containerWidget.childWidgets[index - 1];
            }
            else {
                let previousContainer = undefined;
                if (widget.containerWidget instanceof TableCellWidget) {
                    previousContainer = widget.containerWidget.getPreviousSplitWidget();
                }
                else if (widget.containerWidget && widget.containerWidget.containerWidget instanceof FootNoteWidget &&
                    widget.containerWidget.containerWidget.footNoteType === 'Endnote') {
                    previousContainer = widget.containerWidget.previousWidget ? widget.containerWidget.previousWidget : widget.containerWidget.previousRenderedWidget;
                }
                else if (!(widget.containerWidget instanceof TableRowWidget
                    || widget.containerWidget instanceof HeaderFooterWidget || (widget.containerWidget && widget.containerWidget.containerWidget instanceof FootNoteWidget))) {
                    // Since cells are lay outed left to right, we should not navigate to previous row.
                    previousContainer = widget.containerWidget.previousRenderedWidget;
                }
                while (previousContainer && previousContainer.childWidgets.length === 0) {
                    previousContainer = previousContainer.previousRenderedWidget;
                    if (isNullOrUndefined(previousContainer)) {
                        break;
                    }
                }
                widget = previousContainer && previousContainer.constructor === widget.containerWidget.constructor ?
                    previousContainer.lastChild : undefined;
            }
        }
        return widget;
    }
    get nextRenderedWidget() {
        let widget = this;
        let index = this.indexInOwner;
        if (index < 0) {
            return undefined;
        }
        if (widget instanceof BodyWidget) {
            if (index < widget.page.bodyWidgets.length - 1 && !(widget.containerWidget instanceof FootNoteWidget)) {
                widget = widget.page.bodyWidgets[index + 1];
            }
            else if (widget.containerWidget instanceof FootNoteWidget) {
                const isEndnote = widget.containerWidget.footNoteType === 'Endnote';
                const isLastInContainer = index === widget.containerWidget.bodyWidgets.length - 1;
                if (isEndnote && isLastInContainer && !isNullOrUndefined(widget.page.nextPage)
                    && !isNullOrUndefined(widget.page.nextPage.endnoteWidget) && !isNullOrUndefined(widget.page.nextPage.endnoteWidget.bodyWidgets[0])) {
                    widget = widget.page.nextPage.endnoteWidget.bodyWidgets[0];
                }
                else if (index >= widget.containerWidget.bodyWidgets.length - 1 && !widget.page.documentHelper.owner.editorModule.isDeleteOrBackSpace) {
                    widget = undefined;
                }
                else {
                    widget = widget.containerWidget.bodyWidgets[index + 1];
                }
            }
            else if (widget.page.allowNextPageRendering) {
                let page = widget.page.nextPage;
                widget = page && page.bodyWidgets.length > 0 ? page.bodyWidgets[0] : undefined;
            }
            else {
                widget = undefined;
            }
        }
        else if (widget instanceof FootNoteWidget) {
            let page = widget.page;
            while (page.allowNextPageRendering && page.nextPage) {
                page = page.nextPage;
                widget = page.footnoteWidget;
                if (!isNullOrUndefined(widget)) {
                    break;
                }
            }
        }
        else {
            if (index < widget.containerWidget.childWidgets.length - 1) {
                widget = widget.containerWidget.childWidgets[index + 1];
            }
            else {
                let nextContainer = undefined;
                if (widget.containerWidget instanceof TableCellWidget) {
                    nextContainer = widget.containerWidget.getNextSplitWidget();
                }
                else if (widget.containerWidget && widget.containerWidget.containerWidget instanceof FootNoteWidget &&
                    widget.containerWidget.containerWidget.footNoteType === 'Endnote') {
                    nextContainer = widget.containerWidget.nextWidget ? widget.containerWidget.nextWidget : widget.containerWidget.nextRenderedWidget;
                }
                else if (!(widget.containerWidget instanceof TableRowWidget
                    || widget.containerWidget instanceof HeaderFooterWidget || (widget.containerWidget && widget.containerWidget.containerWidget instanceof FootNoteWidget))) {
                    // Since cells are lay outed left to right, we should not navigate to next row.
                    nextContainer = widget.containerWidget.nextRenderedWidget;
                }
                while (nextContainer && nextContainer.childWidgets.length === 0 && !(nextContainer instanceof TableCellWidget)) {
                    nextContainer = nextContainer.nextRenderedWidget;
                    if (isNullOrUndefined(nextContainer)) {
                        break;
                    }
                }
                widget = nextContainer && nextContainer.constructor === widget.containerWidget.constructor ?
                    nextContainer.firstChild : undefined;
            }
        }
        return widget;
    }
    get previousSplitWidget() {
        let widget = this;
        if (widget instanceof TableCellWidget) {
            return widget.getPreviousSplitWidget();
        }
        else {
            let previous = widget.previousRenderedWidget;
            if (widget instanceof BodyWidget && previous instanceof BodyWidget && widget.equals(previous)) {
                if (widget.containerWidget instanceof FootNoteWidget && widget.containerWidget.footNoteType === 'Endnote' && widget.index !== previous.index) {
                    return undefined;
                }
                return previous;
            }
            else if (previous instanceof BlockWidget && widget.index === previous.index && widget.equals(previous)) {
                return previous;
            }
        }
        return undefined;
    }
    get nextSplitWidget() {
        let widget = this;
        if (widget instanceof TableCellWidget) {
            return widget.getNextSplitWidget();
        }
        else {
            let next = widget.nextRenderedWidget;
            if (widget instanceof BodyWidget && next instanceof BodyWidget && widget.equals(next)) {
                if (widget.containerWidget instanceof FootNoteWidget && widget.containerWidget.footNoteType === 'Endnote' && widget.index !== next.index) {
                    return undefined;
                }
                return next;
            }
            else if (next instanceof BlockWidget && widget.index === next.index && widget.equals(next)) {
                return next;
            }
        }
        return undefined;
    }
    getPreviousSplitWidgets() {
        let widgets = [];
        let widget = this.previousSplitWidget;
        while (widget) {
            widgets.unshift(widget);
            widget = widget.previousSplitWidget;
            if (widget && widget == widget.previousSplitWidget) {
                break;
            }
        }
        return widgets;
    }
    getSplitWidgets() {
        let widgets = this.getPreviousSplitWidgets();
        let widget = this;
        while (widget) {
            widgets.push(widget);
            widget = widget.nextSplitWidget;
        }
        return widgets;
    }
    combineWidget(viewer) {
        let root = this;
        let widgets = this.getSplitWidgets();
        if (widgets.length > 1) {
            root = widgets.shift();
            while (widgets.length > 0) {
                let splitWidget = widgets.shift();
                root.combine(splitWidget, viewer);
            }
        }
        if (root instanceof TableWidget) {
            root.combineRows(viewer);
        }
        return root;
    }
    combine(widget, viewer) {
        if (widget.childWidgets.length > 0) {
            let lastChild = this.lastChild;
            if (lastChild instanceof TableWidget) {
                lastChild.combineWidget(viewer);
            }
            else {
                let firstChild = widget.firstChild;
                if (!(widget instanceof TableWidget) && lastChild instanceof Widget && firstChild instanceof Widget &&
                    lastChild.index === firstChild.index) {
                    lastChild.combine(widget.childWidgets.shift(), viewer);
                }
            }
            this.addWidgets(widget.childWidgets);
            widget.childWidgets = [];
        }
        widget.destroyInternal(viewer);
    }
    addWidgets(childWidgets) {
        while (childWidgets.length > 0) {
            let widget = childWidgets.shift();
            if (widget instanceof LineWidget && this instanceof ParagraphWidget) {
                widget.paragraph = this;
                this.height += widget.height;
            }
            else if (widget instanceof Widget) {
                let lastChild = this.lastChild;
                widget.containerWidget = this;
                widget.y = lastChild instanceof Widget ? lastChild.y + lastChild.height : this.y;
                this.height += widget.height;
            }
            if (widget instanceof TableRowWidget) {
                let previousRow = this.childWidgets[this.childWidgets.length - 1];
                for (let i = 0; i < previousRow.childWidgets.length; i++) {
                    let previousCell = previousRow.childWidgets[i];
                    if (previousCell.cellFormat.rowSpan > 1) {
                        for (let j = 0; j < widget.childWidgets.length; j++) {
                            let currentCell = widget.childWidgets[j];
                            if (currentCell.columnIndex === previousCell.columnIndex && currentCell.isSplittedCell && currentCell.cellFormat.rowSpan === previousCell.cellFormat.rowSpan) {
                                for (let k = 0; k < currentCell.childWidgets.length; k++) {
                                    let block = currentCell.childWidgets[k];
                                    currentCell.childWidgets.splice(block.indexInOwner, 1);
                                    previousCell.childWidgets.push(block);
                                    block.containerWidget = previousCell;
                                    k--;
                                }
                                currentCell.ownerRow.childWidgets.splice(currentCell.indexInOwner, 1);
                                currentCell.containerWidget = undefined;
                                j--;
                            }
                        }
                    }
                }
            }
            this.childWidgets.push(widget);
        }
    }
    removeChild(index) {
        if (index > -1 && index < this.childWidgets.length) {
            this.childWidgets.splice(index, 1);
        }
    }
    destroy() {
        if (this.childWidgets) {
            while (this.childWidgets.length > 0) {
                let child = this.childWidgets.pop();
                if (child instanceof LineWidget || child instanceof Widget) {
                    child.destroy();
                }
            }
        }
        this.childWidgets = undefined;
        if (this.containerWidget) {
            this.containerWidget.removeChild(this.indexInOwner);
        }
        this.containerWidget = undefined;
        // if (this.margin) {
        //     this.margin.destroy();
        // }
        this.margin = undefined;
        this.x = undefined;
        this.y = undefined;
        this.width = undefined;
        this.height = undefined;
        this.index = undefined;
    }
    /**
     * Disposes the internal objects which are maintained.
     * @private
     */
    componentDestroy() {
        if (this.childWidgets) {
            while (this.childWidgets.length > 0) {
                let child = this.childWidgets.pop();
                if (child instanceof LineWidget || child instanceof Widget) {
                    child.componentDestroy();
                }
            }
        }
        this.childWidgets = undefined;
        if (this.margin) {
            this.margin.destroy();
        }
        this.margin = undefined;
        this.x = undefined;
        this.y = undefined;
        this.width = undefined;
        this.height = undefined;
        this.index = undefined;
        this.containerWidget = undefined;
    }
}
/**
 * @private
 */
export class BlockContainer extends Widget {
    constructor() {
        super(...arguments);
        /**
         * @private
         */
        this.floatingElements = [];
        /**
         * @private
         */
        this.footNoteReference = undefined;
        /**
         * @private
         */
        this.sectionFormatIn = undefined;
        /**
        * @private
        */
        this.columnIndex = 0;
        /**
        * @private
        */
        this.headerSectionIndex = 0;
        /**
         * @private
         */
        this.isWord2010NextColumn = false;
    }
    get sectionFormat() {
        let container = this;
        if (container instanceof BodyWidget) {
            return container.sectionFormatIn;
        }
        else if (container.page && !isNullOrUndefined(container.page.bodyWidgets)) {
            return container.page.bodyWidgets[0].sectionFormat;
        }
        return undefined;
    }
    set sectionFormat(value) {
        if (this instanceof BodyWidget) {
            this.sectionFormatIn = value;
        }
    }
    get sectionIndex() {
        let container = this;
        let index = 0;
        if (container instanceof BodyWidget) {
            index = container.index;
        }
        else if (container.page) {
            index = container.page.bodyWidgets[0].index;
        }
        return index;
    }
    getHierarchicalIndex(hierarchicalIndex) {
        let documentHelper = this.page.documentHelper;
        ;
        let node = this;
        if (node instanceof BodyWidget) {
            hierarchicalIndex = node.index + ';' + hierarchicalIndex;
        }
        else if (node instanceof FootNoteWidget) {
            if (node.footNoteType === 'Footnote') {
                hierarchicalIndex = 'FN' + ';' + hierarchicalIndex;
            }
            else {
                hierarchicalIndex = 'EN' + ';' + hierarchicalIndex;
            }
        }
        else {
            if (documentHelper.owner.enableLayout) {
                if (node.headerFooterType.indexOf('Header') !== -1) {
                    hierarchicalIndex = 'H' + ';' + hierarchicalIndex;
                }
                else {
                    hierarchicalIndex = 'F' + ';' + hierarchicalIndex;
                }
            }
            else {
                let headerIndex = documentHelper.selection.getHeaderFooterIndex(node).toString();
                if (node.headerFooterType.indexOf('Header') !== -1) {
                    hierarchicalIndex = 'H' + ';' + headerIndex + ';' + hierarchicalIndex;
                }
                else {
                    hierarchicalIndex = 'F' + ';' + headerIndex + ';' + hierarchicalIndex;
                }
            }
        }
        if (!isNullOrUndefined(node.page)) {
            if (documentHelper.owner.enableLayout) {
                let pageIndex = documentHelper.pages.indexOf(this.page);
                return pageIndex + ';' + hierarchicalIndex;
            }
            else {
                if (node instanceof HeaderFooterWidget) {
                    let pageIndex = node.headerSectionIndex;
                    return pageIndex + ';' + hierarchicalIndex;
                }
            }
        }
        return hierarchicalIndex;
    }
    /**
     * Disposes the internal objects which are maintained.
     * @private
     */
    componentDestroy() {
        if (this.sectionFormatIn) {
            this.sectionFormatIn.destroy();
        }
        this.sectionFormatIn = undefined;
        this.floatingElements = [];
        this.removedHeaderFooters = [];
        this.footNoteReference = undefined;
        this.page = undefined;
        super.componentDestroy();
    }
}
/**
 * @private
 */
export class BodyWidget extends BlockContainer {
    /**
     * Initialize the constructor of BodyWidget
     */
    constructor() {
        super();
    }
    equals(widget) {
        return widget instanceof BodyWidget && widget.sectionFormat === this.sectionFormat;
    }
    getHierarchicalIndex(hierarchicalIndex) {
        let documentHelper = undefined;
        let node = this;
        if (node.containerWidget instanceof FootNoteWidget) {
            hierarchicalIndex = node.containerWidget.bodyWidgets.indexOf(node) + ';' + hierarchicalIndex;
            if (node.containerWidget.footNoteType === 'Footnote') {
                hierarchicalIndex = 'FN' + ';' + hierarchicalIndex;
            }
            else {
                hierarchicalIndex = 'EN' + ';' + hierarchicalIndex;
            }
        }
        else {
            if (this.page && this.page.bodyWidgets.indexOf(this) !== -1) {
                hierarchicalIndex = this.page.bodyWidgets.indexOf(this) + ';' + hierarchicalIndex;
            }
            else {
                hierarchicalIndex = node.index + ';' + hierarchicalIndex;
            }
        }
        if (!isNullOrUndefined(node.page)) {
            documentHelper = this.page.documentHelper;
            let pageIndex = documentHelper.pages.indexOf(this.page);
            return pageIndex + ';' + hierarchicalIndex;
        }
        return hierarchicalIndex;
    }
    getTableCellWidget(touchPoint) {
        for (let i = 0; i < this.childWidgets.length; i++) {
            if (this.childWidgets[i] instanceof TableWidget) {
                const childWidget = this.childWidgets[i];
                let tableWidth = 0;
                if (childWidget.wrapTextAround) {
                    tableWidth = childWidget.getTableCellWidth();
                }
                if (!(childWidget.wrapTextAround) && childWidget.y <= touchPoint.y && (childWidget.y + childWidget.height) >= touchPoint.y) {
                    return childWidget.getTableCellWidget(touchPoint);
                }
                if ((childWidget.wrapTextAround &&
                    (childWidget.x <= touchPoint.x && (childWidget.x + tableWidth) >= touchPoint.x &&
                        childWidget.y <= touchPoint.y && (childWidget.y + childWidget.height) >= touchPoint.y))) {
                    return childWidget.getTableCellWidget(touchPoint);
                }
            }
        }
        let tableCellWidget = undefined;
        if (this.childWidgets.length > 0) {
            if (this.childWidgets[0].y <= touchPoint.y) {
                tableCellWidget = this.childWidgets[this.childWidgets.length - 1].getTableCellWidget(touchPoint);
            }
            else {
                tableCellWidget = this.childWidgets[0].getTableCellWidget(touchPoint);
            }
        }
        return tableCellWidget;
    }
    destroyInternal(viewer) {
        let height = this.height;
        if (!isNullOrUndefined(this.childWidgets)) {
            for (let n = 0; n < this.childWidgets.length; n++) {
                let chilgWidget = this.childWidgets[n];
                if (chilgWidget instanceof ParagraphWidget) {
                    chilgWidget.destroyInternal(viewer);
                }
                else {
                    chilgWidget.destroyInternal(viewer);
                }
                if (isNullOrUndefined(this.childWidgets)) {
                    break;
                }
                n--;
            }
            this.childWidgets = undefined;
        }
        // if (this instanceof HeaderFooterWidget && ((this as HeaderFooterWidget).currentNode ))) {
        //     if (((this as HeaderFooterWidget).currentNode as WHeaderFooter).layoutedWidgets )) {
        //         let index: number = ((this as HeaderFooterWidget).currentNode as WHeaderFooter).layoutedWidgets.indexOf(this);
        //         ((this as HeaderFooterWidget).currentNode as WHeaderFooter).layoutedWidgets.splice(index, 1);
        //     }
        //     this.currentNode = undefined;
        if (!isNullOrUndefined(this.page)) {
            let index = this.indexInOwner;
            if (this.indexInOwner > -1) {
                this.page.bodyWidgets.splice(index, 1);
                if (this.page.bodyWidgets.length === 0) {
                    this.page.destroy();
                    // }
                }
                else if ((this instanceof HeaderFooterWidget)
                    && this.page.headerWidget === this) {
                    this.page.headerWidget = undefined;
                }
                else if ((this instanceof HeaderFooterWidget)
                    && this.page.footerWidget === this) {
                    this.page.footerWidget = undefined;
                }
                this.page = undefined;
            }
        }
        this.destroy();
    }
    destroy() {
        // if (this.sectionFormatIn) {
        //     this.sectionFormatIn.destroy();
        // }
        this.sectionFormatIn = undefined;
        if (this.page && this.page.headerWidgetIn) {
            this.page.headerWidgetIn.page = undefined;
        }
        if (this.page && this.page.footerWidgetIn) {
            this.page.footerWidgetIn.page = undefined;
        }
        this.page = undefined;
        super.destroy();
    }
    /**
     * Disposes the internal objects which are maintained.
     * @private
     */
    componentDestroy() {
        super.componentDestroy();
    }
}
/**
 * @private
 */
export class HeaderFooterWidget extends BlockContainer {
    constructor(type) {
        super();
        /**
         * @private
         */
        this.isEmpty = false;
        this.headerFooterType = type;
    }
    getTableCellWidget(point) {
        for (let i = 0; i < this.childWidgets.length; i++) {
            if (this.childWidgets[i] instanceof TableWidget) {
                const child = this.childWidgets[i];
                let tableWidth = 0;
                if (child.wrapTextAround) {
                    tableWidth = child.getTableCellWidth();
                }
                if (!(child.wrapTextAround) && child.y <= point.y && (child.y + child.height) >= point.y) {
                    return child.getTableCellWidget(point);
                }
                if ((child.wrapTextAround &&
                    (child.x <= point.x && (child.x + tableWidth) >= point.x &&
                        child.y <= point.y && (child.y + child.height) >= point.y))) {
                    return child.getTableCellWidget(point);
                }
            }
        }
        let tableCell = undefined;
        if (this.childWidgets.length > 0) {
            if (this.childWidgets[0].y <= point.y) {
                tableCell = this.childWidgets[this.childWidgets.length - 1].getTableCellWidget(point);
            }
            else {
                tableCell = this.childWidgets[0].getTableCellWidget(point);
            }
        }
        return tableCell;
    }
    equals(widget) {
        // Todo: Need to work
        return widget instanceof HeaderFooterWidget
            && widget.containerWidget === this.containerWidget;
    }
    clone() {
        let headerFooter = new HeaderFooterWidget(this.headerFooterType);
        for (let i = 0; i < this.childWidgets.length; i++) {
            let block = this.childWidgets[i].clone();
            headerFooter.childWidgets.push(block);
            block.index = i;
            block.containerWidget = headerFooter;
        }
        headerFooter.isEmpty = this.isEmpty;
        headerFooter.x = this.x;
        headerFooter.y = this.y;
        headerFooter.height = 0;
        headerFooter.width = 0;
        return headerFooter;
    }
    destroyInternal(viewer) {
        this.page = undefined;
        super.destroy();
    }
    /**
     * Disposes the internal objects which are maintained.
     * @private
     */
    componentDestroy() {
        super.componentDestroy();
        this.parentHeaderFooter = undefined;
    }
}
/**
 * @private
 */
export class BlockWidget extends Widget {
    constructor() {
        super(...arguments);
        /**
         * @private
         */
        this.isLayouted = false;
        /**
         * @private
         */
        this.isFieldCodeBlock = false;
        /**
         * @private
         */
        this.locked = false;
        /**
         * @private
         */
        this.lockedBy = '';
    }
    get bodyWidget() {
        let widget = this;
        while (widget.containerWidget) {
            if (widget.containerWidget instanceof TextFrame) {
                let paragraph;
                if (widget.containerWidget.containerShape instanceof ShapeElementBox) {
                    let shape = widget.containerWidget.containerShape;
                    while (!isNullOrUndefined(shape.containerShape)) {
                        shape = shape.containerShape;
                    }
                    paragraph = shape.line.paragraph;
                }
                else {
                    paragraph = widget.containerWidget.containerShape.line.paragraph;
                }
                if (paragraph) {
                    return paragraph.bodyWidget;
                }
            }
            else if (widget.containerWidget instanceof BlockContainer) {
                return widget.containerWidget;
            }
            widget = widget.containerWidget;
        }
        return undefined;
    }
    get leftIndent() {
        let blockAdv = this;
        if (blockAdv instanceof ParagraphWidget && blockAdv.paragraphFormat instanceof WParagraphFormat) {
            return blockAdv.paragraphFormat.leftIndent;
        }
        else if (blockAdv instanceof TableWidget && blockAdv.tableFormat instanceof WTableFormat) {
            return blockAdv.tableFormat.leftIndent;
        }
        return 0;
    }
    get rightIndent() {
        let blockAdv = this;
        if (blockAdv instanceof ParagraphWidget && blockAdv.paragraphFormat instanceof WParagraphFormat) {
            return blockAdv.paragraphFormat.rightIndent;
        }
        return 0;
    }
    get isInsideTable() {
        return this.containerWidget instanceof TableCellWidget;
    }
    get isInHeaderFooter() {
        return this.bodyWidget instanceof HeaderFooterWidget;
    }
    get associatedCell() {
        if (this.containerWidget instanceof TableCellWidget) {
            return this.containerWidget;
        }
        return undefined;
    }
    /**
     * Check whether the paragraph contains only page break.
     *
     * @private
     * @returns {boolean}: Returns true if paragraph contains page break alone.
     */
    isPageBreak() {
        let isPageBreak = false;
        if (this instanceof ParagraphWidget) {
            let paragraph = this;
            if (paragraph != null && paragraph.childWidgets.length === 1 &&
                paragraph.firstChild.children.length === 1) {
                let pageBreak = paragraph.firstChild.children[0];
                isPageBreak = pageBreak.isPageBreak;
            }
        }
        return isPageBreak;
    }
    isColumnBreak() {
        let isColumnBreak = false;
        if (this instanceof ParagraphWidget) {
            let paragraph = this;
            if (paragraph != null && paragraph.childWidgets.length === 1 &&
                paragraph.firstChild.children.length === 1) {
                let columnBreak = paragraph.firstChild.children[0];
                isColumnBreak = columnBreak.isColumnBreak;
            }
        }
        return isColumnBreak;
    }
    getHierarchicalIndex(hierarchicalIndex) {
        let node = this;
        hierarchicalIndex = node.containerWidget.childWidgets.indexOf(node) + ';' + hierarchicalIndex;
        if (!isNullOrUndefined(node.containerWidget)) {
            if (node.containerWidget instanceof TextFrame) {
                return node.containerWidget.getHierarchicalIndex(hierarchicalIndex);
            }
            else if (node.containerWidget instanceof BlockWidget) {
                return node.containerWidget.getHierarchicalIndex(hierarchicalIndex);
            }
            else if (node.containerWidget instanceof BlockContainer) {
                hierarchicalIndex = node.containerWidget.getHierarchicalIndex(hierarchicalIndex);
            }
        }
        return hierarchicalIndex;
    }
    getIndex() {
        if (this instanceof ParagraphWidget || this instanceof TableWidget) {
            return this.containerWidget.childWidgets.indexOf(this);
        }
        else if (this instanceof TableRowWidget) {
            return this.ownerTable.childWidgets.indexOf(this);
        }
        else if (this instanceof TableCellWidget) {
            return this.ownerRow.childWidgets.indexOf(this);
        }
        return 0;
    }
    getContainerWidth() {
        if (this.isInsideTable) {
            let block = this;
            if ((block instanceof TableWidget) && block.tableFormat.preferredWidthType === 'Auto' && this.associatedCell.ownerTable.isGridUpdated) {
                let containerWidth = 0;
                let columnSpan = this.associatedCell.cellFormat.columnSpan;
                let columnIndex = this.associatedCell.columnIndex;
                for (let i = 0; i < columnSpan; i++) {
                    containerWidth += this.associatedCell.ownerTable.tableHolder.columns[columnIndex].preferredWidth;
                    columnIndex++;
                }
                if (containerWidth > 0) {
                    return containerWidth;
                }
            }
            let width = this.associatedCell.getCellWidth(this);
            const ownerCell = this.associatedCell;
            const cellSpacing = !isNullOrUndefined(ownerCell.ownerRow) && !isNullOrUndefined(ownerCell.ownerRow.ownerTable) ?
                ownerCell.ownerRow.ownerTable.tableFormat.cellSpacing : 0;
            let leftPad = 0;
            let rightPad = 0;
            if (block instanceof TableWidget && cellSpacing > 0) {
                leftPad = cellSpacing * 2 + block.tableFormat.borders.left.getLineWidth();
                rightPad = cellSpacing * 2 + block.tableFormat.borders.right.getLineWidth();
                width -= leftPad + rightPad;
            }
            //Calculates the cell client width reducing padding and cell spacing.		
            return width;
        }
        if (this.containerWidget instanceof TextFrame) {
            let shape = this.containerWidget.containerShape;
            return HelperMethods.convertPixelToPoint(shape.width) - HelperMethods.convertPixelToPoint(shape.textFrame.marginLeft)
                - HelperMethods.convertPixelToPoint(shape.textFrame.marginRight);
        }
        else {
            let bodyWidget = this.bodyWidget;
            let sectionFormat = bodyWidget.sectionFormat;
            let padding = 0;
            if (!isNullOrUndefined(bodyWidget.page) && !isNullOrUndefined(bodyWidget.page.documentHelper) &&
                bodyWidget.page.documentHelper.compatibilityMode !== 'Word2013' && !this.isInsideTable && this instanceof TableWidget) {
                let firstRow = this.firstChild;
                padding = firstRow.firstChild.leftMargin + (firstRow).lastChild.rightMargin;
            }
            if (bodyWidget instanceof BodyWidget && sectionFormat.columns.length > 1) {
                let colIndex = bodyWidget.columnIndex;
                return HelperMethods.convertPixelToPoint(sectionFormat.columns[colIndex].width);
            }
            else {
                return sectionFormat.pageWidth - (sectionFormat.leftMargin + sectionFormat.rightMargin) + padding;
            }
        }
    }
    get bidi() {
        if (this instanceof ParagraphWidget && this.paragraphFormat instanceof WParagraphFormat) {
            return this.paragraphFormat.bidi;
        }
        if (this instanceof TableWidget && this.tableFormat instanceof WTableFormat) {
            return this.tableFormat.bidi;
        }
        return false;
    }
    /**
     * Disposes the internal objects which are maintained.
     * @private
     */
    componentDestroy() {
        super.componentDestroy();
        this.contentControlProperties = undefined;
    }
}
/**
 * @private
 */
export class FootNoteWidget extends BlockContainer {
    constructor() {
        super(...arguments);
        /**
         * @private
         */
        this.bodyWidgets = [];
    }
    getMinimumAndMaximumWordWidth(minimumWordWidth, maximumWordWidth) {
        throw new Error('Method not implemented.');
    }
    getTableCellWidget(point) {
        return undefined;
    }
    equals(widget) {
        // Todo: Need to work
        return widget instanceof FootNoteWidget
            && widget.containerWidget === this.containerWidget;
    }
    clone() {
        let footNote = new FootNoteWidget();
        for (let i = 0; i < this.childWidgets.length; i++) {
            let block = this.childWidgets[i].clone();
            footNote.childWidgets.push(block);
            block.index = i;
            block.containerWidget = footNote;
        }
        footNote.block = this.block;
        return footNote;
    }
    destroyInternal(viewer) {
        this.block = undefined;
        super.destroy();
    }
    /**
     * Disposes the internal objects which are maintained.
     * @private
     */
    componentDestroy() {
        if (this.bodyWidgets && this.bodyWidgets.length > 0) {
            for (let i = 0; i < this.bodyWidgets.length; i++) {
                let bodyWidget = this.bodyWidgets[i];
                bodyWidget.componentDestroy();
            }
            this.bodyWidgets = [];
        }
        this.bodyWidgets = undefined;
        this.block = undefined;
        super.componentDestroy();
    }
}
/**
 * @private
 */
export class ParagraphWidget extends BlockWidget {
    /**
     * Initialize the constructor of ParagraphWidget
     */
    constructor() {
        super();
        /**
         * @private
         */
        this.isSectionBreak = false;
        /**
         * @private
         */
        this.isChangeDetected = false;
        /**
         * @private
         */
        this.isUpdateBookmarkEnd = false;
        /**
         * @private
         */
        this.ischildContentControl = false;
        /**
         * @private
         */
        this.textWrapWidth = false;
        /**
         * @private
         * The clientX having previous left value of empty paragraph
         */
        this.clientX = undefined;
        /**
         * @private
         */
        this.isRender = true;
        /**
         * @private
         */
        this.floatingElements = [];
        this.paragraphFormat = new WParagraphFormat(this);
        this.characterFormat = new WCharacterFormat(this);
    }
    get isEndsWithPageBreak() {
        if (this.childWidgets.length > 0) {
            return this.lastChild.isEndsWithPageBreak;
        }
        return false;
    }
    get isEndsWithColumnBreak() {
        if (this.childWidgets.length > 0) {
            return this.lastChild.isEndsWithColumnBreak;
        }
        return false;
    }
    getRevisionRange(revision) {
        let paragraphView = this.getSplitWidgets();
        let range = [];
        for (let i = 0; i < paragraphView.length; i++) {
            let paragraph = paragraphView[i];
            for (let j = 0; j < paragraph.childWidgets.length; j++) {
                let line = paragraph.childWidgets[j];
                for (let k = 0; k < line.children.length; k++) {
                    let element = line.children[k];
                    if (!isNullOrUndefined(element.getAllRevision()) && element.getAllRevision().indexOf(revision) !== -1) {
                        range.push(element);
                    }
                }
            }
        }
        return range;
    }
    /**
     * @private
     * @param isUpdateOwnerNode Used for updating ownerNode of the revisions.
     * @returns {Revision[]} Returns the revisions of the paragraph.
     */
    getAllRevisions(isUpdateOwnerNode) {
        let paragraphRevisions = [];
        for (let j = 0; j < this.childWidgets.length; j++) {
            let lineWidget = this.childWidgets[j];
            for (let k = 0; k < lineWidget.children.length; k++) {
                let element = lineWidget.children[k];
                for (let i = 0; i < element.revisionLength; i++) {
                    let revision = element.getRevision(i);
                    if (paragraphRevisions.indexOf(revision) === -1) {
                        paragraphRevisions.push(revision);
                        if (isUpdateOwnerNode) {
                            revision.ownerNode = this;
                        }
                    }
                }
            }
        }
        for (var i = 0; i < this.characterFormat.revisionLength; i++) {
            var revision = this.characterFormat.getRevision(i);
            if (paragraphRevisions.indexOf(revision) === -1) {
                paragraphRevisions.push(revision);
                if (isUpdateOwnerNode) {
                    revision.ownerNode = this.characterFormat;
                }
            }
        }
        return paragraphRevisions;
    }
    equals(widget) {
        return widget instanceof ParagraphWidget && widget.paragraphFormat === this.paragraphFormat;
    }
    isContainsShapeAlone() {
        let containsShape = false;
        for (let i = 0; i < this.childWidgets.length; i++) {
            let lineWidget = this.childWidgets[i];
            for (let j = 0; j < lineWidget.children.length; j++) {
                let inline = lineWidget.children[j];
                if (!(inline instanceof ShapeBase) || (inline instanceof ShapeBase && inline.textWrappingStyle === 'Inline')) {
                    return false;
                }
                else {
                    containsShape = true;
                }
            }
        }
        return containsShape ? true : false;
    }
    isEmptyInternal(layoutCheck) {
        if (isNullOrUndefined(this.childWidgets) || this.childWidgets.length === 0) {
            return true;
        }
        for (let j = 0; j < this.childWidgets.length; j++) {
            let inlineElement = this.childWidgets[j];
            for (let i = 0; i < inlineElement.children.length; i++) {
                let inline = inlineElement.children[i];
                if (inline.length === 0) {
                    continue;
                }
                if (inline instanceof TextElementBox || inline instanceof ImageElementBox || inline instanceof BookmarkElementBox
                    || inline instanceof EditRangeEndElementBox || inline instanceof EditRangeStartElementBox
                    || inline instanceof ChartElementBox || inline instanceof ShapeElementBox || inline instanceof GroupShapeElementBox
                    || inline instanceof ContentControl || (inline instanceof CommentCharacterElementBox && !layoutCheck)
                    || (inline instanceof FieldElementBox && HelperMethods.isLinkedFieldCharacter(inline))) {
                    return false;
                }
            }
        }
        return true;
    }
    isEmpty() {
        return this.isEmptyInternal(false);
    }
    getInline(offset, indexInInline) {
        let inline = undefined;
        let count = 0;
        let isStarted = false;
        let splittedWidget = this.getSplitWidgets();
        for (let k = 0; k < splittedWidget.length; k++) {
            let widget = splittedWidget[k];
            for (let j = 0; j < widget.childWidgets.length; j++) {
                let line = widget.childWidgets[j];
                for (let i = 0; i < line.children.length; i++) {
                    inline = line.children[i];
                    if (inline instanceof ListTextElementBox) {
                        continue;
                    }
                    if (!isStarted && (inline instanceof TextElementBox || inline instanceof ImageElementBox
                        || inline instanceof ShapeElementBox || inline instanceof GroupShapeElementBox
                        || inline instanceof BookmarkElementBox || inline instanceof FieldElementBox
                        && HelperMethods.isLinkedFieldCharacter(inline))
                        || inline instanceof ChartElementBox || inline instanceof ContentControl || inline instanceof CommentCharacterElementBox) {
                        isStarted = true;
                    }
                    if (isStarted && offset <= count + inline.length) {
                        indexInInline = (offset - count);
                        return { 'element': inline, 'index': indexInInline };
                    }
                    count += inline.length;
                }
            }
        }
        if (offset > count) {
            indexInInline = isNullOrUndefined(inline) ? offset : inline.length;
        }
        return { 'element': inline, 'index': indexInInline };
    }
    getLength() {
        let length = 0;
        if (isNullOrUndefined(this.childWidgets)) {
            return length;
        }
        for (let j = 0; j < this.childWidgets.length; j++) {
            let line = this.childWidgets[j];
            for (let i = 0; i < line.children.length; i++) {
                let element = line.children[i];
                if (element instanceof ListTextElementBox) {
                    continue;
                }
                length += element.length;
            }
        }
        return length;
    }
    /**
     * Return the total length by considering splitted paragraph widgets.
     * @private
     */
    getTotalLength() {
        let offset = 0;
        let splittedWidget = this.getSplitWidgets();
        for (let i = 0; i < splittedWidget.length; i++) {
            offset += splittedWidget[i].getLength();
        }
        return offset;
    }
    getTableCellWidget(point) {
        return undefined;
    }
    getMinimumAndMaximumWordWidth(minimumWordWidth, maximumWordWidth) {
        minimumWordWidth = HelperMethods.convertPointToPixel(minimumWordWidth);
        maximumWordWidth = HelperMethods.convertPointToPixel(maximumWordWidth);
        if (this.childWidgets.length > 0) {
            let element = this.childWidgets[0].children[0];
            let text = '';
            let elements = new Dictionary();
            let imageWidths = [];
            let isAutoWidth = false;
            let isAllColumnHasAutoWidthType = false;
            do {
                if (element instanceof TextElementBox && element.text !== '') {
                    elements.add(element, text.length);
                    text += (element.text);
                }
                else if (element instanceof FieldElementBox && element.fieldType === 0) {
                    let fieldBegin = element;
                    if (!isNullOrUndefined(fieldBegin.fieldEnd)) {
                        element = isNullOrUndefined(fieldBegin.fieldSeparator) ? fieldBegin.fieldEnd : fieldBegin.fieldSeparator;
                    }
                }
                else if (element instanceof ImageElementBox) {
                    imageWidths.push(element.width);
                }
                if (isNullOrUndefined(element) || isNullOrUndefined(element.nextNode)) {
                    break;
                }
                element = element.nextNode;
            } while (true);
            if (this.isInsideTable && this.containerWidget instanceof TableCellWidget && this.containerWidget.ownerTable &&
                this.containerWidget.ownerTable.bodyWidget && this.containerWidget.ownerTable.bodyWidget.page &&
                this.containerWidget.ownerTable.bodyWidget.page.documentHelper && this.containerWidget.ownerTable.bodyWidget.page.documentHelper.layout
                && this.bodyWidget.page.documentHelper.layout.isAllColumnHasAutoWidthType) {
                isAllColumnHasAutoWidthType = true;
            }
            if (this.containerWidget instanceof TableCellWidget && this.containerWidget.ownerTable && (this.containerWidget.ownerTable.tableFormat.preferredWidthType === 'Auto' || (this.containerWidget.ownerTable.tableFormat.preferredWidthType === "Point" && this.containerWidget.ownerTable.tableFormat.preferredWidth === 0))) {
                isAutoWidth = true;
            }
            //Word split
            let texts = [];
            let word;
            this.bodyWidget.page.documentHelper.textHelper.position = 0;
            do {
                let pos = this.bodyWidget.page.documentHelper.textHelper.position;
                word = this.bodyWidget.page.documentHelper.textHelper.readWord(text, elements, isAutoWidth, isAllColumnHasAutoWidthType);
                if (word) {
                    texts.push({ value: word, index: pos });
                }
            } while (this.bodyWidget.page.documentHelper.textHelper.position < text.length);
            for (let i = 0; i < texts.length; i++) {
                let match = texts[i].value;
                let position = texts[i].index;
                let width = 0;
                text = '';
                let matchedValue = '';
                let wordStartIndex = 0;
                let wordEndIndex = position;
                let index = position;
                for (let j = 0; j < elements.keys.length; j++) {
                    let span = elements.keys[j];
                    let startIndex = elements.get(span);
                    let spanLength = span.length;
                    if (index <= startIndex + spanLength) {
                        wordStartIndex = index - startIndex;
                        if (position + match.length <= startIndex + spanLength) {
                            wordEndIndex = (position + match.length) - (startIndex + wordStartIndex);
                        }
                        else {
                            wordEndIndex = spanLength - wordStartIndex;
                            index += wordEndIndex;
                        }
                        text = span.text.substring(wordStartIndex, wordStartIndex + wordEndIndex);
                        matchedValue = matchedValue + text;
                    }
                    if (text !== '') {
                        width += this.bodyWidget.page.documentHelper.textHelper.getWidth(text, span.characterFormat, span.scriptType);
                    }
                    if (matchedValue === match) {
                        break;
                    }
                }
                if (width !== 0) {
                    if (minimumWordWidth === 0 || width > minimumWordWidth) {
                        minimumWordWidth = width;
                    }
                }
            }
            // Check the image widths present in the paragraph. Consider the maximum image width as minimum word width.
            let imageWidth = 0;
            if (imageWidths.length > 0) {
                imageWidth = Math.max.apply(null, imageWidths);
            }
            if (minimumWordWidth === 0 || imageWidth > minimumWordWidth) {
                minimumWordWidth = imageWidth;
            }
            let maximum = this.measureParagraph();
            if (maximumWordWidth === 0 || maximum > maximumWordWidth) {
                maximumWordWidth = maximum;
            }
        }
        let leftIndent = 0;
        if (!this.isEmpty() && this.floatingElements.length == 0 && !isNullOrUndefined(this.paragraphFormat) && this.paragraphFormat.leftIndent > 0
            && !isNullOrUndefined(this.associatedCell) && !isNullOrUndefined(this.associatedCell.cellFormat) && this.associatedCell.cellFormat.preferredWidthType === 'Point') {
            const paraIndent = this.paragraphFormat.leftIndent + this.paragraphFormat.firstLineIndent;
            if ((paraIndent + minimumWordWidth) > this.associatedCell.cellFormat.preferredWidth) {
                leftIndent = paraIndent;
            }
        }
        return {
            'maximumWordWidth': HelperMethods.convertPixelToPoint(maximumWordWidth),
            'minimumWordWidth': HelperMethods.convertPixelToPoint(minimumWordWidth) + leftIndent
        };
    }
    measureParagraph() {
        let width = 0;
        let element = this.childWidgets[0].children[0];
        do {
            if (element instanceof TextElementBox && element.text !== '') {
                if (element.isWidthUpdated && element.text[element.text.length - 1] !== ' ') {
                    width += element.trimEndWidth;
                }
                else {
                    width += this.bodyWidget.page.documentHelper.textHelper.getWidth(element.text, element.characterFormat, element.scriptType);
                }
            }
            else if (element instanceof FieldElementBox && element.fieldType === 0) {
                let fieldBegin = element;
                if (fieldBegin.fieldEnd != null) {
                    element = isNullOrUndefined(fieldBegin.fieldSeparator) ? fieldBegin.fieldEnd : fieldBegin.fieldSeparator;
                }
            }
            else if (element instanceof ImageElementBox) {
                width += element.width;
            }
            if (isNullOrUndefined(element) || isNullOrUndefined(element.nextNode)) {
                break;
            }
            element = element.nextNode;
        } while (true);
        // Considered the left and right indent.
        if (this.leftIndent > 0) {
            width += this.leftIndent;
        }
        if (this.rightIndent > 0) {
            width += this.rightIndent;
        }
        return width;
    }
    isArabicChar(character) {
        //Arabic characters https://en.wikipedia.org/wiki/Arabic_script#Unicode
        return ((character >= String.fromCharCode(1536) && character <= String.fromCharCode(1791)) //Script-Arab, Arabic characters https://en.wikipedia.org/wiki/Arabic_(Unicode_block)
            || (character >= String.fromCharCode(1872) && character <= String.fromCharCode(1919)) //Script-Arab, Arabic Supplement characters https://en.wikipedia.org/wiki/Arabic_Supplement
            || (character >= String.fromCharCode(2208) && character <= String.fromCharCode(2303)) //Script-Arab, Arabic Extended-A characters https://en.wikipedia.org/wiki/Arabic_Extended-A
            || (character >= String.fromCharCode(64336) && character <= String.fromCharCode(65023)) //Script-Arab, Arabic Presentation Forms-A characters https://en.wikipedia.org/wiki/Arabic_Presentation_Forms-A
            || (character >= String.fromCharCode(65136) && character <= String.fromCharCode(65279))); //Script-Arab, Arabic Presentation Forms-B characters https://en.wikipedia.org/wiki/Arabic_Presentation_Forms-B                
    }
    isHebrewChar(character) {
        return ((character >= String.fromCharCode(1424) && character <= String.fromCharCode(1535)) //Script-Hebr, Hebrew characters https://en.wikipedia.org/wiki/Hebrew_alphabet#Unicode_and_HTML (https://en.wikipedia.org/wiki/Hebrew_(Unicode_block))
            || (character >= String.fromCharCode(64285) && character <= String.fromCharCode(64335))); //Script-Hebr, Hebrew Alphabetic Presentation Forms characters https://en.wikipedia.org/wiki/Alphabetic_Presentation_Forms                                                                    
    }
    isHindiChar(character) {
        //Hindi characters are comes under the Devanagari scripts.
        //The Unicode Standard defines three blocks for Devanagari. https://en.wikipedia.org/wiki/Devanagari#Unicode              
        return ((character >= String.fromCharCode(2304) && character <= String.fromCharCode(2431)) //Devanagari (U+0900–U+097F), https://en.wikipedia.org/wiki/Devanagari_(Unicode_block)
            || (character >= String.fromCharCode(43232) && character <= String.fromCharCode(43263)) //Devanagari Extended (U+A8E0–U+A8FF), https://en.wikipedia.org/wiki/Devanagari_Extended
            || (character >= String.fromCharCode(7376) && character <= String.fromCharCode(7423))); //Vedic Extensions (U+1CD0–U+1CFF), https://en.wikipedia.org/wiki/Vedic_Extensions
    }
    isKoreanChar(character) {
        return (
        //Korean characters https://en.wikipedia.org/wiki/Korean_language_and_computers#Hangul_in_Unicode
        (character >= String.fromCharCode(44032) && character <= String.fromCharCode(55203)) //Hangul Syllables characters https://en.wikipedia.org/wiki/Hangul_Syllables
            || (character >= String.fromCharCode(4352) && character <= String.fromCharCode(4607)) //Hangul Jamo characters https://en.wikipedia.org/wiki/Hangul_Jamo_(Unicode_block)
            || (character >= String.fromCharCode(12592) && character <= String.fromCharCode(12687)) //Hangul Compatibility Jamo characters https://en.wikipedia.org/wiki/Hangul_Compatibility_Jamo
            || (character >= String.fromCharCode(43360) && character <= String.fromCharCode(43391)) //Hangul Jamo Extended-A characters https://en.wikipedia.org/wiki/Hangul_Jamo_Extended-A
            || (character >= String.fromCharCode(55216) && character <= String.fromCharCode(55295)) //Hangul Jamo Extended-B characters https://en.wikipedia.org/wiki/Hangul_Jamo_Extended-B
            || (character >= String.fromCharCode(44032) && character <= String.fromCharCode(55215)) //Hangul_Syllables characters https://en.wikipedia.org/wiki/Hangul_Syllables
        );
    }
    isJapanese(character) {
        return (
        //Japanese and Ainu languages
        (character >= String.fromCharCode(12448) && character <= String.fromCharCode(12543)) //Katakana characters https://en.wikipedia.org/wiki/Katakana_(Unicode_block)
            || (character >= String.fromCharCode(12352) && character <= String.fromCharCode(12447)) //Hiragana characters https://en.wikipedia.org/wiki/Hiragana_(Unicode_block)
        );
    }
    isThaiCharacter(character) {
        // Thai characters https://en.wikipedia.org/wiki/Thai_script#Unicode_ranges 
        return (character >= String.fromCharCode(3584) && character <= String.fromCharCode(3711));
    }
    isChineseChar(character) {
        //To-Do: Should handle a Chinese characters as two separate scripts such as Chinese Simplified and Chinese Traditional.
        return (
        //Chinese characters https://en.wikipedia.org/wiki/Han_unification#Unicode_ranges
        //Chinese characters are comes under the Han script.
        (character >= String.fromCharCode(19968) && character <= String.fromCharCode(40959)) //CJK Unified Ideographs(4E00–9FFF), https://en.wikipedia.org/wiki/CJK_Unified_Ideographs_(Unicode_block)
            || (character >= String.fromCharCode(13312) && character <= String.fromCharCode(19903)) //CJK Unified Ideographs Extension A(3400–4DBF), https://en.wikipedia.org/wiki/CJK_Unified_Ideographs_Extension_A
            //|| (character >= '\u20000' && character <= '\u2A6DF') //CJK Unified Ideographs Extension B(20000–2A6DF), https://en.wikipedia.org/wiki/CJK_Unified_Ideographs_Extension_B
            // As we don't hold a 32 bit character into char data type, and also it get splitted into two char value, when it is 32 bit.
            // So, below we have added a maximum and least char range of the above 32 bit character.
            // We can split a 32 bit character into two 16 bit characters by "Char.ConvertFromUtf32(0x20000).ToCharArray()" built-in method.
            || (character >= String.fromCharCode(55360) && character <= String.fromCharCode(55401)) // Represents a start and end range of first character code, when we split a character between (character >= '\u20000' && character <= '\u2A6DF').
            || (character >= String.fromCharCode(56320) && character <= String.fromCharCode(57055)) // Represents a start and end range of second character code, when we split a character between (character >= '\u20000' && character <= '\u2A6DF').
            || (character >= String.fromCharCode(43360) && character <= String.fromCharCode(43391)) //CJK Compatibility Ideographs(F900–FAFF), https://en.wikipedia.org/wiki/CJK_Compatibility_Ideographs
            || (character >= String.fromCharCode(65280) && character <= String.fromCharCode(65519)) //Halfwidth and Fullwidth Forms, https://en.wikipedia.org/wiki/Halfwidth_and_Fullwidth_Forms_(Unicode_block).
            || (character >= String.fromCharCode(12288) && character <= String.fromCharCode(12351)) //CJK Symbols and Punctuation, https://en.wikipedia.org/wiki/CJK_Symbols_and_Punctuation
            || (character >= String.fromCharCode(0xF900) && character <= String.fromCharCode(0xFAFF)));
    }
    isSpecialCharacters(character) {
        return ((character >= String.fromCharCode(8192) && character <= String.fromCharCode(10175)));
    }
    getFontScriptType(inputCharacter, hasHintType) {
        // Return FontScriptType as Hindi, if input character is in-between Hindi character ranges.
        if (this.isHindiChar(inputCharacter))
            return FontScriptType.Hindi;
        // Return FontScriptType as Korean, if input character is in-between Korean character ranges.
        else if (this.isKoreanChar(inputCharacter))
            return FontScriptType.Korean;
        // Return FontScriptType as Japanese, if input character is in-between Japanese character ranges.
        else if (this.isJapanese(inputCharacter))
            return FontScriptType.Japanese;
        // Return FontScriptType as Chinese, if input character is in-between Chinese character ranges.
        else if (this.isChineseChar(inputCharacter))
            return FontScriptType.Chinese;
        // Return FontScriptType as Arabic, if input character is in-between Arabic character ranges.
        else if (this.isArabicChar(inputCharacter))
            return FontScriptType.Arabic;
        // Return FontScriptType as Hebrew, if input character is in-between Hebrew character ranges.
        else if (this.isHebrewChar(inputCharacter))
            return FontScriptType.Hebrew;
        // Return FontScriptType as Thai, if input character is in-between Thai character ranges.
        else if (this.isThaiCharacter(inputCharacter))
            return FontScriptType.Thai;
        // Return FontScriptType as SpecialCharacter, if input character is in-between SpecialCharacter character ranges.
        else if (this.isSpecialCharacters(inputCharacter) && hasHintType)
            return FontScriptType.SpecialCharacter;
        // Return FontScriptType as English, for remaining character ranges.
        else
            return FontScriptType.English;
    }
    splitTextByFontScriptType(inputText, fontScriptTypes, hasHintType) {
        let splittedText = [];
        //Retrun the empty array, if input text is Null or Empty.
        if (isNullOrUndefined(inputText)
            || (!isNullOrUndefined(inputText) && inputText === '')) {
            return splittedText;
        }
        let text = '';
        let prevCharacterType = FontScriptType.English;
        let currCharacterType = FontScriptType.English;
        // Regex for finding a string is unicode or not.
        const surrogateRegex = /[\uD800-\uDFFF]/;
        for (let i = 0; i < inputText.length; i++) {
            // Gets a FontScriptType for the current character.
            // As per the Microsoft application behavior, we need to consider a space (\u0020) as previous character type.
            // So, that we can avoid a text splitting based on space character.
            if (inputText[i] != String.fromCharCode(32) && !surrogateRegex.test(inputText[i])) {
                // && !(char.IsHighSurrogate(inputText.charAt(i)) || char.IsLowSurrogate(inputText.charAt(i)))) { //Skip the setting of script type for surrogate character.
                currCharacterType = this.getFontScriptType(inputText[i], hasHintType);
            }
            //Add a current text into splitted text collection, when previous character type is not equival to current type.
            if (text != '' && currCharacterType !== prevCharacterType) {
                //Add splitted text and it's FontScriptType into the collection.
                splittedText.push(text);
                fontScriptTypes.push(prevCharacterType);
                //Reset the text value.
                text = '';
            }
            //Add a current character.
            text += inputText[i];
            //Assign a current character type as previous type.
            prevCharacterType = currCharacterType;
        }
        //Add a final text.
        if (text != '') {
            //Add splitted text and it's FontScriptType into the collection.
            splittedText.push(text);
            fontScriptTypes.push(currCharacterType);
            //Reset the text value.
            text = '';
        }
        return splittedText;
    }
    splitTextRangeByScriptType(lineIndex) {
        let isField = false;
        let iIncrementer = 1;
        // Iterates the items for textrange in the paragraph.
        if (this.childWidgets.length > 0) {
            let lineWidget = this.childWidgets[lineIndex];
            for (let i = lineIndex + 1; i < this.childWidgets.length; i++) {
                let nextLineWidget = this.childWidgets[i];
                for (let m = 0; m < nextLineWidget.children.length; m++) {
                    let element = nextLineWidget.children[m];
                    lineWidget.children.push(element);
                    element.line = lineWidget;
                }
                this.childWidgets.splice(i, 1);
                i--;
            }
            for (let i = 0; i < lineWidget.children.length; i += iIncrementer) {
                let elementBox = lineWidget.children[i];
                iIncrementer = 1;
                // InlineContentControl inlineContentControl = paraItems[i] as InlineContentControl;
                // if (inlineContentControl != null)
                //     this.splitTextRangeByScriptType(inlineContentControl.ParagraphItems, splitter);
                ////Gets the span to split.
                let textElement = undefined;
                if (elementBox instanceof TextElementBox) {
                    textElement = elementBox;
                }
                if (elementBox instanceof FieldElementBox && elementBox.fieldType == 0) {
                    isField = true;
                }
                else if (elementBox instanceof FieldElementBox && elementBox.fieldType === 2) {
                    isField = false;
                }
                if (textElement != undefined && !isField) {
                    // ToDo: Need to handle CS font hint type
                    let hasHintType = textElement.characterFormat.fontHintType === 'EastAsia' && textElement.characterFormat.hasValue('fontFamilyFarEast');
                    let fontScriptTypes = [];
                    // Split a current text part text based on FontScriptType.
                    let splitedTextCollection = this.splitTextByFontScriptType(textElement.text, fontScriptTypes, hasHintType);
                    if (splitedTextCollection.length > 1) {
                        for (let j = 0; j < splitedTextCollection.length; j++) {
                            let text = splitedTextCollection[j];
                            if (j > 0) {
                                //Split text range.
                                //Clone the source text range.
                                let clonedtextElement = textElement.clone();
                                clonedtextElement.text = text;
                                //Sets a script type of WTextRange.
                                clonedtextElement.scriptType = fontScriptTypes[j];
                                //Insert the splitted text ranges in order.
                                lineWidget.children.splice(i + j, 0, clonedtextElement);
                                clonedtextElement.line = lineWidget;
                                iIncrementer++;
                                if (textElement.revisionLength > 0) {
                                    this.updateTextElementInRevisionRange(textElement, clonedtextElement);
                                }
                            }
                            else {
                                //Replace the source text range with splitted text.
                                textElement.text = text;
                                //Sets a script type of WTextRange.
                                textElement.scriptType = fontScriptTypes[j];
                                textElement.isWidthUpdated = false;
                            }
                        }
                    }
                    else if (splitedTextCollection.length > 0) {
                        //Sets a script type of WTextRange.
                        textElement.scriptType = fontScriptTypes[0];
                    }
                    // Clear the FontScriptType collection.
                    fontScriptTypes.length = 0;
                }
            }
        }
    }
    /**
     * @private
     */
    splitLtrAndRtlText(lineIndex) {
        let isPrevLTRText = { value: null };
        let iIncrementer = 1;
        let hasRTLCharacter = { value: null };
        let characterRangeTypes = [];
        let isField = false;
        let documentHelper = this.bodyWidget.page.documentHelper;
        let textHelper = documentHelper.textHelper;
        if (this.childWidgets.length > 0) {
            let lineWidget = this.childWidgets[lineIndex];
            for (let i = 0; i < lineWidget.children.length; i += iIncrementer) {
                let elementBox = lineWidget.children[i];
                iIncrementer = 1;
                ////Gets the span to split.
                let textElement = undefined;
                if (elementBox instanceof TextElementBox) {
                    textElement = elementBox;
                }
                if (elementBox instanceof FieldElementBox && elementBox.fieldType == 0) {
                    isField = true;
                }
                else if (elementBox instanceof FieldElementBox && elementBox.fieldType === 2) {
                    isField = false;
                }
                if (textElement != undefined && !isField) {
                    let text = textElement.text;
                    let isTextBidi = textElement.characterFormat.bidi;
                    let isRTLLang = false;
                    let charTypeIndex = characterRangeTypes.length;
                    if (isTextBidi) {
                        isRTLLang = textHelper.isRightToLeftLanguage(elementBox.characterFormat.localeIdBidi);
                    }
                    ////Split the text as consicutive LTR and RTL
                    let splitedTextCollection = textHelper.splitTextByConsecutiveLtrAndRtl(text, isTextBidi, isRTLLang, characterRangeTypes, isPrevLTRText, hasRTLCharacter);
                    if (splitedTextCollection.length > 1) {
                        for (let j = 0; j < splitedTextCollection.length; j++) {
                            text = splitedTextCollection[j];
                            if (j > 0) {
                                ////Clone the source span.
                                let clonedTextElement = textElement.clone();
                                clonedTextElement.text = text;
                                clonedTextElement.characterRange = characterRangeTypes[j + charTypeIndex];
                                ////Inert the splitted span in order.
                                lineWidget.children.splice(i + j, 0, clonedTextElement);
                                clonedTextElement.line = lineWidget;
                                iIncrementer++;
                                if (textElement.revisionLength > 0) {
                                    this.updateTextElementInRevisionRange(textElement, clonedTextElement);
                                }
                            }
                            else {
                                ////Replace the source span with splitted text.
                                textElement.text = text;
                                textElement.characterRange = characterRangeTypes[charTypeIndex];
                            }
                        }
                    }
                    else if (splitedTextCollection.length > 0) {
                        textElement.characterRange = characterRangeTypes[charTypeIndex];
                    }
                }
            }
            characterRangeTypes.length = 0;
        }
    }
    updateTextElementInRevisionRange(inline, splittedElementBox) {
        for (let i = 0; i < inline.revisionLength; i++) {
            let revision = inline.getRevision(i);
            splittedElementBox.addRevision(revision);
            splittedElementBox.removedIds = [];
        }
    }
    /**
     * Combine the spans by consecutive LTR and RTL texts.
     * @private
     */
    combineconsecutiveRTL(lineIndex) {
        let isField = false;
        let documentHelper = this.bodyWidget.page.documentHelper;
        let textHelper = documentHelper.textHelper;
        for (let j = lineIndex; j < this.childWidgets.length; j++) {
            let lineWidget = this.childWidgets[j];
            for (let i = 0; i <= lineWidget.children.length - 2; i++) {
                let elementBox = lineWidget.children[i];
                if (elementBox instanceof FieldElementBox && elementBox.fieldType === 0) {
                    isField = true;
                }
                else if (elementBox instanceof FieldElementBox && elementBox.fieldType === 2) {
                    isField = false;
                }
                if (!isField && elementBox instanceof TextElementBox && lineWidget.children[i + 1] instanceof TextElementBox) {
                    let currentTxtRange = elementBox;
                    let nextTxtRange = lineWidget.children[i + 1];
                    // Bug 866413: Here skipped the Hewbrew script type rtl text combining, because facing element left margin issue.
                    if (((currentTxtRange.characterFormat.complexScript && currentTxtRange.scriptType == nextTxtRange.scriptType) || (currentTxtRange.characterFormat.bidi && currentTxtRange.scriptType !== FontScriptType.Hebrew
                        && currentTxtRange.characterRange == CharacterRangeType.RightToLeft && nextTxtRange.characterRange == CharacterRangeType.RightToLeft)) &&
                        currentTxtRange.text.length > 0 && nextTxtRange.text.length > 0 &&
                        !textHelper.isWordSplitChar(currentTxtRange.text[currentTxtRange.text.length - 1]) && !textHelper.isWordSplitChar(nextTxtRange.text[0])
                        && currentTxtRange.characterFormat.isEqualFormat(nextTxtRange.characterFormat) && this.compareRevisions(currentTxtRange.getAllRevision(), nextTxtRange.getAllRevision())) {
                        currentTxtRange.text = currentTxtRange.text + nextTxtRange.text;
                        lineWidget.children.splice(i + 1, 1);
                        i--;
                        currentTxtRange.isWidthUpdated = false;
                    }
                    else if (currentTxtRange.characterRange == CharacterRangeType.RightToLeft && nextTxtRange.characterRange == CharacterRangeType.RightToLeft &&
                        currentTxtRange.text.length > 0 && nextTxtRange.text.length > 0 &&
                        textHelper.isWordSplitChar(currentTxtRange.text[currentTxtRange.text.length - 1]) && textHelper.isWordSplitChar(nextTxtRange.text[0])
                        && currentTxtRange.characterFormat.isEqualFormat(nextTxtRange.characterFormat) && this.compareRevisions(currentTxtRange.getAllRevision(), nextTxtRange.getAllRevision())) {
                        currentTxtRange.text = currentTxtRange.text + nextTxtRange.text;
                        lineWidget.children.splice(i + 1, 1);
                        i--;
                        currentTxtRange.isWidthUpdated = false;
                    }
                    else if (documentHelper.compatibilityMode !== 'Word2013' && currentTxtRange.characterFormat.bidi &&
                        !textHelper.isRightToLeftLanguage(currentTxtRange.characterFormat.localeIdBidi) && currentTxtRange.characterRange === CharacterRangeType.Number) {
                        this.combineConsecutiveRTLDateFormatText(lineWidget, i);
                    }
                }
            }
        }
    }
    combineConsecutiveRTLDateFormatText(lineWidget, startIndex) {
        const currentText = lineWidget.children[startIndex];
        let nextElement = lineWidget.children[startIndex + 1];
        if (nextElement && currentText.characterFormat.isEqualFormat(nextElement.characterFormat) && (nextElement.text === '/' || nextElement.text === '.')) {
            let combinedText = currentText.text + nextElement.text;
            let removeCount = 1;
            let k = startIndex + 2;
            let isSeperator = true;
            while (k < lineWidget.children.length) {
                nextElement = lineWidget.children[k];
                if (currentText.characterFormat.isEqualFormat(nextElement.characterFormat) && (nextElement.characterRange === CharacterRangeType.Number
                    || ((nextElement.text === '/' || nextElement.text === '.') && !isSeperator))) {
                    isSeperator = nextElement.characterRange === CharacterRangeType.WordSplit ? true : false;
                    const thirdElement = lineWidget.children[k + 1];
                    const canCombine = !isSeperator || (thirdElement && currentText.characterFormat.isEqualFormat(thirdElement.characterFormat) && (thirdElement.characterRange === CharacterRangeType.Number));
                    if (canCombine) {
                        combinedText += nextElement.text;
                        removeCount++;
                        k++;
                    }
                    else {
                        break;
                    }
                }
                else {
                    break;
                }
            }
            if (removeCount > 1) {
                currentText.text = combinedText;
                lineWidget.children.splice(startIndex + 1, removeCount);
                currentText.isWidthUpdated = false;
            }
        }
    }
    compareRevisions(revisionA, revisionB) {
        if (revisionA.length !== revisionB.length) {
            return false;
        }
        for (let i = 0; i < revisionA.length; i++) {
            if (revisionA[i] !== revisionB[i]) {
                return false;
            }
        }
        return true;
    }
    clone() {
        let paragraph = new ParagraphWidget();
        paragraph.paragraphFormat.copyFormat(this.paragraphFormat);
        paragraph.characterFormat.copyFormat(this.characterFormat);
        for (let i = 0; i < this.childWidgets.length; i++) {
            let line = this.childWidgets[i];
            let cloneLine = line.clone();
            paragraph.childWidgets.push(cloneLine);
            for (let j = 0; j < cloneLine.children.length; j++) {
                let element = cloneLine.children[j];
                if ((element instanceof ImageElementBox && element.textWrappingStyle !== 'Inline') || element instanceof ShapeElementBox || element instanceof GroupShapeElementBox) {
                    paragraph.floatingElements.push(element);
                }
            }
            cloneLine.paragraph = paragraph;
        }
        paragraph.x = this.x;
        paragraph.y = this.y;
        paragraph.height = this.height;
        paragraph.width = this.width;
        paragraph['absoluteXPosition'] = isNullOrUndefined(this['absoluteXPosition']) ? undefined : { 'width': this['absoluteXPosition']['width'], 'x': this['absoluteXPosition']['x'] };
        if (this.contentControlProperties) {
            paragraph.contentControlProperties = this.contentControlProperties;
        }
        return paragraph;
    }
    destroyInternal(viewer) {
        let height = this.height;
        if (!isNullOrUndefined(this.childWidgets)) {
            for (let i = 0; i < this.childWidgets.length; i++) {
                let widget = this.childWidgets[i];
                widget.destroy();
                if (this.childWidgets.length === 1 && isNullOrUndefined(this.childWidgets[0].children)) {
                    this.childWidgets = undefined;
                }
                if (isNullOrUndefined(this.childWidgets)) {
                    break;
                }
                i--;
            }
            this.childWidgets = undefined;
        }
        if (!isNullOrUndefined(this.containerWidget) && !isNullOrUndefined(this.containerWidget.childWidgets)
            && this.containerWidget.childWidgets.indexOf(this) !== -1) {
            this.containerWidget.childWidgets.splice(this.containerWidget.childWidgets.indexOf(this), 1);
            this.containerWidget.height -= height;
            // if ((isNullOrUndefined(this.containerWidget.childWidgets) || this.containerWidget.childWidgets.length === 0)
            //     && this.containerWidget instanceof BodyWidget) {
            //     // (this.containerWidget as BodyWidget).destroyInternal(viewer);
            // }
            this.containerWidget = undefined;
        }
        if (this.hasOwnProperty('absoluteXPosition')) {
            delete this['absoluteXPosition'];
        }
        this.destroy();
    }
    destroy() {
        // if (this.paragraphFormat) {
        //     this.paragraphFormat.destroy();
        // }
        this.paragraphFormat = undefined;
        // if (this.characterFormat) {
        //     this.characterFormat.destroy();
        // }
        this.characterFormat = undefined;
        super.destroy();
    }
    /**
     * Disposes the internal objects which are maintained.
     * @private
     */
    componentDestroy() {
        if (this.paragraphFormat) {
            this.paragraphFormat.destroy();
        }
        this.paragraphFormat = undefined;
        if (this.characterFormat) {
            this.characterFormat.destroy();
        }
        this.characterFormat = undefined;
        super.componentDestroy();
    }
}
/**
 * @private
 */
export class TablePosition {
    /**
     * @private
     */
    clone() {
        let positioning = new TablePosition();
        positioning.allowOverlap = this.allowOverlap;
        positioning.distanceTop = this.distanceTop;
        positioning.distanceRight = this.distanceRight;
        positioning.distanceLeft = this.distanceLeft;
        positioning.distanceBottom = this.distanceBottom;
        positioning.verticalAlignment = this.verticalAlignment;
        positioning.verticalOrigin = this.verticalOrigin;
        positioning.verticalPosition = this.verticalPosition;
        positioning.horizontalAlignment = this.horizontalAlignment;
        positioning.horizontalOrigin = this.horizontalOrigin;
        positioning.horizontalPosition = this.horizontalPosition;
        return positioning;
    }
}
/**
 * @private
 */
export class TableWidget extends BlockWidget {
    constructor() {
        super();
        this.flags = 0;
        /**
         * @private
         */
        this.leftMargin = 0;
        /**
         * @private
         */
        this.topMargin = 0;
        /**
         * @private
         */
        this.rightMargin = 0;
        /**
         * @private
         */
        this.bottomMargin = 0;
        /**
         * @private
         */
        this.isDefaultFormatUpdated = false;
        /**
         * @private
         */
        this.isContainInsideTable = false;
        /**
         * @private
         */
        this.isHeaderNotRepeatForAllPages = false;
        /**
         * @private
         */
        this.footnoteElement = [];
        // /**
        //  * @private
        //  */
        // get length(): number {
        //     if (!isNullOrUndefined(this.nextSplitWidget)) {
        //         return 1;
        //     } else {
        //         if (isNullOrUndefined(this.previousSplitWidget)) {
        //             return 1;
        //         }
        //         return 0;
        //     }
        // }
        /**
         * @private
         */
        this.isRender = true;
        this.margin = new Margin(this.leftMargin, this.topMargin, this.rightMargin, this.bottomMargin);
        this.leftBorderWidth = 0;
        this.rightBorderWidth = 0;
        this.topBorderWidth = 0;
        this.bottomBorderWidth = 0;
        this.tableFormat = new WTableFormat(this);
        this.tableHolder = new WTableHolder();
        this.spannedRowCollection = new Dictionary();
    }
    /**
     * @private
     */
    get isGridUpdated() {
        return ((this.flags & 0x4) >> 2) !== 0;
    }
    /**
     * @private
     */
    set isGridUpdated(value) {
        this.flags = ((this.flags & 0xFB) | ((value ? 1 : 0) << 2));
    }
    /**
     * @private
     */
    get continueHeader() {
        return ((this.flags & 0x2) >> 1) !== 0;
    }
    /**
     * @private
     */
    set continueHeader(value) {
        this.flags = ((this.flags & 0xFD) | ((value ? 1 : 0) << 1));
    }
    /**
     * @private
     */
    get header() {
        return (this.flags & 0x1) !== 0;
    }
    /**
     * @private
     */
    set header(value) {
        this.flags = ((this.flags & 0xFE) | (value ? 1 : 0));
    }
    get isBidiTable() {
        return ((this.flags & 0x10) >> 4) !== 0;
    }
    set isBidiTable(value) {
        this.flags = ((this.flags & 0xEF) | ((value ? 1 : 0) << 4));
    }
    /**
     * @private
     */
    equals(widget) {
        return widget instanceof TableWidget && widget.tableFormat === this.tableFormat;
    }
    /**
     * @private
     */
    combineRows(viewer) {
        for (let i = 0; i < this.childWidgets.length; i++) {
            let row = this.childWidgets[i];
            if (!isNullOrUndefined(row.firstChild) && row.firstChild.index !== 0 && row.getSplitWidgets().length === 1) {
                for (let j = 0; j < row.childWidgets.length; j++) {
                    row.childWidgets[j].index--;
                }
            }
            if (row.childWidgets.length === 0) {
                row.destroy();
                i--;
            }
            else {
                row.combineCells(viewer);
            }
        }
    }
    /**
     * @private
     */
    contains(tableCell) {
        if (this.equals(tableCell.ownerTable)) {
            return true;
        }
        while (tableCell.ownerTable.isInsideTable) {
            if (this.equals(tableCell.ownerTable)) {
                return true;
            }
            tableCell = tableCell.ownerTable.associatedCell;
        }
        return this.equals(tableCell.ownerTable);
    }
    /**
     * @private
     */
    getOwnerWidth(isBasedOnViewer) {
        let width = this.getContainerWidth();
        // As per the Microsoft Word behavior, left and right indent should be considered for the auto preferred width type table
        // and not to be considered for the point and percent preferred width type table.
        if (this.tableFormat.preferredWidthType === 'Auto') {
            width = width - this.leftIndent - this.rightIndent;
        }
        return width >= 0 ? width : 0;
    }
    /**
     * @private
     */
    getTableWidth() {
        let width = 0;
        for (let i = 0; i < this.childWidgets.length; i++) {
            let rowWidth = 0;
            let row = this.childWidgets[i];
            for (let j = 0; j < row.childWidgets.length; j++) {
                rowWidth += row.childWidgets[j].cellFormat.cellWidth;
            }
            if (width < rowWidth) {
                width = rowWidth;
            }
        }
        return width;
    }
    /**
     * @private
     */
    getTableCellWidth() {
        let width = 0;
        for (let k = 0; k < this.childWidgets.length; k++) {
            let rowWidth = 0;
            let rowWidget = this.childWidgets[k];
            for (let m = 0; m < rowWidget.childWidgets.length; m++) {
                let cellWidget = rowWidget.childWidgets[m];
                let cellWidth = cellWidget.width;
                if (cellWidth === 0) {
                    cellWidth = cellWidget.cellFormat.cellWidth;
                    if (this.tableFormat.tableAlignment === 'Center' && !this.tableFormat.allowAutoFit && this.tableFormat.preferredWidthType !== 'Percent' &&
                        this.tableFormat.preferredWidth !== 0 && this.tableFormat.preferredWidth === cellWidth) {
                        width = HelperMethods.convertPointToPixel(this.tableFormat.preferredWidth);
                    }
                    if (cellWidth > cellWidget.cellFormat.preferredWidth &&
                        cellWidget.cellFormat.preferredWidth !== 0 && cellWidget.cellFormat.preferredWidthType !== 'Percent') {
                        cellWidth = cellWidget.cellFormat.preferredWidth;
                    }
                    cellWidth = HelperMethods.convertPointToPixel(cellWidth - (cellWidget.margin.left + cellWidget.margin.right));
                }
                rowWidth += (cellWidth + cellWidget.margin.left + cellWidget.margin.right);
            }
            if (width < rowWidth) {
                width = rowWidth;
            }
        }
        return width;
    }
    /**
     * @private
     */
    getTableClientWidth(clientWidth) {
        let tableWidth = clientWidth;
        if (this.tableFormat.preferredWidthType === 'Point'
            && this.tableFormat.preferredWidth > 0) {
            tableWidth = this.tableFormat.preferredWidth;
        }
        else {
            if (this.tableFormat.preferredWidthType === 'Percent'
                && this.tableFormat.preferredWidth > 0) {
                tableWidth = tableWidth * this.tableFormat.preferredWidth / 100;
            }
        }
        return tableWidth;
    }
    /**
     * @private
     */
    getCellWidth(preferredWidth, preferredWidthType, containerWidth, cell) {
        let cellWidth = preferredWidth;
        if (preferredWidthType === 'Percent') {
            cellWidth = (preferredWidth * containerWidth) / 100;
        }
        else if (preferredWidthType === 'Point') {
            cellWidth = preferredWidth;
        }
        // For grid before and grid after with auto width, no need to calculate minimum preferred width.
        else if (!isNullOrUndefined(cell)) {
            cellWidth = this.getMinimumPreferredWidth(cell);
        }
        return cellWidth;
    }
    getMinimumPreferredWidth(cell) {
        let defaultWidth = 0;
        ////For fixed table, cell width (grid column width) should be considered as default width, When the preferred cell width is zero.
        if (cell.cellFormat.preferredWidth === 0 && cell.cellFormat.cellWidth !== 0 && !(cell.ownerTable
            && cell.ownerTable.bodyWidget && cell.ownerTable.bodyWidget.page &&
            cell.ownerTable.bodyWidget.page.documentHelper && cell.ownerTable.bodyWidget.page.documentHelper.layout
            && this.bodyWidget.page.documentHelper.layout.isAllColumnHasAutoWidthType)) {
            defaultWidth = cell.cellFormat.cellWidth;
        }
        else {
            defaultWidth = cell.getMinimumPreferredWidth();
        }
        return defaultWidth;
    }
    /**
     * @private
     */
    fitCellsToClientArea(clientWidth) {
        let tableWidth = this.getTableWidth();
        let factor = clientWidth / tableWidth;
        for (let i = 0; i < this.childWidgets.length; i++) {
            let row = this.childWidgets[i];
            row.rowFormat.gridAfterWidth *= factor;
            row.rowFormat.gridBeforeWidth *= factor;
            for (let j = 0; j < row.childWidgets.length; j++) {
                row.childWidgets[j].cellFormat.cellWidth *= factor;
                row.childWidgets[j].cellFormat.preferredWidth *= factor;
            }
        }
    }
    /**
     * @private
     */
    getTableCellWidget(point) {
        let tableCellWidget = undefined;
        for (let i = 0; i < this.childWidgets.length; i++) {
            if (this.childWidgets[i].y <= point.y
                && (this.childWidgets[i].y + this.childWidgets[i].height +
                    this.childWidgets[i].topBorderWidth) >= point.y - this.bodyWidget.page.documentHelper.resizerBoundaryWidth) {
                tableCellWidget = this.childWidgets[i].getTableCellWidget(point);
                break;
            }
        }
        return tableCellWidget;
    }
    /**
     * @private
     */
    /* eslint-disable  */
    calculateGrid(isInsertRow, isOnlyRow) {
        let tempGrid = [];
        let tempSpanDecimal = [];
        let spannedCells = [];
        let containerWidth = this.getOwnerWidth(true);
        let tableWidth = this.getTableClientWidth(containerWidth);
        this.tableCellInfo = new Dictionary();
        for (let i = 0; i < this.childWidgets.length; i++) {
            let row = this.childWidgets[i];
            let rowCellInfo = new Dictionary();
            let rowFormat = row.rowFormat;
            let cellWidth = 0;
            let columnSpan = row.rowFormat.gridBefore;
            let currOffset = 0;
            if (tempGrid.indexOf(currOffset) < 0) {
                tempGrid.push(currOffset);
                tempSpanDecimal.push(currOffset);
            }
            //Converts the row grid before width from point to twips point by 15 factor.
            cellWidth = this.getCellWidth(rowFormat.gridBeforeWidth, rowFormat.gridBeforeWidthType, tableWidth, null);
            currOffset += cellWidth;
            let startOffset = parseFloat(currOffset.toFixed(2));
            if (tempGrid.indexOf(startOffset) < 0) {
                tempGrid.push(startOffset);
                tempSpanDecimal.push(currOffset);
            }
            for (let j = 0; j < row.childWidgets.length; j++) {
                let cell = row.childWidgets[j];
                for (let k = 0; k < spannedCells.length; k++) {
                    if (spannedCells[k].columnIndex < columnSpan) {
                        continue;
                    }
                    let rowSpan = spannedCells[k].cellFormat.rowSpan;
                    let removeSpannedCell = true;
                    if (spannedCells[k].columnIndex > columnSpan) {
                        {
                            removeSpannedCell = false;
                            // If the cell is the last cell in the row and the row has grid after value..
                            if (j === row.childWidgets.length - 1 && row.rowFormat.gridAfter > 0) {
                                this.updateValidPreferredWidth(spannedCells[k]);
                                cellWidth = this.getCellWidth(spannedCells[k].cellFormat.preferredWidth, spannedCells[k].cellFormat.preferredWidthType, tableWidth, null);
                                currOffset += cellWidth;
                            }
                        }
                    }
                    else {
                        // If the table gird alone calculted then column index of the rowspanned cell will be directly taken. 
                        // If the gird calculation is done from the UI level opearations such as resizing then table holder 
                        // will have the columns at that time we can get the column index from the table holder.
                        //Converts the cell width from point to twips point by 15 factor.
                        this.updateValidPreferredWidth(spannedCells[k]);
                        cellWidth = this.getCellWidth(spannedCells[k].cellFormat.preferredWidth, spannedCells[k].cellFormat.preferredWidthType, tableWidth, null);
                        currOffset += cellWidth;
                        columnSpan = spannedCells[k].columnIndex + spannedCells[k].cellFormat.columnSpan;
                    }
                    if (!removeSpannedCell && j === row.childWidgets.length - 1) {
                        removeSpannedCell = true;
                    }
                    if (removeSpannedCell && i - spannedCells[k].ownerRow.rowIndex === rowSpan - 1) {
                        spannedCells.splice(k, 1);
                        k--;
                    }
                }
                // At the start of each row, we will process the row spanned cells to get the start column index.
                // To calculate grid properly, we need the items in the spanned cells collection in the order of their column index
                if (cell.cellFormat.rowSpan > 1) {
                    if (spannedCells.length === 0 || spannedCells[spannedCells.length - 1].columnIndex <= columnSpan) {
                        spannedCells.push(cell);
                    }
                    else {
                        for (let m = spannedCells.length; m > 0; m--) {
                            if (spannedCells[m - 1].columnIndex > columnSpan) {
                                spannedCells.splice(m - 1, 0, cell);
                            }
                        }
                    }
                }
                // Add start offset of each cell based on its index
                if (!rowCellInfo.containsKey(cell.cellIndex)) {
                    rowCellInfo.add(cell.cellIndex, parseFloat((currOffset - startOffset).toFixed(2)));
                }
                columnSpan += cell.cellFormat.columnSpan;
                this.updateValidPreferredWidth(cell);
                //Converts the cell width from pixel to twips point by 15 factor.
                cellWidth = this.getCellWidth(cell.cellFormat.preferredWidth, cell.cellFormat.preferredWidthType, tableWidth, null);
                currOffset += cellWidth;
                let offset = parseFloat(currOffset.toFixed(2));
                if (tempGrid.indexOf(offset) < 0) {
                    tempGrid.push(offset);
                    tempSpanDecimal.push(currOffset);
                }
                if (j === row.childWidgets.length - 1 && rowFormat.gridAfter > 0) {
                    cellWidth = this.getCellWidth(rowFormat.gridAfterWidth, 'Point', tableWidth, null);
                    currOffset += cellWidth;
                    if (tempGrid.indexOf(parseFloat(currOffset.toFixed(2))) < 0) {
                        tempGrid.push(parseFloat(currOffset.toFixed(2)));
                        tempSpanDecimal.push(currOffset);
                    }
                    columnSpan += rowFormat.gridAfter;
                }
                // Add rowindex and its cells info for each row
                if (!this.tableCellInfo.containsKey(row.rowIndex)) {
                    this.tableCellInfo.add(row.rowIndex, rowCellInfo);
                }
            }
        }
        tempGrid.sort((a, b) => { return a - b; });
        tempSpanDecimal.sort((a, b) => { return a - b; });
        if (this.tableHolder.columns.length > 0 || isInsertRow) {
            this.updateColumnSpans(tempGrid, tableWidth, tempSpanDecimal, isOnlyRow);
        }
        this.tableCellInfo.clear();
        this.tableCellInfo = undefined;
    }
    updateValidPreferredWidth(cell) {
        if (cell.cellFormat.preferredWidthType === 'Point' && cell.cellFormat.preferredWidth !== cell.cellFormat.cellWidth
            && cell.cellFormat.preferredWidth < HelperMethods.round(cell.getMinimumPreferredWidth(), 2)) {
            if (cell.indexInOwner === 0) {
                cell.cellFormat.preferredWidth = cell.ownerColumn.endOffset;
            }
            else {
                const prevCell = cell.ownerRow.childWidgets[cell.indexInOwner - 1];
                if (prevCell.ownerColumn) {
                    cell.cellFormat.preferredWidth = cell.ownerColumn.endOffset - prevCell.ownerColumn.endOffset;
                }
            }
        }
    }
    updateColumnSpans(tempGrid, containerWidth, tempSpan, isInsertRow) {
        for (let i = 0; i < this.childWidgets.length; i++) {
            let row = this.childWidgets[i];
            if (row.rowFormat.gridBeforeWidth >= 0) {
                row.rowFormat.gridBefore = row.getGridCount(tempGrid, undefined, -1, containerWidth, tempSpan);
            }
            for (let j = 0; j < row.childWidgets.length; j++) {
                let cell = row.childWidgets[j];
                let columnSpan = row.getGridCount(tempGrid, cell, cell.getIndex(), containerWidth, tempSpan);
                if (columnSpan > 0 && cell.cellFormat.columnSpan !== columnSpan && !isInsertRow) {
                    cell.cellFormat.columnSpan = columnSpan;
                }
            }
            if (row.rowFormat.gridAfterWidth >= 0) {
                row.rowFormat.gridAfter = row.getGridCount(tempGrid, undefined, row.childWidgets.length, containerWidth, tempSpan);
            }
        }
    }
    /**
     * @private
     */
    getMinimumAndMaximumWordWidth(minimumWordWidth, maximumWordWidth) {
        this.checkTableColumns();
        let isAllColumnHasPointWidth = this.tableHolder.isAllColumnHasPointWidthType();
        let tableWidth = isAllColumnHasPointWidth ? this.tableHolder.getTotalWidth(0) : this.tableHolder.getTotalWidth(1);
        if (tableWidth > minimumWordWidth) {
            minimumWordWidth = tableWidth;
        }
        if (!isAllColumnHasPointWidth) {
            tableWidth = this.tableHolder.getTotalWidth(2);
        }
        if (tableWidth > maximumWordWidth) {
            maximumWordWidth = tableWidth;
        }
        return { 'minimumWordWidth': minimumWordWidth, 'maximumWordWidth': maximumWordWidth };
    }
    /**
     * @private
     */
    checkTableColumns() {
        if (this.isGridUpdated) {
            return;
        }
        let isAutoFit = this.isAutoFit();
        if (isAutoFit || this.tableHolder.columns.length === 0) {
            this.buildTableColumns();
        }
        this.isGridUpdated = false;
    }
    /**
     * @private
     */
    isAutoFit() {
        let bodyWidget = this.bodyWidget;
        if (!isNullOrUndefined(bodyWidget) && !isNullOrUndefined(bodyWidget.page)) {
            return bodyWidget.page.documentHelper.layout.getParentTable(this).tableFormat.allowAutoFit;
        }
        return false;
    }
    /**
     * @private
     */
    updateRowSpan() {
        const rowsLength = this.childWidgets.length;
        for (let i = 0; i < rowsLength; i++) {
            const row = this.childWidgets[i];
            for (let j = 0; j < row.childWidgets.length; j++) {
                const cell = row.childWidgets[j];
                if (cell.cellFormat.rowSpan > 1) {
                    // Check if the rowSpan extends beyond the table's boundaries
                    const remainingRows = rowsLength - row.rowIndex;
                    if (cell.cellFormat.rowSpan > remainingRows) {
                        // Reset rowSpan to the number of remaining rows
                        cell.cellFormat.rowSpan = remainingRows;
                    }
                }
            }
        }
    }
    /**
     * @private
     */
    updateCellFormatPreferredWidth() {
        let factor = 0;
        for (let i = 0; i < this.tableHolder.columns.length; i++) {
            let column = this.tableHolder.columns[i];
            if (i === 0) {
                factor = column.endOffset / column.preferredWidth;
            }
            else {
                if (column.endOffset < this.tableHolder.columns[i - 1].endOffset) {
                    column.endOffset = this.tableHolder.columns[i - 1].endOffset + (column.preferredWidth * factor);
                }
            }
        }
        //Updating preferred width.
        for (let i = 0; i < this.childWidgets.length; i++) {
            let row = this.childWidgets[i];
            for (let j = 0; j < row.childWidgets.length; j++) {
                let cell = row.childWidgets[j];
                if (cell.cellFormat.preferredWidthType === 'Point' && this.tableHolder && this.tableHolder.columns
                    && this.tableHolder.columns.length > 0 && (this.tableHolder.columns[cell.columnIndex + cell.cellFormat.columnSpan - 1])) {
                    cell.cellFormat.preferredWidth = this.tableHolder.columns[cell.columnIndex + cell.cellFormat.columnSpan - 1].endOffset - (cell.columnIndex > 0 ? this.tableHolder.columns[cell.columnIndex - 1].endOffset : 0);
                }
            }
        }
    }
    /**
     * @private
     */
    buildTableColumns() {
        if (this.isGridUpdated) {
            return;
        }
        // Clear existing columns in order to start creating columns freshly.
        this.tableHolder.resetColumns();
        let containerWidth = 0;
        let tableWidth = 0;
        let rowSpannedCells = [];
        let gridBeforeWidth = false;
        /* eslint-disable-next-line max-len */
        let isAutoWidth = (this.tableFormat.preferredWidthType === 'Auto' || (this.tableFormat.preferredWidthType === "Point" && this.tableFormat.preferredWidth === 0));
        let isAutoFit = this.tableFormat.allowAutoFit;
        if (!isAutoFit && !isNullOrUndefined(this.bodyWidget.page) && this.bodyWidget.page.documentHelper && this.bodyWidget.page.documentHelper.owner
            && this.bodyWidget.page.documentHelper.owner.isTableMarkerDragging) {
            isAutoWidth = true;
        }
        // For continuous layout, window width should be considered. 
        // If preferred width exceeds this limit, it can take upto maximum of 2112 pixels (1584 points will be assigned by Microsoft Word).
        if (((!isNullOrUndefined(this.bodyWidget.page)) && this.bodyWidget.page.viewer instanceof WebLayoutViewer && (isAutoFit || this.tableFormat.preferredWidthType === 'Percent') && !this.isInsideTable && !(this.containerWidget instanceof TextFrame))) {
            containerWidth = HelperMethods.convertPixelToPoint(this.bodyWidget.page.viewer.clientArea.width - this.bodyWidget.page.viewer.padding.right * 3);
        }
        else {
            containerWidth = this.getOwnerWidth(true);
        }
        if (!isNullOrUndefined(this.bodyWidget.page) && this.bodyWidget.page.documentHelper && this.bodyWidget.page.documentHelper.layout) {
            this.bodyWidget.page.documentHelper.layout.isAllColumnHasAutoWidthType = this.bodyWidget.page.documentHelper.layout.isAuto(this);
        }
        if (this.tableFormat.preferredWidthType !== 'Percent') {
            containerWidth = (this.tableFormat.preferredWidth > containerWidth) ? this.tableFormat.preferredWidth : containerWidth;
        }
        let isZeroWidth = (isAutoWidth && this.tableFormat.preferredWidth === 0 && !isAutoFit);
        tableWidth = this.getTableClientWidth(containerWidth);
        let pageContainerWidth = this.getContainerWidth();
        if (isZeroWidth && !this.isDefaultFormatUpdated && isAutoFit) {
            this.splitWidthToTableCells(tableWidth, isZeroWidth);
        }
        let hasSpannedCells = false;
        for (let i = 0; i < this.childWidgets.length; i++) {
            let row = this.childWidgets[i];
            let rowFormat = row.rowFormat;
            let columnSpan = 0;
            let cellWidth = 0;
            let sizeInfo = new ColumnSizeInfo();
            let offset = 0;
            if (rowFormat.gridBefore > 0 && (row.rowFormat.beforeWidth !== 0 || row.rowFormat.gridBeforeWidth !== 0) && ((this.bodyWidget.page.documentHelper.alignTablesRowByRow) ? row.ownerTable.tableFormat.tableAlignment === 'Left' || (this.bodyWidget.page.documentHelper.compatibilityMode === 'Word2003' && row.ownerTable.firstChild.rowFormat.gridAfter > 0) : true)) {
                gridBeforeWidth = true;
                cellWidth = this.getCellWidth(rowFormat.gridBeforeWidth, row.rowFormat.gridAfterWidthType, tableWidth, null);
                sizeInfo.minimumWidth = cellWidth;
                this.tableHolder.addColumns(columnSpan, columnSpan = rowFormat.gridBefore, cellWidth, sizeInfo, offset = cellWidth, 'Point', isAutoWidth);
            }
            for (let j = 0; j < row.childWidgets.length; j++) {
                let cell = row.childWidgets[j];
                if (cell.cellFormat.rowSpan > 1 || cell.cellFormat.columnSpan > 1) {
                    hasSpannedCells = true;
                }
                if (rowSpannedCells.length === 0) {
                    cell.columnIndex = columnSpan;
                }
                for (let k = 0; k < rowSpannedCells.length; k++) {
                    let rowSpannedCell = rowSpannedCells[k];
                    if (rowSpannedCell.columnIndex < columnSpan) {
                        cell.columnIndex = columnSpan;
                        continue;
                    }
                    let rowSpan = 1;
                    let removeSpannedCell = true;
                    rowSpan = rowSpannedCell.cellFormat.rowSpan;
                    if (rowSpannedCell.columnIndex > columnSpan) {
                        cell.columnIndex = columnSpan;
                        removeSpannedCell = false;
                    }
                    else {
                        sizeInfo = rowSpannedCell.getCellSizeInfo(isAutoFit);
                        cellWidth = this.getCellWidth(rowSpannedCell.cellFormat.preferredWidth, rowSpannedCell.cellFormat.preferredWidthType, tableWidth, rowSpannedCell);
                        // If the table gird alone calculated then column index of the rowspanned cell will be directly taken. 
                        // If the gird calculation is done from the UI level operations such as resizing then table holder will have the columns at that time we can get the column index from the table holder.
                        if (this.tableHolder.columns.length > 0) {
                            this.tableHolder.addColumns(columnSpan, columnSpan = this.tableHolder.columns.indexOf(rowSpannedCell.ownerColumn) + rowSpannedCell.cellFormat.columnSpan, cellWidth, sizeInfo, offset += cellWidth, cell.cellFormat.preferredWidthType, isAutoWidth);
                            cell.columnIndex = columnSpan;
                        }
                        else {
                            this.tableHolder.addColumns(columnSpan, columnSpan = rowSpannedCell.columnIndex + rowSpannedCell.cellFormat.columnSpan, cellWidth, sizeInfo, offset += cellWidth, cell.cellFormat.preferredWidthType, isAutoWidth);
                            cell.columnIndex = columnSpan;
                        }
                    }
                    if (!removeSpannedCell && j === row.childWidgets.length - 1) {
                        removeSpannedCell = true;
                    }
                    if (removeSpannedCell && i - rowSpannedCell.ownerRow.rowIndex === rowSpan - 1) {
                        rowSpannedCells.splice(k, 1);
                        k--;
                    }
                }
                // At the start of each row, we will process the row spanned cells to get the start column index.
                // To calculate grid properly, we need the items in the spanned cells collection in the order of their column index
                if (cell.cellFormat.rowSpan > 1) {
                    if (rowSpannedCells.length === 0 || rowSpannedCells[rowSpannedCells.length - 1].columnIndex <= columnSpan) {
                        rowSpannedCells.push(cell);
                    }
                    else {
                        let insertIndex = 0;
                        for (let m = rowSpannedCells.length; m > 0; m--) {
                            if (rowSpannedCells[m - 1].columnIndex > columnSpan) {
                                insertIndex = m - 1;
                            }
                        }
                        rowSpannedCells.splice(insertIndex, 0, cell);
                    }
                }
                sizeInfo = cell.getCellSizeInfo(isAutoFit);
                cellWidth = this.getCellWidth(cell.cellFormat.preferredWidth, cell.cellFormat.preferredWidthType, tableWidth, cell);
                this.tableHolder.addColumns(columnSpan, columnSpan += cell.cellFormat.columnSpan, cellWidth, sizeInfo, offset += cellWidth, cell.cellFormat.preferredWidthType, isAutoWidth);
                if (j === row.childWidgets.length - 1 && rowFormat.gridAfterWidth > 0) {
                    cellWidth = this.getCellWidth(rowFormat.gridAfterWidth, 'Point', tableWidth, null);
                    sizeInfo.minimumWordWidth = sizeInfo.maximumWordWidth = sizeInfo.minimumWidth = cellWidth;
                    this.tableHolder.addColumns(columnSpan, columnSpan += rowFormat.gridAfter, cellWidth, sizeInfo, offset += cellWidth, 'Point', isAutoWidth);
                }
            }
        }
        if (!isNullOrUndefined(this.bodyWidget.page) && this.bodyWidget.page.documentHelper && this.bodyWidget.page.documentHelper.layout
            && this.bodyWidget.page.documentHelper.layout.isAllColumnHasAutoWidthType) {
            this.bodyWidget.page.documentHelper.layout.isAllColumnHasAutoWidthType = false;
        }
        if (isZeroWidth && !this.isDefaultFormatUpdated) {
            this.isDefaultFormatUpdated = true;
        }
        this.tableHolder.validateColumnWidths();
        if (isAutoFit) {
            // Fits the column width automatically based on contents.
            this.tableHolder.autoFitColumn(containerWidth, tableWidth, isAutoWidth, this.isInsideTable, isAutoFit, hasSpannedCells, this.bodyWidget.page.viewer.clientArea.width, this.leftIndent + this.rightIndent, pageContainerWidth, this.tableFormat.preferredWidthType, gridBeforeWidth);
        }
        else {
            // Fits the column width based on preferred width. i.e. Fixed layout.
            this.tableHolder.fitColumns(containerWidth, tableWidth, isAutoWidth, isAutoFit, this.leftIndent + this.rightIndent);
        }
        // if (!isAutoFit && isAutoWidth) {
        //     tableWidth = this.tableHolder.tableWidth;
        // }
        //Sets the width to cells
        this.setWidthToCells(tableWidth, isAutoWidth);
    }
    /**
     * @private
     */
    setWidthToCells(tableWidth, isAutoWidth) {
        let isTableResizing = false;
        if (this.containerWidget instanceof BodyWidget && this.containerWidget.page
            && this.containerWidget.page.documentHelper
            && (this.containerWidget.page.documentHelper.owner.isTableMarkerDragging
                || this.containerWidget.page.documentHelper.isRowOrCellResizing)) {
            isTableResizing = true;
        }
        for (let i = 0; i < this.childWidgets.length; i++) {
            let rw = this.childWidgets[i];
            let rowFormat = rw.rowFormat;
            if (rowFormat.gridBefore > 0) {
                rowFormat.beforeWidth = this.tableHolder.getCellWidth(0, rowFormat.gridBefore, tableWidth);
            }
            for (let j = 0; j < rw.childWidgets.length; j++) {
                let cell = rw.childWidgets[j];
                if (cell.cellFormat.preferredWidthType === "Auto") {
                    cell.cellFormat.initialCellWidth = cell.cellFormat.cellWidth;
                }
                cell.cellFormat.cellWidth =
                    this.tableHolder.getCellWidth(cell.columnIndex, cell.cellFormat.columnSpan, tableWidth, isTableResizing);
                //By default, if cell preferred widthType is auto , width set based on table width and type is changed to 'Point'
            }
            if (rowFormat.gridAfter > 0) {
                const lastCell = rw.lastChild;
                let gridAfterStartIndex = lastCell.index + lastCell.cellFormat.columnSpan;
                rowFormat.afterWidth = this.tableHolder.getCellWidth(gridAfterStartIndex, rowFormat.gridAfter, tableWidth);
            }
        }
    }
    /**
     * @private
     */
    updateProperties(updateAllowAutoFit, currentSelectedTable, autoFitBehavior) {
        if (updateAllowAutoFit) {
            this.tableFormat.allowAutoFit = autoFitBehavior !== 'FixedColumnWidth';
        }
        if (this !== currentSelectedTable) {
            currentSelectedTable.updateProperties(false, currentSelectedTable, autoFitBehavior);
            return;
        }
        if (autoFitBehavior === 'FixedColumnWidth') {
            // Clear the table widths and set the preferred width for cells.
            this.tableFormat.preferredWidth = 0;
            this.tableFormat.preferredWidthType = 'Auto';
            for (let i = 0; i < this.childWidgets.length; i++) {
                let rowWidget = this.childWidgets[i];
                for (let j = 0; j < rowWidget.childWidgets.length; j++) {
                    let cellWidget = rowWidget.childWidgets[j];
                    cellWidget.cellFormat.preferredWidthType = 'Point';
                    cellWidget.cellFormat.preferredWidth = cellWidget.cellFormat.cellWidth;
                }
            }
        }
        else if (autoFitBehavior === 'FitToWindow') {
            // Set the preferred width for table and cells in percentage.
            let tableWidth = this.tableHolder.getTotalWidth(0);
            this.tableFormat.leftIndent = 0;
            this.tableFormat.preferredWidth = 100;
            this.tableFormat.preferredWidthType = 'Percent';
            for (let i = 0; i < this.childWidgets.length; i++) {
                let row = this.childWidgets[i];
                for (let z = 0; z < row.childWidgets.length; z++) {
                    let cell = row.childWidgets[z];
                    if (cell.cellFormat.preferredWidthType !== 'Percent') {
                        cell.cellFormat.preferredWidthType = 'Percent';
                        cell.cellFormat.preferredWidth = (cell.cellFormat.cellWidth / tableWidth) * 100;
                    }
                }
            }
        }
        else {
            // Clear the preferred width for table and cells.
            this.tableFormat.preferredWidth = 0;
            this.tableFormat.preferredWidthType = 'Auto';
            for (let i = 0; i < this.childWidgets.length; i++) {
                let row = this.childWidgets[i];
                row.rowFormat.beforeWidth = 0;
                row.rowFormat.gridBefore = 0;
                row.rowFormat.gridBeforeWidth = 0;
                row.rowFormat.gridBeforeWidthType = 'Auto';
                row.rowFormat.afterWidth = 0;
                row.rowFormat.gridAfter = 0;
                row.rowFormat.gridAfterWidth = 0;
                row.rowFormat.gridAfterWidthType = 'Auto';
                for (let j = 0; j < row.childWidgets.length; j++) {
                    let cell = row.childWidgets[j];
                    cell.cellFormat.preferredWidth = 0;
                    cell.cellFormat.preferredWidthType = 'Auto';
                }
            }
        }
    }
    /**
     * @private
     */
    getMaxRowWidth(clientWidth) {
        let width = 0;
        for (let i = 0; i < this.childWidgets.length; i++) {
            let row = this.childWidgets[i];
            let rowWidth = 0;
            for (let j = 0; j < row.childWidgets.length; j++) {
                let cell = row.childWidgets[j];
                rowWidth += this.getCellWidth(cell.cellFormat.preferredWidth, cell.cellFormat.preferredWidthType, clientWidth, cell);
            }
            if (width < rowWidth) {
                width = rowWidth;
            }
        }
        return width;
    }
    /**
     * @private
     */
    updateWidth(dragValue, isCurrentTableResizing, isLastColumn) {
        let totalPreferredWidth = this.tableHolder.getTotalWidth(0);
        let ownerWidth = this.getOwnerWidth(true);
        let containerWidth = this.getTableClientWidth(ownerWidth);
        // if (containerWidth <= totalPreferredWidth) {
        //     if (this.tableFormat.preferredWidthType === 'Auto') {
        //         this.tableFormat.preferredWidthType = 'Point';
        //     }
        // }
        if (this.tableFormat.preferredWidthType !== 'Auto') {
            if (this.tableFormat.preferredWidthType === 'Point') {
                this.tableFormat.preferredWidth = this.getMaxRowWidth(containerWidth);
            }
            else { //ToDo:Need to analyze more the Percentage calculation for table width.
                totalPreferredWidth = this.getMaxRowWidth(containerWidth);
                let value = (totalPreferredWidth / ownerWidth) * 100;
                this.tableFormat.preferredWidth = value;
            }
        }
        if (isLastColumn && isCurrentTableResizing && this.tableFormat.preferredWidthType === 'Auto' &&
            this.tableFormat.preferredWidth < this.getMaxRowWidth(containerWidth)) {
            this.tableFormat.preferredWidth = this.getMaxRowWidth(containerWidth);
        }
    }
    /**
     * @private
     */
    convertPointToPercent(tablePreferredWidth, ownerWidth) {
        let value = 0;
        value = (tablePreferredWidth / ownerWidth) * 100;
        value = Math.round(value);
        return value < 100 ? value : 100; // The value should be lesser than or equal to 100%;
    }
    updateChildWidgetLeft(left) {
        for (let i = 0; i < this.childWidgets.length; i++) {
            let rowWidget = this.childWidgets[i];
            rowWidget.x = left;
            rowWidget.updateChildWidgetLeft(left);
        }
    }
    /**
     * Shift the widgets for right to left aligned table.
     * @private
     */
    shiftWidgetsForRtlTable(clientArea, tableWidget) {
        let clientAreaX = tableWidget.x;
        let clientAreaRight = clientArea.right;
        let cellSpace = 0;
        if (tableWidget.tableFormat && tableWidget.tableFormat.cellSpacing > 0) {
            cellSpace = tableWidget.tableFormat.cellSpacing;
        }
        for (let i = 0; i < tableWidget.childWidgets.length; i++) {
            let rowWidget = tableWidget.childWidgets[i];
            let rowX = rowWidget.x;
            let left = clientAreaRight - (rowX - clientAreaX);
            for (let j = 0; j < rowWidget.childWidgets.length; j++) {
                let cellWidget = rowWidget.childWidgets[j];
                left = left -
                    (cellWidget.width + cellWidget.margin.left + cellWidget.margin.right - cellWidget.rightBorderWidth + cellSpace);
                cellWidget.updateWidgetLeft(left + cellWidget.margin.left);
            }
        }
    }
    /**
     * @private
     */
    clone(skip) {
        let table = new TableWidget();
        table.tableHolder = this.tableHolder.clone();
        table.tableFormat.copyFormat(this.tableFormat);
        if (this.wrapTextAround) {
            table.wrapTextAround = this.wrapTextAround;
            table.positioning = this.positioning.clone();
        }
        if (!skip) {
            for (let i = 0; i < this.childWidgets.length; i++) {
                let row = this.childWidgets[i].clone();
                table.childWidgets.push(row);
                row.containerWidget = table;
                row.index = i;
            }
        }
        table.x = this.x;
        table.y = this.y;
        table.height = this.height;
        table.width = this.width;
        table.isBidiTable = this.isBidiTable;
        table.containerWidget = this.containerWidget;
        if (this.contentControlProperties) {
            table.contentControlProperties = this.contentControlProperties;
        }
        return table;
    }
    /**
     * @private
     */
    static getTableOf(node) {
        if (node instanceof WBorders) {
            let row = TableRowWidget.getRowOf(node);
            if (!isNullOrUndefined(row)) {
                return row.ownerTable;
            }
            else if (node.ownerBase instanceof WTableFormat && node.ownerBase.ownerBase instanceof TableWidget) {
                return node.ownerBase.ownerBase;
            }
            else {
                return undefined;
            }
        }
        return undefined;
    }
    /**
     * @private
     */
    fitChildToClientArea() {
        let clientWidth = this.getContainerWidth();
        if (Math.round(clientWidth) < Math.round(this.getTableWidth())) {
            this.fitCellsToClientArea(clientWidth);
        }
        for (let i = 0; i < this.childWidgets.length; i++) {
            let row = this.childWidgets[i];
            for (let j = 0; j < row.childWidgets.length; j++) {
                let cell = row.childWidgets[j];
                for (let k = 0; k < cell.childWidgets.length; k++) {
                    if (cell.childWidgets[k] instanceof TableWidget) {
                        cell.childWidgets[k].fitChildToClientArea();
                    }
                }
            }
        }
    }
    /**
     * @private
     */
    getColumnCellsForSelection(startCell, endCell) {
        let cells = [];
        let start = startCell.columnIndex;
        let end = endCell.columnIndex + endCell.cellFormat.columnSpan;
        for (let i = 0; i < this.childWidgets.length; i++) {
            let row = this.childWidgets[i];
            for (let j = 0; j < row.childWidgets.length; j++) {
                let cell = row.childWidgets[j];
                let columnIndex = cell.columnIndex;
                let columnSpan = cell.cellFormat.columnSpan;
                if ((columnIndex + columnSpan > start && columnIndex + columnSpan < end) || (columnIndex > start && columnIndex < end)) {
                    if (cells.indexOf(cell) < 0) {
                        cells.push(cell);
                    }
                }
                else if ((columnIndex > start && columnIndex < end && columnIndex + columnSpan < end)
                    || (columnIndex < start && columnIndex + columnSpan > end)) {
                    if (cells.indexOf(cell) < 0) {
                        cells.push(cell);
                    }
                }
                else if (columnIndex === start || columnIndex + columnSpan === end) {
                    if (cells.indexOf(cell) < 0) {
                        cells.push(cell);
                    }
                }
            }
        }
        return cells;
    }
    /**
     * Splits width equally for all the cells.
     * @param tableClientWidth
     * @private
     */
    splitWidthToTableCells(tableClientWidth, isZeroWidth) {
        for (let row = 0; row < this.childWidgets.length; row++) {
            this.childWidgets[row].splitWidthToRowCells(tableClientWidth, isZeroWidth);
        }
    }
    /**
     * @private
     */
    insertTableRowsInternal(tableRows, startIndex, isInsertRow, initilizeCellBorder, isOnlyRow) {
        for (let i = tableRows.length - 1; i >= 0; i--) {
            let row = tableRows.splice(i, 1)[0];
            row.containerWidget = this;
            if (initilizeCellBorder) {
                for (let j = 0; j < row.childWidgets.length; j++) {
                    let cell = row.childWidgets[j];
                    cell.cellFormat.initializeCellBorders();
                }
            }
            this.childWidgets.splice(startIndex, 0, row);
        }
        this.updateRowIndex(startIndex);
        this.isGridUpdated = false;
        if (isInsertRow) {
            this.calculateGrid(true, isOnlyRow);
            this.buildTableColumns();
        }
        this.isGridUpdated = true;
    }
    /**
     * @private
     */
    updateRowIndex(startIndex) {
        for (let i = startIndex; i < this.childWidgets.length; i++) {
            let row = this.childWidgets[i];
            row.index = i;
            for (let j = 0; j < row.childWidgets.length; j++) {
                row.childWidgets[j].index = j;
                row.childWidgets[j].rowIndex = row.rowIndex;
            }
            startIndex++;
        }
    }
    /**
     * @private
     */
    getCellStartOffset(cell) {
        let offset = 0;
        if (cell && this.tableCellInfo) {
            if (this.tableCellInfo.containsKey(cell.ownerRow.rowIndex)) {
                let rowCellInfo = this.tableCellInfo.get(cell.ownerRow.rowIndex);
                if (rowCellInfo.containsKey(cell.cellIndex)) {
                    offset = rowCellInfo.get(cell.cellIndex);
                }
            }
        }
        return offset;
    }
    /**
     * @private
     */
    destroyInternal(viewer) {
        let height = this.height;
        if (!isNullOrUndefined(this.childWidgets)) {
            for (let j = 0; j < this.childWidgets.length; j++) {
                let widget = undefined;
                let childWidget = this.childWidgets[j];
                widget = childWidget;
                if (!isNullOrUndefined(widget)) {
                    widget.destroyInternal(viewer);
                }
                if (isNullOrUndefined(this.childWidgets)) {
                    break;
                }
                j--;
            }
            this.childWidgets = undefined;
        }
        if (!isNullOrUndefined(this.containerWidget)) {
            if (this.containerWidget instanceof BodyWidget) {
                if (this.containerWidget.floatingElements.indexOf(this) !== -1) {
                    this.containerWidget.floatingElements.splice(this.containerWidget.floatingElements.indexOf(this), 1);
                }
            }
            if (!isNullOrUndefined(this.containerWidget.childWidgets)) {
                if (this.containerWidget.childWidgets.indexOf(this) !== -1) {
                    this.containerWidget.childWidgets.splice(this.containerWidget.childWidgets.indexOf(this), 1);
                }
                this.containerWidget.height -= height;
                // if ((isNullOrUndefined(this.containerWidget.childWidgets) || this.containerWidget.childWidgets.length === 0)
                //     && this.containerWidget instanceof BodyWidget) {
                //     // (this.containerWidget as BodyWidget).destroyInternal(viewer);
                // }
            }
            this.containerWidget = undefined;
        }
        this.destroy();
    }
    /**
     * @private
     */
    destroy() {
        // if (this.tableFormat) {
        //     this.tableFormat.destroy();
        // }
        this.tableFormat = undefined;
        if (this.spannedRowCollection) {
            this.spannedRowCollection.destroy();
        }
        this.spannedRowCollection = undefined;
        // if (this.tableHolder) {
        //     this.tableHolder.destroy();
        // }
        this.tableHolder = undefined;
        this.flags = undefined;
        this.leftMargin = undefined;
        this.topMargin = undefined;
        this.rightMargin = undefined;
        this.bottomMargin = undefined;
        this.headerHeight = undefined;
        this.isDefaultFormatUpdated = undefined;
        super.destroy();
    }
    /**
     * Disposes the internal objects which are maintained.
     * @private
     */
    componentDestroy() {
        if (this.tableFormat) {
            this.tableFormat.destroy();
        }
        this.tableFormat = undefined;
        if (this.spannedRowCollection) {
            this.spannedRowCollection.destroy();
        }
        this.spannedRowCollection = undefined;
        if (this.tableHolder) {
            this.tableHolder.destroy();
        }
        this.tableHolder = undefined;
        this.flags = undefined;
        this.leftMargin = undefined;
        this.topMargin = undefined;
        this.rightMargin = undefined;
        this.bottomMargin = undefined;
        this.headerHeight = undefined;
        this.isDefaultFormatUpdated = undefined;
        super.componentDestroy();
    }
}
/**
 * @private
 */
export class TableRowWidget extends BlockWidget {
    constructor() {
        super();
        /**
         * @private
         */
        this.isRenderBookmarkEnd = false;
        this.topBorderWidth = 0;
        this.bottomBorderWidth = 0;
        this.rowFormat = new WRowFormat(this);
        this.editRangeID = new Dictionary();
    }
    // /**
    //  * @private
    //  */
    // get length(): number {
    //     if (!isNullOrUndefined(this.nextSplitWidget)) {
    //         return 1;
    //     } else {
    //         if (isNullOrUndefined(this.previousSplitWidget)) {
    //             return 1;
    //         }
    //         return 0;
    //     }
    // }
    /**
     * @private
     */
    get rowIndex() {
        if (this.containerWidget) {
            return this.containerWidget.childWidgets.indexOf(this);
        }
        return -1;
    }
    /**
     * @private
     */
    get ownerTable() {
        if (this.containerWidget instanceof TableWidget) {
            return this.containerWidget;
        }
        return undefined;
    }
    /**
     * @private
     */
    get nextRow() {
        let index = this.indexInOwner;
        if (index > -1 && index < this.ownerTable.childWidgets.length - 1) {
            return this.ownerTable.childWidgets[index + 1];
        }
        return undefined;
    }
    /**
     * @private
     */
    equals(widget) {
        return widget instanceof TableRowWidget && widget.rowFormat === this.rowFormat;
    }
    /**
     * @private
     */
    combineCells(viewer) {
        for (let i = 0; i < this.childWidgets.length; i++) {
            let cell = this.childWidgets[i];
            cell.combineWidget(viewer);
            if (!isNullOrUndefined(cell.cellFormat) && cell.cellFormat.rowSpan === 1) {
                let cellHeight = cell.height + cell.margin.top + cell.margin.bottom;
                if ((this.height - this.ownerTable.tableFormat.cellSpacing) < cell.height) {
                    this.height = this.ownerTable.tableFormat.cellSpacing + cell.height;
                }
            }
            else if (isNullOrUndefined(cell.cellFormat)) {
                i--;
            }
        }
    }
    /**
     * @private
     */
    static getRowOf(node) {
        if (node instanceof WBorders) {
            let cell = TableCellWidget.getCellOf(node);
            if (!isNullOrUndefined(cell)) {
                return cell.ownerRow;
            }
            else if (node.ownerBase instanceof WRowFormat && node.ownerBase.ownerBase instanceof TableRowWidget) {
                return node.ownerBase.ownerBase;
            }
            else {
                return undefined;
            }
        }
        return undefined;
    }
    /**
     * @private
     */
    getCell(rowIndex, columnIndex, cellIndex) {
        for (let i = 0; i < this.childWidgets.length; i++) {
            let cell = this.childWidgets[i];
            if (cell.rowIndex === rowIndex && (!isNullOrUndefined(cellIndex) ? cell.cellIndex === cellIndex : cell.columnIndex === columnIndex)) {
                return cell;
            }
        }
        return undefined;
    }
    /**
     * @private
     */
    getCellUsingColumnIndex(rowIndex, columnIndex) {
        let cell;
        for (let i = 0; i < this.childWidgets.length; i++) {
            cell = this.childWidgets[i];
            if (cell.rowIndex === rowIndex && cell.columnIndex === columnIndex) {
                return cell;
            }
        }
        cell = this.getCell(rowIndex, columnIndex);
        if (!isNullOrUndefined(cell)) {
            return cell;
        }
        return undefined;
    }
    /**
     * @private
     */
    splitWidthToRowCells(tableClientWidth, isZeroWidth) {
        let cells = this.childWidgets;
        let cellWidth = tableClientWidth / cells.length;
        for (let cell = 0; cell < cells.length; cell++) {
            if (isZeroWidth && cells[cell].cellFormat.preferredWidth === 0) {
                cells[cell].cellFormat.preferredWidth = cellWidth;
                this.ownerTable.isDefaultFormatUpdated = false;
            }
            else if (isZeroWidth) {
                this.ownerTable.isDefaultFormatUpdated = true;
                break;
            }
            else {
                cells[cell].cellFormat.preferredWidth = cellWidth;
            }
        }
    }
    /**
     * @private
     */
    getGridCount(tableGrid, cell, index, containerWidth, tempSpan) {
        let prevOffset = 0;
        let width = 0;
        let ownerTable = this.ownerTable;
        let rowFormat = this.rowFormat;
        if (index === -1) {
            width = ownerTable.getCellWidth(rowFormat.gridBeforeWidth, rowFormat.gridBeforeWidthType, containerWidth, null);
        }
        else {
            prevOffset += ownerTable.getCellWidth(rowFormat.gridBeforeWidth, rowFormat.gridBeforeWidthType, containerWidth, null);
            if (index >= 0) {
                prevOffset += ownerTable.getCellStartOffset(cell);
            }
            if (index < this.childWidgets.length) {
                width = ownerTable.getCellWidth(cell.cellFormat.preferredWidth, cell.cellFormat.preferredWidthType, containerWidth, null);
            }
            else {
                width = ownerTable.getCellWidth(rowFormat.gridAfterWidth, rowFormat.gridAfterWidthType, containerWidth, null);
            }
        }
        let tabIndex = tableGrid.indexOf(prevOffset);
        let tabGrid = tempSpan[tabIndex];
        let gridEndIndex;
        let gridStartIndex = this.getOffsetIndex(tableGrid, prevOffset);
        let gridWidth = parseFloat((width + prevOffset).toFixed(2));
        let gridDecimalWidth = parseFloat((width + tabGrid).toFixed(2));
        if (gridDecimalWidth !== gridWidth && !isNullOrUndefined(tabGrid)) {
            gridEndIndex = this.getOffsetIndex(tableGrid, tabGrid + width);
        }
        else {
            gridEndIndex = this.getOffsetIndex(tableGrid, prevOffset + width);
        }
        return gridEndIndex - gridStartIndex;
    }
    getOffsetIndex(tableGrid, offset) {
        offset = parseFloat(offset.toFixed(2));
        let index = 0;
        if (tableGrid.indexOf(offset) >= 0) {
            index = tableGrid.indexOf(offset);
        }
        else {
            for (let i = 0; i < tableGrid.length; i++) {
                if (tableGrid[i] > offset) {
                    return i;
                }
            }
            index = tableGrid.length - 1;
        }
        return index;
    }
    getCellOffset(index, containerWidth) {
        let prevOffset = 0;
        let ownerTable = this.ownerTable;
        for (let i = 0; i < this.childWidgets.length; i++) {
            let cellFormat = this.childWidgets[i].cellFormat;
            if (i === index) {
                break;
            }
            prevOffset += ownerTable.getCellWidth(cellFormat.preferredWidth, cellFormat.preferredWidthType, containerWidth, null);
        }
        return prevOffset;
    }
    /**
     * @private
     */
    updateRowBySpannedCells() {
        let rowSpannedCells = this.getPreviousRowSpannedCells();
        let currentRowIndex = this.rowIndex;
        for (let i = 0; i < rowSpannedCells.length; i++) {
            let spannedCell = rowSpannedCells[i];
            let rowSpanEnd = spannedCell.ownerRow.rowIndex + spannedCell.cellFormat.rowSpan - 1;
            // If current row is row span end or includes spanned cells. then, decrease the rowspan
            if (rowSpanEnd >= currentRowIndex) {
                spannedCell.cellFormat.rowSpan -= 1;
            }
        }
    }
    /**
     * @private
     */
    getPreviousRowSpannedCells(include) {
        let rowSpannedCells = [];
        let row = include ? this : this.previousWidget;
        while (!isNullOrUndefined(row)) {
            for (let i = 0; i < row.childWidgets.length; i++) {
                let cell = row.childWidgets[i];
                if (cell.cellFormat.rowSpan > 1) {
                    rowSpannedCells.splice(0, 0, cell);
                }
            }
            row = row.previousWidget;
        }
        return rowSpannedCells;
    }
    /**
     * @private
     */
    isCellsHaveSameWidthUnit() {
        if (this.childWidgets.length > 0) {
            var firstCellWidthUnit = this.childWidgets[0].cellFormat.preferredWidthType;
            for (let i = 1; i < this.childWidgets.length; i++) {
                let cell = this.childWidgets[i];
                if (firstCellWidthUnit != cell.cellFormat.preferredWidthType) {
                    return false;
                }
            }
        }
        return true;
    }
    /**
     * @private
     */
    updateUniformWidthUnitForCells() {
        let isSetMinwidth = false;
        if (this.ownerTable && this.ownerTable.tableHolder && this.ownerTable.tableHolder.columns && this.childWidgets.length !== this.ownerTable.tableHolder.columns.length
            && this.ownerTable.tableFormat.allowAutoFit) {
            isSetMinwidth = true;
        }
        for (let i = 0; i < this.childWidgets.length; i++) {
            let cell = this.childWidgets[i];
            if (cell.cellFormat.preferredWidthType !== "Point") {
                if (cell.cellFormat.preferredWidthType === "Auto") {
                    cell.cellFormat.cellWidth = cell.cellFormat.initialCellWidth;
                }
                cell.cellFormat.preferredWidthType = "Point";
                if (isSetMinwidth) {
                    cell.cellFormat.preferredWidth = cell.getMinimumPreferredWidth();
                }
                else {
                    cell.cellFormat.preferredWidth = cell.cellFormat.cellWidth;
                }
            }
        }
    }
    /**
     * @private
     */
    getTableCellWidget(point) {
        const isBidiTable = this.ownerTable.isBidiTable;
        for (let i = 0; i < this.childWidgets.length; i++) {
            let x = Math.round(this.childWidgets[i].x)
                - this.bodyWidget.page.documentHelper.resizerBoundaryWidth;
            if (x - this.childWidgets[i].margin.left - 1 <= point.x
                && (isBidiTable ? x + this.childWidgets[i].width + this.childWidgets[i].margin.left
                    + this.childWidgets[i].margin.right >= point.x
                    : x + this.childWidgets[i].width >= point.x)) {
                return this.childWidgets[i];
            }
            else if (i === this.childWidgets.length - 1
                && (this.childWidgets[i].x + this.childWidgets[i].width) + 1 <= point.x) {
                return this.childWidgets[i];
            }
        }
        let cellWidget = undefined;
        if (this.childWidgets.length > 0) {
            if (this.childWidgets[0].x <= point.x) {
                cellWidget = this.childWidgets[this.childWidgets.length - 1].getTableCellWidget(point);
            }
            else {
                cellWidget = this.childWidgets[0].getTableCellWidget(point);
            }
        }
        return cellWidget;
    }
    /**
     * @private
     */
    getFirstRowWidth() {
        let width = 0;
        for (let i = 0; i < this.childWidgets.length; i++) {
            width += this.childWidgets[i].getCellWidth(this.ownerTable);
        }
        return width;
    }
    /**
     * @private
     */
    getCellWidget(columnIndex, columnSpan) {
        let tableHolder = this.ownerTable.tableHolder;
        let index = tableHolder.getValidColumnIndex(columnIndex);
        if (index > columnIndex) {
            columnSpan -= index - columnIndex;
            columnIndex = index;
        }
        let colIndex = 0;
        if (this.rowFormat.gridBefore > 0) {
            colIndex += this.rowFormat.gridBefore;
        }
        for (let i = 0; i < this.childWidgets.length; i++) {
            let cell = this.childWidgets[i];
            let colSpan = cell.cellFormat.columnSpan;
            if (colIndex < cell.columnIndex && (colIndex <= columnIndex || colIndex < columnIndex + columnSpan)
                && cell.columnIndex > columnIndex) {
                return null;
            }
            if ((cell.columnIndex <= columnIndex || cell.columnIndex < columnIndex + columnSpan)
                && cell.columnIndex + colSpan > columnIndex) {
                return cell;
            }
            else if (cell.columnIndex > columnIndex) {
                break;
            }
            colIndex += colSpan;
        }
        return null;
    }
    getVerticalMergeStartCell(columnIndex, columnSpan) {
        let columns = this.ownerTable.tableHolder.columns;
        if (this.rowFormat.gridBefore > 0 && this.rowFormat.gridBefore > columnIndex + columnSpan) {
            return null;
        }
        var matchedCell = this.getCellWidget(columnIndex, columnSpan);
        if (!isNullOrUndefined(matchedCell)) {
            return matchedCell;
        }
        if (columnIndex + this.rowFormat.gridAfter === columns.length) {
            return null;
        }
        var cell;
        let previousRow = this.previousWidget;
        if (!isNullOrUndefined(previousRow)) {
            //Gets the First intersecting cell from previous row
            cell = previousRow.getVerticalMergeStartCell(columnIndex, columnSpan);
        }
        if (!isNullOrUndefined(cell) && cell.cellFormat.rowSpan > 1 && this.index === cell.rowIndex + cell.cellFormat.rowSpan - 1) {
            return cell;
        }
        return null;
    }
    /**
     * @private
     */
    getMinimumAndMaximumWordWidth(minimumWordWidth, maximumWordWidth) {
        return { 'minimumWordWidth': minimumWordWidth, 'maximumWordWidth': maximumWordWidth };
    }
    /**
     * @private
     */
    destroyInternal(viewer) {
        let height = this.height;
        if (!isNullOrUndefined(this.childWidgets)) {
            for (let i = 0; i < this.childWidgets.length; i++) {
                let widget = this.childWidgets[i];
                widget.destroyInternal(viewer);
                if (isNullOrUndefined(this.childWidgets)) {
                    break;
                }
                i--;
            }
            this.childWidgets = undefined;
        }
        if (!isNullOrUndefined(this.containerWidget)) {
            if (!isNullOrUndefined(this.containerWidget.childWidgets)) {
                this.containerWidget.childWidgets.splice(this.containerWidget.childWidgets.indexOf(this), 1);
                if ((isNullOrUndefined(this.containerWidget.childWidgets) || this.containerWidget.childWidgets.length === 0)
                    && this.containerWidget instanceof TableWidget) {
                    this.containerWidget.destroyInternal(viewer);
                }
                else if (this.containerWidget.containerWidget instanceof BodyWidget) {
                    this.containerWidget.containerWidget.height -= height;
                }
                this.containerWidget.height -= height;
            }
        }
        this.destroy();
    }
    /**
     * @private
     */
    clone(cloneUpToHeight) {
        let row = new TableRowWidget();
        row.rowFormat.copyFormat(this.rowFormat);
        row.topBorderWidth = this.topBorderWidth;
        row.bottomBorderWidth = this.bottomBorderWidth;
        row.isRenderBookmarkEnd = this.isRenderBookmarkEnd;
        for (let i = 0; i < this.childWidgets.length; i++) {
            let cell = this.childWidgets[i].clone(cloneUpToHeight);
            row.childWidgets.push(cell);
            cell.containerWidget = row;
            cell.index = i;
            cell.rowIndex = this.rowIndex;
        }
        row.x = this.x;
        row.y = this.y;
        row.height = this.height;
        row.width = this.width;
        if (this.contentControlProperties) {
            row.contentControlProperties = this.contentControlProperties;
        }
        return row;
    }
    /**
     * Updates the child widgets left.
     * @param left
     * @private
     */
    updateChildWidgetLeft(left, updateLeftIndent) {
        // TODO: Cell spacing calculation.
        let spacing = 0;
        if (this.ownerTable.tableFormat.cellSpacing > 0) {
            spacing = this.ownerTable.tableFormat.cellSpacing;
        }
        for (let i = 0; i < this.childWidgets.length; i++) {
            let cellWidget = this.childWidgets[i];
            left += spacing + cellWidget.margin.left;
            cellWidget.x = left;
            cellWidget.updateChildWidgetLeft(cellWidget.x);
            left += cellWidget.width + cellWidget.margin.right;
        }
    }
    /**
     * Shift the widgets for RTL table.
     * @param tableWidget
     * @private
     */
    shiftWidgetForRtlTable() {
        let tableWidget = this.ownerTable;
        let clientAreaX = tableWidget.x;
        let cellSpace = 0;
        let tableWidth = 0;
        if (tableWidget.tableFormat != null && tableWidget.tableFormat.cellSpacing > 0) {
            cellSpace = tableWidget.tableFormat.cellSpacing;
        }
        tableWidth = HelperMethods.convertPointToPixel(tableWidget.getTableWidth());
        let rowX = this.x;
        let clientAreaRight = clientAreaX + tableWidth;
        let left = clientAreaRight - (rowX - clientAreaX);
        let prevSpannedCellWidth = 0;
        for (let j = 0; j < this.childWidgets.length; j++) {
            let cellWidget = this.childWidgets[j];
            let prevColumnIndex = 0;
            if (!isNullOrUndefined(cellWidget.previousWidget)) {
                prevColumnIndex = cellWidget.previousWidget.columnIndex + cellWidget.previousWidget.cellFormat.columnSpan;
            }
            if (prevColumnIndex < cellWidget.columnIndex) {
                prevSpannedCellWidth = HelperMethods.convertPointToPixel(cellWidget.ownerTable.tableHolder.getPreviousSpannedCellWidth(prevColumnIndex, cellWidget.columnIndex));
                if (prevColumnIndex === 0) {
                    prevSpannedCellWidth = prevSpannedCellWidth - cellSpace / 2;
                }
            }
            left = left - (cellWidget.width + cellWidget.margin.left + cellWidget.margin.right + cellSpace);
            cellWidget.updateWidgetLeft(left + cellWidget.margin.left - prevSpannedCellWidth);
        }
    }
    /**
     * @private
     */
    destroy() {
        // if (this.rowFormat) {
        //     this.rowFormat.destroy();
        // }
        this.rowFormat = undefined;
        this.topBorderWidth = undefined;
        this.bottomBorderWidth = undefined;
        super.destroy();
    }
    /**
     * Disposes the internal objects which are maintained.
     * @private
     */
    componentDestroy() {
        if (this.rowFormat) {
            this.rowFormat.destroy();
        }
        this.rowFormat = undefined;
        this.topBorderWidth = undefined;
        this.bottomBorderWidth = undefined;
        this.isRenderBookmarkEnd = undefined;
        super.componentDestroy();
    }
}
/**
 * @private
 */
export class TableCellWidget extends BlockWidget {
    constructor() {
        super();
        /**
         * @private
         */
        this.rowIndex = -1;
        this.sizeInfoInternal = new ColumnSizeInfo();
        /**
         * @private
         */
        this.updatedTopBorders = [];
        /**
         * @private
         */
        this.isRenderBookmarkStart = false;
        /**
         * @private
         */
        this.isRenderBookmarkEnd = false;
        /**
         * @private
         */
        this.isRenderEditRangeStart = false;
        /**
        * @private
         */
        this.isRenderEditRangeEnd = false;
        // /**
        //  * @private
        //  */
        // get length(): number {
        //     if (!isNullOrUndefined(this.nextSplitWidget)) {
        //         return 1;
        //     } else {
        //         if (isNullOrUndefined(this.previousSplitWidget)) {
        //             return 1;
        //         }
        //         return 0;
        //     }
        // }
        /**
        * @private
         */
        this.isSplittedCell = false;
        this.margin = new Margin(this.leftMargin, this.topMargin, this.rightMargin, this.bottomMargin);
        this.leftBorderWidth = 0;
        this.rightBorderWidth = 0;
        this.cellFormat = new WCellFormat(this);
    }
    /**
     * @private
     */
    get ownerColumn() {
        return this.ownerTable.tableHolder.columns[this.columnIndex];
    }
    /**
     * @private
     */
    get leftMargin() {
        if (this.cellFormat && this.cellFormat.hasValue('leftMargin')) {
            return this.cellFormat.leftMargin;
        }
        else if (!isNullOrUndefined(this.ownerRow) && this.ownerRow.rowFormat.hasValue('leftMargin')) {
            return this.ownerRow.rowFormat.leftMargin;
        }
        else if (!isNullOrUndefined(this.ownerTable) && !isNullOrUndefined(this.ownerTable.tableFormat) && this.ownerTable.tableFormat.hasValue('leftMargin')) {
            return this.ownerTable.tableFormat.leftMargin;
        }
        else {
            return 0;
        }
    }
    /**
     * @private
     */
    get topMargin() {
        if (this.cellFormat && this.cellFormat.hasValue('topMargin')) {
            return this.cellFormat.topMargin;
        }
        else if (!isNullOrUndefined(this.ownerRow) && this.ownerRow.rowFormat.hasValue('topMargin')) {
            return this.ownerRow.rowFormat.topMargin;
        }
        else if (!isNullOrUndefined(this.ownerTable) && !isNullOrUndefined(this.ownerTable.tableFormat) && this.ownerTable.tableFormat.hasValue('topMargin')) {
            return this.ownerTable.tableFormat.topMargin;
        }
        else {
            return 0;
        }
    }
    /**
     * @private
     */
    get rightMargin() {
        if (this.cellFormat && this.cellFormat.hasValue('rightMargin')) {
            return this.cellFormat.rightMargin;
        }
        else if (!isNullOrUndefined(this.ownerRow) && this.ownerRow.rowFormat.hasValue('rightMargin')) {
            return this.ownerRow.rowFormat.rightMargin;
        }
        else if (!isNullOrUndefined(this.ownerTable) && !isNullOrUndefined(this.ownerTable.tableFormat) && this.ownerTable.tableFormat.hasValue('rightMargin')) {
            return this.ownerTable.tableFormat.rightMargin;
        }
        else {
            return 0;
        }
    }
    /**
     * @private
     */
    get bottomMargin() {
        if (this.cellFormat && this.cellFormat.hasValue('bottomMargin')) {
            return this.cellFormat.bottomMargin;
        }
        else if (!isNullOrUndefined(this.ownerRow) && this.ownerRow.rowFormat.hasValue('bottomMargin')) {
            return this.ownerRow.rowFormat.bottomMargin;
        }
        else if (!isNullOrUndefined(this.ownerTable) && !isNullOrUndefined(this.ownerTable.tableFormat) && this.ownerTable.tableFormat.hasValue('bottomMargin')) {
            return this.ownerTable.tableFormat.bottomMargin;
        }
        else {
            return 0;
        }
    }
    /**
     * @private
     */
    get cellIndex() {
        if (this.ownerRow) {
            return this.ownerRow.childWidgets.indexOf(this);
        }
        return -1;
    }
    /**
     * @private
     */
    get ownerTable() {
        if (this.containerWidget instanceof TableRowWidget) {
            return this.containerWidget.ownerTable;
        }
        return undefined;
    }
    /**
     * @private
     */
    get ownerRow() {
        return this.containerWidget;
    }
    /**
     * @private
     */
    get sizeInfo() {
        return this.sizeInfoInternal;
    }
    /**
     * @private
     */
    equals(widget) {
        return widget instanceof TableCellWidget && widget.cellFormat === this.cellFormat;
    }
    /**
     * @private
     */
    getContainerTable() {
        let table = this.ownerTable;
        while (table instanceof TableWidget && table.associatedCell instanceof TableCellWidget) {
            table = table.associatedCell.getContainerTable();
        }
        return table;
    }
    /**
     * @private
     */
    getPreviousSplitWidget() {
        if (this.containerWidget instanceof TableRowWidget) {
            let row = this.containerWidget;
            do {
                row = row.previousRenderedWidget;
                if (isNullOrUndefined(row) || row.index < this.rowIndex) {
                    break;
                }
                let previousCell = row.getCell(this.rowIndex, this.columnIndex);
                if (previousCell && this.equals(previousCell)) {
                    return previousCell;
                }
            } while (row);
        }
        return undefined;
    }
    /**
     * @private
     */
    isEmpty() {
        if (this.childWidgets.length > 1) {
            return false;
        }
        else {
            let block = this.childWidgets[0];
            if (block instanceof ParagraphWidget) {
                return block.isEmpty();
            }
            else {
                return false;
            }
        }
    }
    /**
     * @private
     */
    getNextSplitWidget() {
        let rowSpan = this.cellFormat.rowSpan;
        if (this.containerWidget instanceof TableRowWidget) {
            let row = this.containerWidget;
            do {
                row = row.nextRenderedWidget;
                if (isNullOrUndefined(row) || row.index > this.rowIndex + rowSpan) {
                    break;
                }
                let nextCell = row.getCell(this.rowIndex, this.columnIndex);
                if (nextCell && this.equals(nextCell)) {
                    return nextCell;
                }
            } while (row);
        }
        return undefined;
    }
    /**
     * @private
     */
    getTableCellWidget(point) {
        for (let i = 0; i < this.childWidgets.length; i++) {
            if (this.childWidgets[i].y <= point.y
                && (this.childWidgets[i].y + this.childWidgets[i].height) >= point.y) {
                return this.childWidgets[i].getTableCellWidget(point);
            }
        }
        let tableCellWidget = undefined;
        if (this.childWidgets.length > 0) {
            if (this.childWidgets[0].y <= point.y) {
                tableCellWidget = this.childWidgets[this.childWidgets.length - 1].getTableCellWidget(point);
            }
            else {
                tableCellWidget = this.childWidgets[0].getTableCellWidget(point);
            }
        }
        return tableCellWidget;
    }
    /**
     * @private
     */
    updateWidth(preferredWidth) {
        if (this.cellFormat.preferredWidthType === 'Point') {
            this.cellFormat.preferredWidth = preferredWidth;
        }
        else if (this.cellFormat.preferredWidthType === 'Percent') {
            this.cellFormat.preferredWidth = this.convertPointToPercent(preferredWidth);
        }
        this.cellFormat.cellWidth = preferredWidth;
    }
    /**
     * @private
     */
    getCellWidth(block) {
        let ownerTable = this.ownerTable;
        let containerWidth = ownerTable ? ownerTable.getTableClientWidth(ownerTable.getOwnerWidth(true)) : 0;
        let cellWidth = containerWidth;
        let leftMargin = !isNullOrUndefined(this.leftMargin) ? this.leftMargin : 0;
        let rightMargin = !isNullOrUndefined(this.rightMargin) ? this.rightMargin : 0;
        if (ownerTable && ownerTable.tableFormat.preferredWidthType === 'Auto' && ownerTable.tableFormat.allowAutoFit) {
            if (this.cellFormat.preferredWidth === 0) {
                cellWidth = containerWidth;
            }
            else {
                if (this.cellFormat.preferredWidthType === 'Percent') {
                    cellWidth = (this.cellFormat.preferredWidth * containerWidth) / 100 - leftMargin - rightMargin;
                }
                else {
                    // If cell has prefferd width, we need to consider prefferd width.
                    cellWidth = this.cellFormat.preferredWidth - leftMargin - rightMargin;
                    // If cell prefferd width exceeds container width, we need to consider container width
                    if (containerWidth < cellWidth) {
                        cellWidth = containerWidth;
                    }
                }
            }
        }
        else if (this.cellFormat.preferredWidthType === 'Percent') {
            cellWidth = (this.cellFormat.preferredWidth * containerWidth) / 100 - leftMargin - rightMargin;
        }
        else if (this.cellFormat.preferredWidthType === 'Point') {
            if (block instanceof TableWidget && block.tableFormat.preferredWidthType === 'Percent') {
                cellWidth = this.cellFormat.cellWidth - leftMargin - rightMargin;
            }
            else {
                cellWidth = this.cellFormat.preferredWidth - leftMargin - rightMargin;
            }
        }
        else if (!isNullOrUndefined(ownerTable) && ownerTable.tableFormat.preferredWidthType === 'Percent' && ownerTable.tableFormat.allowAutoFit && this.cellFormat.preferredWidthType === 'Auto' && block instanceof TableWidget && block.tableFormat.preferredWidthType === 'Percent' && block.tableFormat.allowAutoFit) {
            cellWidth = this.cellFormat.cellWidth - leftMargin - rightMargin;
        }
        // For grid before and grid after with auto width, no need to calculate minimum preferred width.
        return cellWidth;
    }
    /**
     * @private
     */
    convertPointToPercent(cellPreferredWidth) {
        let value = 0;
        let clientWidth = this.ownerTable.getOwnerWidth(true);
        let tableWidth = this.ownerTable.getTableClientWidth(clientWidth);
        value = (cellPreferredWidth / tableWidth) * 100;
        value = Math.round(value);
        return value < 100 ? value : 100; // The value should be lesser than or equal to 100%;
    }
    /**
     * @private
     */
    static getCellLeftBorder(tableCell) {
        let leftBorder = undefined;
        let cellBorder = tableCell.cellFormat.borders;
        let rowBorders = !isNullOrUndefined(tableCell.ownerRow) ? tableCell.ownerRow.rowFormat.borders : undefined;
        let tableBorders = !isNullOrUndefined(tableCell.ownerTable) ? tableCell.ownerTable.tableFormat.borders : undefined;
        if (!isNullOrUndefined(cellBorder.left)) {
            leftBorder = cellBorder.left;
        }
        if (isNullOrUndefined(leftBorder)) {
            leftBorder = tableCell.getLeftBorderToRenderByHierarchy(leftBorder, rowBorders, tableBorders);
        }
        if (tableCell.ownerTable.tableFormat.cellSpacing > 0) {
            leftBorder = tableCell.getLeftBorderToRenderByHierarchy(leftBorder, rowBorders, tableBorders);
        }
        else {
            let prevCell = this.getPreviousCell(tableCell);
            // if the border is shared then choose the border based on Conflict Resolution algorithm.
            leftBorder = tableCell.getPreviousCellLeftBorder(leftBorder, prevCell);
        }
        if (isNullOrUndefined(leftBorder)) {
            leftBorder = new WBorder(tableCell.cellFormat.borders);
        }
        return leftBorder;
    }
    static getPreviousCell(tableCell) {
        let prevCell = undefined;
        if (!isNullOrUndefined(tableCell.previousWidget)) {
            //Validates whether the previous cell in same row is adjacent left cell and sets to prevCell.
            //If the previous cell is not in the same row and it is vertically merged, we have handled in serverside
            //to copy border based on priority of current cell left border and previous cell right border.
            let cell = tableCell.previousWidget;
            if (cell.columnIndex + cell.cellFormat.columnSpan === tableCell.columnIndex) {
                prevCell = cell;
            }
        }
        return prevCell;
    }
    /**
     * @private
     */
    getLeftBorderWidth() {
        let borderWidth = 0;
        // Added null condition check for asynchronous loading.
        if (this.cellFormat !== null && this.cellFormat.borders !== null) {
            // update the margins values respect to layouting of borders.
            // For normal table cells only left border is rendered. for last cell left and right border is rendered.
            // this border widths are not included in margins.
            borderWidth = TableCellWidget.getCellLeftBorder(this).getLineWidth();
            // need to render rightBorder specifically for all the cells when the cellSpacing is greater than zero or for last cell of each row.
        }
        return borderWidth;
    }
    /**
     * @private
     */
    getRightBorderWidth() {
        let borderWidth = 0;
        let ownerTable = this.ownerTable;
        //Added null condition check for asynchronous loading.
        if (this.cellFormat !== null && this.cellFormat.borders !== null) {
            borderWidth = TableCellWidget.getCellRightBorder(this).getLineWidth();
        }
        return borderWidth;
    }
    /**
     * @private
     */
    getCellSpacing() {
        let actualCellSpacing = this.ownerTable && this.ownerTable.tableFormat ? this.ownerTable.tableFormat.cellSpacing : 0;
        let cellSpacingToLayout = actualCellSpacing;
        // Considers the left, right margins and border widths(only available for Layouted table) for Minimum width.
        if (this.ownerRow.childWidgets.length === 1) {
            cellSpacingToLayout = actualCellSpacing * 2;
        }
        else if (this.cellIndex === 0 || this.cellIndex === this.ownerRow.childWidgets.length - 1) {
            cellSpacingToLayout = actualCellSpacing + (actualCellSpacing / 2);
        }
        else {
            cellSpacingToLayout = actualCellSpacing;
        }
        return cellSpacingToLayout;
    }
    /**
     * @private
     */
    getCellSizeInfo(isAutoFit) {
        let isSetWidth = true;
        let layout = undefined;
        if (!isNullOrUndefined(this.bodyWidget) && !isNullOrUndefined(this.bodyWidget.page)) {
            if (!isNullOrUndefined(this.bodyWidget.page.documentHelper)) {
                layout = this.bodyWidget.page.documentHelper.layout;
            }
        }
        if (!isNullOrUndefined(layout) && !isNullOrUndefined(layout.currentCell)) {
            isSetWidth = false;
            if (this === layout.currentCell) {
                isSetWidth = true;
            }
        }
        // Gets the minimum preferred width for the table cell.
        if (isSetWidth && !this.sizeInfo.hasMinimumWidth) {
            this.sizeInfo.minimumWidth = this.getMinimumPreferredWidth();
        }
        // Gets the minimum and maximum word widths.
        if (isAutoFit) {
            if (isSetWidth && !this.sizeInfo.hasMinimumWordWidth) {
                let size = this.getMinimumAndMaximumWordWidth(0, 0);
                this.sizeInfo.minimumWordWidth = size.minimumWordWidth + this.sizeInfo.minimumWidth;
                this.sizeInfo.maximumWordWidth = size.maximumWordWidth + this.sizeInfo.minimumWidth;
                // if minimum and maximum width values are equal, set value as zero.
                // later, preferred width value is considered for all width values.
                // if (this.sizeInfo.minimumWidth === this.sizeInfo.minimumWordWidth
                //     && this.sizeInfo.minimumWordWidth === this.sizeInfo.maximumWordWidth) {
                //     this.sizeInfo.minimumWordWidth = 0;
                //     this.sizeInfo.maximumWordWidth = 0;
                //     this.sizeInfo.minimumWidth = 0;
                // }
            }
        }
        let sizeInfo = new ColumnSizeInfo();
        sizeInfo.minimumWidth = this.sizeInfo.minimumWidth;
        sizeInfo.minimumWordWidth = this.sizeInfo.minimumWordWidth;
        sizeInfo.maximumWordWidth = this.sizeInfo.maximumWordWidth;
        return sizeInfo;
    }
    /**
     * @private
     */
    getMinimumPreferredWidth() {
        let defaultWidth = this.leftMargin + this.rightMargin + this.getLeftBorderWidth() + this.getRightBorderWidth() + this.getCellSpacing();
        return defaultWidth;
    }
    /**
     * @private
     */
    getPreviousCellLeftBorder(leftBorder, previousCell) {
        let isLeftBorderChanged = false;
        if ((isNullOrUndefined(previousCell) || (!isNullOrUndefined(leftBorder) && (leftBorder.lineStyle === 'None' && !leftBorder.hasNoneStyle)))) {
            if (!isNullOrUndefined(leftBorder) && !(leftBorder.ownerBase.ownerBase instanceof WTableFormat)) {
                leftBorder = this.getLeftBorderToRenderByHierarchy(leftBorder, TableRowWidget.getRowOf(leftBorder.ownerBase).rowFormat.borders, TableWidget.getTableOf(leftBorder.ownerBase).tableFormat.borders);
                isLeftBorderChanged = true;
            }
        }
        if (isNullOrUndefined(previousCell)) {
            return leftBorder;
        }
        else {
            let prevCellRightBorder = undefined;
            if (!isNullOrUndefined(previousCell.cellFormat.borders) && !isNullOrUndefined(previousCell.cellFormat.borders.right) && previousCell.cellFormat.borders.right.lineStyle !== 'None') {
                prevCellRightBorder = previousCell.cellFormat.borders.right;
            }
            if (!isNullOrUndefined(prevCellRightBorder) && prevCellRightBorder.lineStyle !== 'None') {
                return this.getBorderBasedOnPriority(prevCellRightBorder, leftBorder);
            }
            else if (!isNullOrUndefined(leftBorder) && !(leftBorder.ownerBase.ownerBase instanceof WTableFormat) && !isLeftBorderChanged) {
                return this.getLeftBorderToRenderByHierarchy(leftBorder, TableRowWidget.getRowOf(leftBorder.ownerBase).rowFormat.borders, TableWidget.getTableOf(leftBorder.ownerBase).tableFormat.borders);
            }
        }
        return leftBorder;
    }
    /**
     * @private
     */
    getBorderBasedOnPriority(border, adjacentBorder) {
        // If the cell and its adjacent cell defined different borders then based on this algorithm the border choose to render.
        // Reference link :https://msdn.microsoft.com/en-us/library/office/documentformat.openxml.wordprocessing.tablecellborders.aspx
        if (isNullOrUndefined(border)) {
            return adjacentBorder;
        }
        else if (isNullOrUndefined(adjacentBorder)) {
            return border;
        }
        let borderWeight = border.getBorderWeight();
        let adjacentBorderWeight = adjacentBorder.getBorderWeight();
        //the border with higher wight  shall be displayed.
        if (borderWeight === adjacentBorderWeight) {
            //if the border is equal weight the based on the priority the border will be choosen to render.
            let borderPriority = border.getPrecedence();
            let adjacentBorderPriority = adjacentBorder.getPrecedence();
            if (borderPriority === adjacentBorderPriority) {
                //The color with the smaller brightness value shall be displayed.
                let borderColInRGB = HelperMethods.convertHexToRgb(border.color);
                let R1 = borderColInRGB.r;
                let G1 = borderColInRGB.g;
                let B1 = borderColInRGB.b;
                let adjacentBorderColInRGB = HelperMethods.convertHexToRgb(adjacentBorder.color);
                let R2 = adjacentBorderColInRGB.r;
                let G2 = adjacentBorderColInRGB.g;
                let B2 = adjacentBorderColInRGB.b;
                let borderBrightness = (R1 + B1 + (2 * G1));
                let adjacentBorderBrightness = (R2 + B2 + (2 * G2));
                if (borderBrightness === adjacentBorderBrightness) {
                    borderBrightness = (B1 + (2 * G1));
                    adjacentBorderBrightness = (B2 + (2 * G2));
                    if (borderBrightness === adjacentBorderBrightness) {
                        if (G1 === G2) {
                            return border;
                        }
                        else if (G1 > G2) {
                            return adjacentBorder;
                        }
                        else {
                            return border;
                        }
                    }
                    else if (borderBrightness > adjacentBorderBrightness) {
                        return adjacentBorder;
                    }
                    else {
                        return border;
                    }
                }
                else if (borderBrightness > adjacentBorderBrightness) {
                    return adjacentBorder;
                }
                else {
                    return border;
                }
            }
            else if (borderPriority > adjacentBorderPriority) {
                return border;
            }
            else {
                return adjacentBorder;
            }
        }
        else if (borderWeight > adjacentBorderWeight) {
            return border;
        }
        else {
            return adjacentBorder;
        }
    }
    /**
     * @private
     */
    getLeftBorderToRenderByHierarchy(leftBorder, rowBorders, tableBorders) {
        let ownerCell = TableCellWidget.getCellOf(leftBorder.ownerBase);
        if (!isNullOrUndefined(ownerCell)) {
            let isFirstCell = false;
            if (ownerCell.columnIndex === 0 || (ownerCell.cellIndex === 0 && ownerCell.ownerRow.rowFormat.gridBefore > 0)) {
                isFirstCell = true;
            }
            let isRowBorderDefined = false;
            let hasNoneStyle = false;
            if (isFirstCell && !isNullOrUndefined(rowBorders.left)) {
                hasNoneStyle = rowBorders.left.hasNoneStyle;
            }
            else if (!isFirstCell && !isNullOrUndefined(rowBorders.vertical)) {
                hasNoneStyle = rowBorders.vertical.hasNoneStyle;
            }
            if (!isNullOrUndefined(rowBorders.left) && rowBorders.left.lineStyle !== 'None'
                && rowBorders.left.isBorderDefined && !hasNoneStyle && !isNullOrUndefined(leftBorder)
                && leftBorder.lineStyle === 'None' && leftBorder.isBorderDefined && !leftBorder.hasValue('color')) {
                isRowBorderDefined = true;
            }
            if ((!isNullOrUndefined(leftBorder) && leftBorder.lineStyle === 'None' && ((!leftBorder.isBorderDefined && !hasNoneStyle) || isRowBorderDefined)) || isNullOrUndefined(leftBorder)) {
                if (isFirstCell) {
                    leftBorder = rowBorders.left;
                    if ((!isNullOrUndefined(leftBorder) && leftBorder.lineStyle === 'None') || isNullOrUndefined(leftBorder)) {
                        leftBorder = tableBorders.left;
                    }
                }
                else {
                    leftBorder = rowBorders.vertical;
                    if ((!isNullOrUndefined(leftBorder) && leftBorder.lineStyle === 'None') || isNullOrUndefined(leftBorder)) {
                        leftBorder = tableBorders.vertical;
                    }
                }
            }
        }
        return leftBorder;
    }
    /**
     * @private
     */
    static getCellRightBorder(tableCell) {
        let rightBorder = undefined;
        let cellBorder = tableCell.cellFormat.borders;
        let rowBorders = !isNullOrUndefined(tableCell.ownerRow) ? tableCell.ownerRow.rowFormat.borders : undefined;
        let tableBorders = !isNullOrUndefined(tableCell.ownerTable) ? tableCell.ownerTable.tableFormat.borders : undefined;
        if (!isNullOrUndefined(cellBorder.right)) {
            rightBorder = cellBorder.right;
        }
        if (isNullOrUndefined(rightBorder)) {
            rightBorder = tableCell.getRightBorderToRenderByHierarchy(rightBorder, rowBorders, tableBorders);
        }
        if (tableCell.ownerTable.tableFormat.cellSpacing > 0) {
            rightBorder = tableCell.getRightBorderToRenderByHierarchy(rightBorder, rowBorders, tableBorders);
        }
        else {
            let nextCell = this.getNextCell(tableCell);
            // if the border is shared then choose the border based on Conflict Resolution algorithm.
            rightBorder = tableCell.getAdjacentCellRightBorder(rightBorder, nextCell);
        }
        if (isNullOrUndefined(rightBorder)) {
            rightBorder = new WBorder(tableCell.cellFormat.borders);
        }
        return rightBorder;
    }
    static getNextCell(tableCell) {
        let nextCell = undefined;
        let columnSpan = tableCell.cellFormat.columnSpan;
        if (!isNullOrUndefined(tableCell.nextWidget)) {
            //Validates whether the next cell in same row is adjacent right cell and sets to nextCell.
            //If the next cell is not in the same row and it is vertically merged, we have handled in serverside
            //to copy border based on priority of current cell right border and next cell left border.
            let cell = tableCell.nextWidget;
            if (tableCell.columnIndex + columnSpan === cell.columnIndex) {
                nextCell = cell;
            }
        }
        return nextCell;
    }
    /**
     * @private
     */
    getAdjacentCellRightBorder(rightBorder, nextCell) {
        let isRightBorderChanged = false;
        if (isNullOrUndefined(nextCell) || (!isNullOrUndefined(rightBorder) && (rightBorder.lineStyle === 'None' && !rightBorder.hasNoneStyle))) {
            if (!isNullOrUndefined(rightBorder) && !(rightBorder.ownerBase.ownerBase instanceof WTableFormat)) {
                rightBorder = this.getRightBorderToRenderByHierarchy(rightBorder, TableRowWidget.getRowOf(rightBorder.ownerBase).rowFormat.borders, TableWidget.getTableOf(rightBorder.ownerBase).tableFormat.borders);
                isRightBorderChanged = true;
            }
        }
        if (isNullOrUndefined(nextCell)) {
            return rightBorder;
        }
        else {
            let nextCellLeftBorder = undefined;
            if (!isNullOrUndefined(nextCell.cellFormat.borders) && !isNullOrUndefined(nextCell.cellFormat.borders.left) && nextCell.cellFormat.borders.left.lineStyle !== 'None') {
                nextCellLeftBorder = nextCell.cellFormat.borders.left;
            }
            if (!isNullOrUndefined(nextCellLeftBorder) && nextCellLeftBorder.lineStyle !== 'None') {
                return this.getBorderBasedOnPriority(rightBorder, nextCellLeftBorder);
            }
            else if (!isNullOrUndefined(rightBorder) && !(rightBorder.ownerBase.ownerBase instanceof WTableFormat) && !isRightBorderChanged) {
                return this.getRightBorderToRenderByHierarchy(rightBorder, TableRowWidget.getRowOf(rightBorder.ownerBase).rowFormat.borders, TableWidget.getTableOf(rightBorder.ownerBase).tableFormat.borders);
            }
        }
        return rightBorder;
    }
    /**
     * @private
     */
    getRightBorderToRenderByHierarchy(rightBorder, rowBorders, tableBorders) {
        let ownerCell = TableCellWidget.getCellOf(rightBorder.ownerBase);
        if (!isNullOrUndefined(ownerCell)) {
            let isLastCell = false;
            //Have to check lastcell logic
            if ((ownerCell.columnIndex + ownerCell.cellFormat.columnSpan) === ownerCell.ownerTable.tableHolder.columns.length
                || (ownerCell.cellIndex === ownerCell.ownerRow.childWidgets.length - 1)) {
                isLastCell = true;
            }
            let isRowBorderDefined = false;
            let hasNoneStyle = false;
            if (isLastCell && !isNullOrUndefined(rowBorders.right)) {
                hasNoneStyle = rowBorders.right.hasNoneStyle;
            }
            else if (!isLastCell && !isNullOrUndefined(rowBorders.vertical)) {
                hasNoneStyle = rowBorders.vertical.hasNoneStyle;
            }
            if (!isNullOrUndefined(rowBorders.right) && rowBorders.right.lineStyle !== 'None'
                && rowBorders.right.isBorderDefined && !hasNoneStyle && !isNullOrUndefined(rightBorder) && rightBorder.lineStyle === 'None'
                && rightBorder.isBorderDefined && !rightBorder.hasValue('color')) {
                isRowBorderDefined = true;
            }
            if ((!isNullOrUndefined(rightBorder) && rightBorder.lineStyle === 'None' && ((!rightBorder.isBorderDefined && !hasNoneStyle) || isRowBorderDefined)) || isNullOrUndefined(rightBorder)) {
                if (isLastCell) {
                    rightBorder = rowBorders.right;
                    if ((!isNullOrUndefined(rightBorder) && rightBorder.lineStyle === 'None') || isNullOrUndefined(rightBorder)) {
                        rightBorder = tableBorders.right;
                    }
                }
                else {
                    rightBorder = rowBorders.vertical;
                    if ((!isNullOrUndefined(rightBorder) && rightBorder.lineStyle === 'None') || isNullOrUndefined(rightBorder)) {
                        rightBorder = tableBorders.vertical;
                    }
                }
            }
        }
        return rightBorder;
    }
    /**
     * @private
     */
    static getCellTopBorder(tableCell) {
        let topBorder = undefined;
        let cellBorder = tableCell.cellFormat.borders;
        let rowBorders = !isNullOrUndefined(tableCell.ownerRow) ? tableCell.ownerRow.rowFormat.borders : undefined;
        let tableBorders = !isNullOrUndefined(tableCell.ownerTable) ? tableCell.ownerTable.tableFormat.borders : undefined;
        if (!isNullOrUndefined(cellBorder.top)) {
            topBorder = cellBorder.top;
        }
        if (isNullOrUndefined(topBorder)) {
            topBorder = tableCell.getTopBorderToRenderByHierarchy(topBorder, rowBorders, tableBorders);
        }
        if (tableCell.ownerTable.tableFormat.cellSpacing > 0) {
            topBorder = tableCell.getTopBorderToRenderByHierarchy(topBorder, rowBorders, tableBorders);
        }
        else {
            let prevTopCell = tableCell.getTopAdjacentCell();
            //If the border is shared then choose the border based on Conflict Resolution algorithm.
            topBorder = tableCell.getPreviousCellTopBorder(topBorder, prevTopCell);
        }
        if (isNullOrUndefined(topBorder)) {
            topBorder = new WBorder(tableCell.cellFormat.borders);
        }
        return topBorder;
    }
    getTopAdjacentCell() {
        let previousRow = this.ownerRow.previousWidget;
        let cell;
        if (!isNullOrUndefined(previousRow)) {
            cell = previousRow.getVerticalMergeStartCell(this.columnIndex, this.cellFormat.columnSpan);
        }
        return cell;
    }
    /**
     * @private
     */
    getPreviousCellTopBorder(topBorder, previousTopCell) {
        let isTopBorderChanged = false;
        if (isNullOrUndefined(previousTopCell) || (!isNullOrUndefined(topBorder) && (topBorder.lineStyle === 'None' && !topBorder.hasNoneStyle))) {
            if (!isNullOrUndefined(topBorder) && !(topBorder.ownerBase.ownerBase instanceof WTableFormat)) {
                topBorder = this.getTopBorderToRenderByHierarchy(topBorder, TableRowWidget.getRowOf(topBorder.ownerBase).rowFormat.borders, TableWidget.getTableOf(topBorder.ownerBase).tableFormat.borders);
                isTopBorderChanged = true;
            }
        }
        if (isNullOrUndefined(previousTopCell)) {
            return topBorder;
        }
        else {
            let prevTopCellBottomBorder = undefined;
            if (!isNullOrUndefined(previousTopCell.cellFormat.borders) && !isNullOrUndefined(previousTopCell.cellFormat.borders.bottom)) {
                prevTopCellBottomBorder = this.getBottomBorderToRenderByHierarchy(previousTopCell.cellFormat.borders.bottom, previousTopCell.ownerRow.rowFormat.borders, previousTopCell.ownerTable.tableFormat.borders);
            }
            if (!isNullOrUndefined(prevTopCellBottomBorder) && prevTopCellBottomBorder.lineStyle !== 'None') {
                return this.getBorderBasedOnPriority(topBorder, prevTopCellBottomBorder);
            }
            else if (!isNullOrUndefined(topBorder) && !(topBorder.ownerBase.ownerBase instanceof WTableFormat) && !isTopBorderChanged) {
                return this.getTopBorderToRenderByHierarchy(topBorder, TableRowWidget.getRowOf(topBorder.ownerBase).rowFormat.borders, TableWidget.getTableOf(topBorder.ownerBase).tableFormat.borders);
            }
        }
        return topBorder;
    }
    /**
     * @private
     */
    getTopBorderToRenderByHierarchy(topBorder, rowBorders, tableBorders) {
        let ownerCell = TableCellWidget.getCellOf(topBorder.ownerBase);
        if (!isNullOrUndefined(ownerCell)) {
            let isFirstRow = isNullOrUndefined(ownerCell.ownerRow.previousWidget);
            let isRowBorderDefined = false;
            let hasNoneStyle = false;
            if (isFirstRow && !isNullOrUndefined(rowBorders.top)) {
                hasNoneStyle = rowBorders.top.hasNoneStyle;
            }
            else if (!isFirstRow && !isNullOrUndefined(rowBorders.horizontal)) {
                hasNoneStyle = rowBorders.horizontal.hasNoneStyle;
            }
            if (!isNullOrUndefined(rowBorders.top) && rowBorders.top.lineStyle !== 'None'
                && rowBorders.top.isBorderDefined && !hasNoneStyle && !isNullOrUndefined(topBorder)
                && topBorder.lineStyle === 'None' && topBorder.isBorderDefined && !topBorder.hasValue('color')) {
                isRowBorderDefined = true;
            }
            if ((!isNullOrUndefined(topBorder) && topBorder.lineStyle === 'None' && ((!topBorder.isBorderDefined && !hasNoneStyle) || isRowBorderDefined)) || isNullOrUndefined(topBorder)) {
                if (isFirstRow) {
                    topBorder = rowBorders.top;
                    if ((!isNullOrUndefined(topBorder) && topBorder.lineStyle === 'None') || isNullOrUndefined(topBorder)) {
                        topBorder = tableBorders.top;
                    }
                }
                else {
                    topBorder = rowBorders.horizontal;
                    if ((!isNullOrUndefined(topBorder) && topBorder.lineStyle === 'None') || isNullOrUndefined(topBorder)) {
                        topBorder = tableBorders.horizontal;
                    }
                }
            }
        }
        return topBorder;
    }
    /**
     * @private
     */
    static getCellBottomBorder(tableCell) {
        let bottomBorder = undefined;
        let cellBorder = tableCell.cellFormat.borders;
        let rowBorders = !isNullOrUndefined(tableCell.ownerRow) ? tableCell.ownerRow.rowFormat.borders : undefined;
        let tableBorders = !isNullOrUndefined(tableCell.ownerTable) ? tableCell.ownerTable.tableFormat.borders : undefined;
        if (!isNullOrUndefined(cellBorder.bottom)) {
            bottomBorder = cellBorder.bottom;
        }
        if (isNullOrUndefined(bottomBorder)) {
            bottomBorder = tableCell.getBottomBorderToRenderByHierarchy(bottomBorder, rowBorders, tableBorders); // select the left border based on heirarchy.
        }
        if (tableCell.ownerTable.tableFormat.cellSpacing > 0) {
            bottomBorder = tableCell.getBottomBorderToRenderByHierarchy(bottomBorder, rowBorders, tableBorders);
        }
        else {
            let nextBottomCell = undefined;
            let nextRow = undefined;
            let rowSpan = tableCell.cellFormat.rowSpan;
            if (rowSpan === 1) {
                nextRow = tableCell.ownerRow.nextWidget;
            }
            else if (rowSpan > 1) {
                let row = tableCell.containerWidget;
                do {
                    row = row.nextWidget;
                    if (isNullOrUndefined(row)) {
                        break;
                    }
                    else if (row.index === tableCell.rowIndex + rowSpan) {
                        nextRow = row;
                        break;
                    }
                } while (row);
            }
            if (!isNullOrUndefined(nextRow)) {
                nextBottomCell = nextRow.getCellWidget(tableCell.columnIndex, tableCell.cellFormat.columnSpan);
            }
            //If the border is shared then choose the border based on Conflict Resolution algorithm.
            bottomBorder = tableCell.getAdjacentCellBottomBorder(bottomBorder, nextBottomCell);
        }
        if (isNullOrUndefined(bottomBorder)) {
            bottomBorder = new WBorder(tableCell.cellFormat.borders);
        }
        return bottomBorder;
    }
    /**
     * @private
     */
    getAdjacentCellBottomBorder(bottomBorder, nextBottomCell) {
        let isBottomBorderChanged = false;
        if (isNullOrUndefined(nextBottomCell) || (!isNullOrUndefined(bottomBorder) && (bottomBorder.lineStyle === 'None' && !bottomBorder.hasNoneStyle))) {
            if (!isNullOrUndefined(bottomBorder) && !(bottomBorder.ownerBase.ownerBase instanceof WTableFormat)) {
                bottomBorder = this.getBottomBorderToRenderByHierarchy(bottomBorder, TableRowWidget.getRowOf(bottomBorder.ownerBase).rowFormat.borders, TableWidget.getTableOf(bottomBorder.ownerBase).tableFormat.borders);
                isBottomBorderChanged = true;
            }
        }
        if (isNullOrUndefined(nextBottomCell)) {
            return bottomBorder;
        }
        else {
            let prevBottomCellTopBorder = undefined;
            if (!isNullOrUndefined(nextBottomCell.cellFormat.borders) && !isNullOrUndefined(nextBottomCell.cellFormat.borders.top) && nextBottomCell.cellFormat.borders.top.lineStyle !== 'None') {
                prevBottomCellTopBorder = nextBottomCell.cellFormat.borders.top;
            }
            if (!isNullOrUndefined(prevBottomCellTopBorder) && prevBottomCellTopBorder.lineStyle !== 'None') {
                return this.getBorderBasedOnPriority(bottomBorder, prevBottomCellTopBorder);
            }
            else if (!isNullOrUndefined(bottomBorder) && !(bottomBorder.ownerBase.ownerBase instanceof WTableFormat) && !isBottomBorderChanged) {
                return this.getBottomBorderToRenderByHierarchy(bottomBorder, TableRowWidget.getRowOf(bottomBorder.ownerBase).rowFormat.borders, TableWidget.getTableOf(bottomBorder.ownerBase).tableFormat.borders);
            }
        }
        return bottomBorder;
    }
    /**
     * @private
     */
    getBottomBorderToRenderByHierarchy(bottomBorder, rowBorders, tableBorders) {
        let ownerCell = TableCellWidget.getCellOf(bottomBorder.ownerBase);
        if (!isNullOrUndefined(ownerCell)) {
            let isLastRow = isNullOrUndefined(ownerCell.ownerRow.nextWidget);
            let isRowBorderDefined = false;
            let hasNoneStyle = false;
            if (isLastRow && !isNullOrUndefined(rowBorders.bottom)) {
                hasNoneStyle = rowBorders.bottom.hasNoneStyle;
            }
            else if (!isLastRow && !isNullOrUndefined(rowBorders.horizontal)) {
                hasNoneStyle = rowBorders.horizontal.hasNoneStyle;
            }
            if (!isNullOrUndefined(rowBorders.bottom) && rowBorders.bottom.lineStyle !== 'None'
                && rowBorders.bottom.isBorderDefined && !hasNoneStyle && !isNullOrUndefined(bottomBorder)
                && bottomBorder.lineStyle === 'None' && bottomBorder.isBorderDefined && !bottomBorder.hasValue('color')) {
                isRowBorderDefined = true;
            }
            if ((!isNullOrUndefined(bottomBorder) && bottomBorder.lineStyle === 'None' && ((!bottomBorder.isBorderDefined && !hasNoneStyle) || isRowBorderDefined)) || isNullOrUndefined(bottomBorder)) {
                if (isLastRow) {
                    bottomBorder = rowBorders.bottom;
                    if ((!isNullOrUndefined(bottomBorder) && bottomBorder.lineStyle === 'None') || isNullOrUndefined(bottomBorder)) {
                        bottomBorder = tableBorders.bottom;
                    }
                }
                else {
                    bottomBorder = rowBorders.horizontal;
                    if ((!isNullOrUndefined(bottomBorder) && bottomBorder.lineStyle === 'None') || isNullOrUndefined(bottomBorder)) {
                        bottomBorder = tableBorders.horizontal;
                    }
                }
            }
        }
        return bottomBorder;
    }
    /**
     * @private
     */
    static getCellOf(node) {
        if (node instanceof WBorders) {
            if (node.ownerBase instanceof WCellFormat && node.ownerBase.ownerBase instanceof TableCellWidget) {
                return node.ownerBase.ownerBase;
            }
            else {
                return undefined;
            }
        }
        return undefined;
    }
    /**
     * Updates the Widget left.
     * @private
     */
    updateWidgetLeft(x) {
        this.x = x;
        this.updateChildWidgetLeft(x);
    }
    /**
     * @private
     */
    updateChildWidgetLeft(left) {
        for (let i = 0; i < this.childWidgets.length; i++) {
            let widget = this.childWidgets[i];
            widget.x = left;
            if (widget instanceof ParagraphWidget) {
                const leftIndent = HelperMethods.convertPointToPixel(widget.leftIndent);
                const rightIndent = HelperMethods.convertPointToPixel(widget.rightIndent);
                if (widget.isInsideTable && widget.associatedCell.ownerTable.isBidiTable && this.bodyWidget.page.documentHelper.layout.isNeedToUpdateXPositionForEmptyParagraph(widget)) {
                    const tableCellWidth = widget.associatedCell.width;
                    const paragraphMarkWidth = this.bodyWidget.page.documentHelper.textHelper.getParagraphMarkWidth(widget.characterFormat);
                    widget.x += tableCellWidth - paragraphMarkWidth - leftIndent;
                }
                else {
                    widget.x = left + (widget.bidi ? rightIndent : leftIndent);
                }
            }
            if (widget instanceof TableWidget) {
                let tableWidget = widget;
                tableWidget.updateChildWidgetLeft(left);
                if (tableWidget.isBidiTable) {
                    let clientArea = new Rect(tableWidget.x, tableWidget.y, tableWidget.width, tableWidget.height);
                    tableWidget.shiftWidgetsForRtlTable(clientArea, tableWidget);
                }
            }
        }
    }
    /**
     * @private
     */
    getMinimumAndMaximumWordWidth(minimumWordWidth, maximumWordWidth) {
        for (let i = 0; i < this.childWidgets.length; i++) {
            let block = this.childWidgets[i];
            let widthInfo = block.getMinimumAndMaximumWordWidth(minimumWordWidth, maximumWordWidth);
            minimumWordWidth = widthInfo.minimumWordWidth;
            maximumWordWidth = widthInfo.maximumWordWidth;
        }
        return { 'minimumWordWidth': minimumWordWidth, 'maximumWordWidth': maximumWordWidth };
    }
    /**
     * @private
     */
    destroyInternal(viewer) {
        // let viewer: LayoutViewer = undefined;
        // let page: Page = this.getPage();
        // if (!isNullOrUndefined(page ))
        //     viewer = page.viewer;
        if (!isNullOrUndefined(this.childWidgets)) {
            for (let i = 0; i < this.childWidgets.length; i++) {
                let widget = this.childWidgets[i];
                if (widget instanceof ParagraphWidget) {
                    widget.destroyInternal(viewer);
                }
                else {
                    widget.destroyInternal(viewer);
                }
                i--;
            }
            this.childWidgets = undefined;
            if (!isNullOrUndefined(viewer.documentHelper.selection)) {
                if (viewer.documentHelper.selection.selectedWidgets.containsKey(this)) {
                    viewer.documentHelper.selection.selectedWidgets.remove(this);
                }
            }
        }
        this.destroy();
    }
    /**
     * @private
     */
    clone(cloneUpToHeight) {
        let cell = new TableCellWidget();
        cell.cellFormat.copyFormat(this.cellFormat);
        let blockHeight = 0;
        for (let i = 0; i < this.childWidgets.length; i++) {
            if (cloneUpToHeight && blockHeight > this.height) {
                break;
            }
            let block = this.childWidgets[i].clone();
            cell.childWidgets.push(block);
            block.containerWidget = cell;
            block.index = i;
            blockHeight += block.height;
        }
        cell.leftBorderWidth = this.leftBorderWidth;
        cell.rightBorderWidth = this.rightBorderWidth;
        cell.isRenderBookmarkEnd = this.isRenderBookmarkEnd;
        cell.isRenderBookmarkStart = this.isRenderBookmarkStart;
        if (this.margin) {
            cell.margin = this.margin.clone();
        }
        cell.columnIndex = this.columnIndex;
        cell.x = this.x;
        cell.y = this.y;
        cell.height = this.height;
        cell.width = this.width;
        if (this.contentControlProperties) {
            cell.contentControlProperties = this.contentControlProperties;
        }
        return cell;
    }
    /**
     * @private
     */
    destroy() {
        // if (this.cellFormat) {
        //     this.cellFormat.destroy();
        // }
        this.cellFormat = undefined;
        this.rowIndex = undefined;
        this.columnIndex = undefined;
        this.isSplittedCell = undefined;
        super.destroy();
    }
    /**
     * Disposes the internal objects which are maintained.
     * @private
     */
    componentDestroy() {
        if (this.cellFormat) {
            this.cellFormat.destroy();
        }
        this.cellFormat = undefined;
        this.contentControlProperties = undefined;
        this.rowIndex = undefined;
        this.columnIndex = undefined;
        this.isRenderBookmarkStart = undefined;
        this.isRenderBookmarkEnd = undefined;
        super.componentDestroy();
    }
}
/**
 * @private
 */
export class LineWidget {
    /**
     * Initialize the constructor of LineWidget
     */
    constructor(paragraphWidget) {
        /**
         * @private
         */
        this.children = [];
        /**
         * @private
         */
        this.x = 0;
        /**
         * @private
         */
        this.y = 0;
        /**
         * @private
         */
        this.width = 0;
        /**
         * @private
         */
        this.height = 0;
        /**
         * @private
         */
        this.marginTop = 0;
        /**
         * @private
         */
        this.maxBaseLine = 0;
        /**
        * @private
        */
        this.skipClipImage = false;
        this.paragraph = paragraphWidget;
    }
    /**
     * Rendered elements contains reordered element for RTL layout
     */
    get renderedElements() {
        if (!isNullOrUndefined(this.layoutedElements)) {
            return this.layoutedElements;
        }
        return this.children;
    }
    /**
     * @private
     */
    get indexInOwner() {
        if (this.paragraph && this.paragraph.childWidgets) {
            return this.paragraph.childWidgets.indexOf(this);
        }
        return -1;
    }
    /**
     * @private
     */
    get nextLine() {
        let paragraph = this.paragraph;
        let lineIndex = this.indexInOwner;
        if (lineIndex <= paragraph.childWidgets.length - 2) {
            return paragraph.childWidgets[lineIndex + 1];
        }
        else if (paragraph.nextSplitWidget) {
            let line = paragraph.nextSplitWidget.firstChild;
            if (line instanceof LineWidget && line.paragraph.equals(this.paragraph)) {
                return line;
            }
        }
        return undefined;
    }
    /**
     * @private
     */
    get previousLine() {
        let paragraph = this.paragraph;
        let lineIndex = this.indexInOwner;
        let splitParagraph = paragraph.previousSplitWidget;
        if (lineIndex > 0) {
            return paragraph.childWidgets[lineIndex - 1];
        }
        else if (splitParagraph instanceof ParagraphWidget) {
            let line = splitParagraph.lastChild;
            if (line instanceof LineWidget && line.paragraph.equals(this.paragraph)) {
                return line;
            }
        }
        return undefined;
    }
    /**
     * @private
     */
    get isEndsWithPageBreak() {
        if (this.children.length > 0) {
            let lastElement = this.children[this.children.length - 1];
            if (lastElement instanceof TextElementBox) {
                return lastElement.isPageBreak;
            }
            else {
                for (let i = this.children.length - 1; i >= 0; i--) {
                    if (this.children[i] instanceof TextElementBox) {
                        return this.children[i].isPageBreak;
                    }
                }
            }
        }
        return false;
    }
    get isEndsWithColumnBreak() {
        if (this.children.length > 0) {
            let lastElement = this.children[this.children.length - 1];
            if (lastElement instanceof TextElementBox) {
                return lastElement.isColumnBreak;
            }
        }
        return false;
    }
    /**
     * @private
     */
    get isEndsWithLineBreak() {
        if (this.children.length > 0) {
            let lastElement = this.children[this.children.length - 1];
            if (lastElement instanceof TextElementBox) {
                return lastElement.text === '\v';
            }
        }
        return false;
    }
    /**
     * @private
     */
    isFirstLine() {
        let index = this.indexInOwner;
        const previousSplitWidget = this.paragraph.previousSplitWidget;
        if (index > -1 && (previousSplitWidget === undefined || (previousSplitWidget instanceof ParagraphWidget && (previousSplitWidget.isEndsWithColumnBreak || previousSplitWidget.isEndsWithPageBreak)))) {
            return index === 0;
        }
        return false;
    }
    /**
     * @private
     */
    isLastLine() {
        let index = this.indexInOwner;
        if (index > -1 && this.paragraph.nextSplitWidget === undefined) {
            return index === this.paragraph.childWidgets.length - 1;
        }
        return false;
    }
    /**
     * @private
     */
    getOffset(inline, index) {
        if (isNullOrUndefined(inline)) {
            return index;
        }
        let textIndex = index;
        let line = inline.line;
        for (let i = 0; i < line.children.length; i++) {
            let inlineElement = line.children[i];
            if (inline === inlineElement) {
                break;
            }
            if (inlineElement instanceof ListTextElementBox) {
                continue;
            }
            textIndex += inlineElement.length;
        }
        return textIndex;
    }
    /**
     * @private
     */
    getEndOffset() {
        let startOffset = 0;
        let count = 0;
        for (let i = 0; i < this.children.length; i++) {
            let inlineElement = this.children[i];
            if (inlineElement.length === 0) {
                continue;
            }
            if (inlineElement instanceof ListTextElementBox) {
                continue;
            }
            if (inlineElement.characterFormat.hidden) {
                count += inlineElement.length;
                continue;
            }
            if (inlineElement instanceof TextElementBox || inlineElement instanceof CommentCharacterElementBox
                || inlineElement instanceof EditRangeStartElementBox || inlineElement instanceof ImageElementBox
                || inlineElement instanceof EditRangeEndElementBox || inlineElement instanceof BookmarkElementBox
                || inlineElement instanceof ContentControl || (inlineElement instanceof FieldElementBox
                && HelperMethods.isLinkedFieldCharacter(inlineElement))) {
                startOffset = count + inlineElement.length;
            }
            count += inlineElement.length;
        }
        return startOffset;
    }
    /**
     * @private
     */
    getInline(offset, indexInInline, bidi, isInsert) {
        bidi = isNullOrUndefined(bidi) ? this.paragraph.bidi : bidi;
        let inlineElement = undefined;
        let count = 0;
        let isStarted = false;
        if (this.children.length === 0) {
            if (this.previousLine) {
                let elementBox = this.previousLine.children[this.previousLine.children.length - 1];
                if (elementBox instanceof TextElementBox && elementBox.text === '\v') {
                    inlineElement = this.previousLine.children[this.previousLine.children.length - 1];
                    indexInInline = 1;
                    return { 'element': inlineElement, 'index': indexInInline };
                }
            }
        }
        for (let i = 0; i < this.children.length; i++) {
            inlineElement = this.children[i];
            if (inlineElement instanceof ListTextElementBox) {
                continue;
            }
            if (!isStarted && (inlineElement instanceof TextElementBox || inlineElement instanceof ImageElementBox
                || inlineElement instanceof ShapeElementBox || inlineElement instanceof ContentControl || inlineElement instanceof GroupShapeElementBox
                || inlineElement instanceof BookmarkElementBox || inlineElement instanceof EditRangeEndElementBox
                || inlineElement instanceof EditRangeStartElementBox || inlineElement instanceof CommentCharacterElementBox
                || inlineElement instanceof FieldElementBox
                    && HelperMethods.isLinkedFieldCharacter(inlineElement))) {
                isStarted = true;
            }
            if (isStarted && offset <= count + inlineElement.length) {
                if (inlineElement instanceof TextElementBox && (inlineElement.text === ' ' && inlineElement.revisionLength === 0 && isInsert)) {
                    let currentElement = this.getNextTextElement(this, i + 1);
                    inlineElement = !isNullOrUndefined(currentElement) ? currentElement : inlineElement;
                    indexInInline = isNullOrUndefined(currentElement) ? (offset - count) : 0;
                    return { 'element': inlineElement, 'index': indexInInline };
                }
                else if (offset === inlineElement.length && this.children[i + 1] instanceof FootnoteElementBox) {
                    return { 'element': this.children[i + 1], 'index': indexInInline };
                }
                else {
                    indexInInline = (offset - count);
                }
                return { 'element': inlineElement, 'index': indexInInline };
            }
            count += inlineElement.length;
        }
        if (offset > count) {
            indexInInline = isNullOrUndefined(inlineElement) ? offset : inlineElement.length;
        }
        return { 'element': inlineElement, 'index': indexInInline };
    }
    /**
     * @private
     */
    isEndnoteLineWidget() {
        if (!isNullOrUndefined(this.paragraph.containerWidget)
            && this.paragraph.containerWidget.containerWidget instanceof FootNoteWidget
            && this.paragraph.containerWidget.containerWidget.footNoteType === 'Endnote') {
            return true;
        }
        return false;
    }
    /**
     * Method to retrieve next element
     * @param line
     * @param index
     */
    getNextTextElement(line, index) {
        if (index < line.children.length - 1 && line.children[index]) {
            return line.children[index];
        }
        return null;
    }
    /**
     * @private
     */
    getHierarchicalIndex(hierarchicalIndex) {
        let node = this;
        hierarchicalIndex = node.paragraph.childWidgets.indexOf(node) + ';' + hierarchicalIndex;
        if (node.paragraph instanceof BlockWidget) {
            return node.paragraph.getHierarchicalIndex(hierarchicalIndex);
        }
        return hierarchicalIndex;
    }
    /**
     * @private
     */
    clone() {
        let line = new LineWidget(undefined);
        for (let j = 0; j < this.children.length; j++) {
            let element = this.children[j];
            let clone = element.clone();
            line.children.push(clone);
            clone.line = line;
            if (clone instanceof GroupShapeElementBox) {
                this.updateLineForGroupChildren(clone, line);
            }
        }
        line.width = this.width;
        line.height = this.height;
        if (!isNullOrUndefined(this.margin)) {
            line.margin = this.margin.clone();
        }
        return line;
    }
    updateLineForGroupChildren(group, line) {
        for (let i = 0; i < group.childWidgets.length; i++) {
            const child = group.childWidgets[i];
            child.line = line;
            if (child instanceof GroupShapeElementBox) {
                this.updateLineForGroupChildren(child, line);
            }
        }
    }
    /**
     * @private
     */
    destroy() {
        if (!isNullOrUndefined(this.children)) {
            for (let i = 0; i < this.children.length; i++) {
                this.children[i].destroy();
            }
            this.children = [];
        }
        this.children = undefined;
        if (this.paragraph) {
            this.paragraph.removeChild(this.indexInOwner);
        }
        this.paragraph = undefined;
        this.x = undefined;
        this.y = undefined;
        this.width = undefined;
    }
    /**
     * Disposes the internal objects which are maintained.
     * @private
     */
    componentDestroy() {
        if (!isNullOrUndefined(this.children)) {
            for (let i = 0; i < this.children.length; i++) {
                let elementBox = this.children[i];
                elementBox.componentDestroy();
            }
            this.children = [];
        }
        this.children = undefined;
        this.paragraph = undefined;
        this.layoutedElements = [];
        this.layoutedElements = undefined;
        this.x = undefined;
        this.y = undefined;
        this.width = undefined;
        this.height = undefined;
    }
}
/**
 * @private
 */
export class ElementBox {
    /**
     * Initialize the constructor of ElementBox
     */
    constructor() {
        /**
         * @private
         */
        this.x = 0;
        /**
         * @private
         */
        this.y = 0;
        /**
         * @private
         */
        this.width = 0;
        /**
         * @private
         */
        this.height = 0;
        /**
        * @private
        */
        this.isWidthUpdated = false;
        /**
         * @private
         */
        this.margin = new Margin(0, 0, 0, 0);
        /**
         * @private
         */
        this.padding = new Margin(0, 0, 0, 0);
        /**
         * @private
         */
        this.characterFormat = undefined;
        /**
         * @private
         */
        this.isRightToLeft = false;
        /**
         * @private
         */
        this.canTrigger = false;
        /**
         * @private
         */
        this.isChangeDetected = false;
        /**
         * @private
         */
        this.isVisible = false;
        /**
         * @private
         */
        this.isSpellChecked = false;
        /**
         * @private
         */
        this.isSpellCheckTriggered = false;
        /**
         * @private
         */
        this.revisions = [];
        /**
         * @private
         */
        this.canTrack = false;
        /**
         * @private
         */
        this.removedIds = [];
        /**
         * @private
         */
        this.skipformFieldLength = false;
        /**
         * @private
         */
        this.characterRange = undefined;
        /**
         * @private
         */
        this.currentUser = undefined;
        this.characterFormat = new WCharacterFormat(this);
        this.margin = new Margin(0, 0, 0, 0);
    }
    /**
     * @private
     */
    get isPageBreak() {
        if (this instanceof TextElementBox) {
            return this.text === '\f';
        }
        return false;
    }
    get isColumnBreak() {
        if (this instanceof TextElementBox) {
            return this.text === String.fromCharCode(14);
        }
        return false;
    }
    /**
     * @private
     * Method to indicate whether current element is trackable.
     */
    get isValidNodeForTracking() {
        if (this instanceof BookmarkElementBox || this instanceof CommentCharacterElementBox || this instanceof EditRangeStartElementBox || this instanceof EditRangeEndElementBox || this instanceof ContentControl) {
            return false;
        }
        return true;
    }
    /**
     * @private
     */
    get isCheckBoxElement() {
        let element = this;
        if (element instanceof TextElementBox && !isNullOrUndefined(element.text)) {
            return element.text === String.fromCharCode(9746) || element.text === String.fromCharCode(9745) || element.text === String.fromCharCode(9744);
        }
        return false;
    }
    /**
     * @private
     */
    get revisionLength() {
        if (!isNullOrUndefined(this.revisions)) {
            return this.revisions.length;
        }
        return 0;
    }
    /**
     * @private
     */
    getRevision(index) {
        if (!isNullOrUndefined(this.revisions)) {
            return this.revisions[index];
        }
        return undefined;
    }
    /**
     * @private
     */
    addRevision(revision) {
        if (this.revisions.indexOf(revision) === -1) {
            this.revisions.push(revision);
        }
        revision.hasChanges = true;
    }
    /**
     * @private
     */
    insertRevisionAt(index, revision) {
        this.revisions.splice(index, 0, revision);
        revision.hasChanges = true;
    }
    /**
     * @private
     */
    removeRevision(index) {
        let revision = this.revisions.splice(index, 1)[0];
        revision.hasChanges = true;
    }
    /**
     * @private
     */
    getAllRevision() {
        return this.revisions;
    }
    /**
     * @private
     */
    setRevision(index, revision) {
        if (this.revisions) {
            this.revisions[index] = revision;
        }
    }
    /**
     * @private
     */
    clearRevision() {
        this.revisions = [];
    }
    /**
     * @private
     */
    linkFieldCharacter(documentHelper) {
        if (!(this instanceof FieldElementBox)) {
            return;
        }
        if (this.fieldType === 0) {
            let fieldBegin = this;
            if (isNullOrUndefined(fieldBegin.fieldEnd)) {
                this.linkFieldTraversingForward(this.line, fieldBegin, fieldBegin);
                if (documentHelper.fields.indexOf(fieldBegin) === -1) {
                    documentHelper.fields.push(fieldBegin);
                }
                if (!isNullOrUndefined(fieldBegin.formFieldData) &&
                    documentHelper.formFields.indexOf(fieldBegin) === -1 && !documentHelper.layout.isInsertFormField) {
                    documentHelper.formFields.push(fieldBegin);
                }
            }
        }
        else if (this.fieldType === 2) {
            let fieldSeparator = this;
            //Links the field begin for the current separator.
            if (isNullOrUndefined(fieldSeparator.fieldBegin)) {
                this.linkFieldTraversingBackwardSeparator(this.line, fieldSeparator, fieldSeparator);
            }
            if (!isNullOrUndefined(fieldSeparator.fieldBegin)) {
                fieldSeparator.fieldBegin.fieldSeparator = fieldSeparator;
                //Links to field end traversing from field separator.
                if (isNullOrUndefined(fieldSeparator.fieldEnd)) {
                    let isFieldEnd = this.linkFieldTraversingForward(this.line, fieldSeparator.fieldBegin, fieldSeparator);
                    if (isFieldEnd) {
                        fieldSeparator.fieldEnd = fieldSeparator.fieldBegin.fieldEnd;
                    }
                }
                if (fieldSeparator.fieldEnd) {
                    fieldSeparator.fieldEnd.fieldSeparator = fieldSeparator;
                }
            }
        }
        else {
            let fieldEnd = this;
            //Links the field begin and separator for the current end.
            if (isNullOrUndefined(fieldEnd.fieldBegin)) {
                this.linkFieldTraversingBackward(this.line, fieldEnd, fieldEnd);
            }
        }
    }
    /**
     * @private
     */
    linkFieldTraversingBackward(line, fieldEnd, previousNode) {
        let k = line.children.length - 1;
        if (line.children.indexOf(previousNode) > -1) {
            k = line.children.indexOf(previousNode) - 1;
        }
        for (let j = k; j >= 0; j--) {
            let childNode = line.children[j];
            if (childNode instanceof FieldElementBox) {
                if (childNode.fieldType === 0) {
                    if (isNullOrUndefined(childNode.fieldEnd)) {
                        fieldEnd.fieldBegin = childNode;
                        if (isNullOrUndefined(childNode.fieldEnd)) {
                            childNode.fieldEnd = fieldEnd;
                        }
                        if (fieldEnd.fieldSeparator && isNullOrUndefined(fieldEnd.fieldSeparator.fieldBegin)) {
                            fieldEnd.fieldSeparator.fieldBegin = childNode;
                            if (isNullOrUndefined(childNode.fieldSeparator)) {
                                childNode.fieldSeparator = fieldEnd.fieldSeparator;
                            }
                        }
                        return !isNullOrUndefined(fieldEnd.fieldBegin);
                    }
                }
                else if (childNode.fieldType === 2 && isNullOrUndefined(childNode.fieldEnd)) {
                    fieldEnd.fieldSeparator = childNode;
                    childNode.fieldEnd = fieldEnd;
                    if (!isNullOrUndefined(childNode.fieldBegin)) {
                        fieldEnd.fieldBegin = childNode.fieldBegin;
                        if (fieldEnd && isNullOrUndefined(fieldEnd.fieldBegin.fieldEnd)) {
                            fieldEnd.fieldBegin.fieldEnd = fieldEnd;
                        }
                    }
                }
            }
        }
        if (line.previousLine) {
            this.linkFieldTraversingBackward(line.previousLine, fieldEnd, this);
        }
        else if (line.paragraph.previousRenderedWidget instanceof ParagraphWidget
            && line.paragraph.previousRenderedWidget.childWidgets.length > 0) {
            let prevParagraph = line.paragraph.previousRenderedWidget;
            this.linkFieldTraversingBackward(prevParagraph.childWidgets[prevParagraph.childWidgets.length - 1], fieldEnd, this);
        }
        return true;
    }
    /**
     * @private
     */
    linkFieldTraversingForward(line, fieldBegin, previousNode, fieldCount) {
        let i = 0;
        if (isNullOrUndefined(fieldCount)) {
            fieldCount = 0;
        }
        if (line.children.indexOf(previousNode) > -1) {
            i = line.children.indexOf(previousNode) + 1;
        }
        for (let j = i; j < line.children.length; j++) {
            let node = line.children[j];
            if (node instanceof FieldElementBox) {
                if (node.fieldType === 0) {
                    fieldCount++;
                }
                if (node.fieldType === 1) {
                    if (fieldCount !== 0) {
                        fieldCount--;
                        continue;
                    }
                    if (isNullOrUndefined(node.fieldBegin)) {
                        fieldBegin.fieldEnd = node;
                    }
                    if (fieldBegin.fieldEnd && isNullOrUndefined(fieldBegin.fieldEnd.fieldBegin)) {
                        fieldBegin.fieldEnd.fieldBegin = fieldBegin;
                    }
                    return true;
                }
                else if (isNullOrUndefined(fieldBegin.fieldSeparator)) {
                    if (node.fieldType === 2 && isNullOrUndefined(node.fieldBegin)) {
                        fieldBegin.fieldSeparator = node;
                        if (fieldBegin.fieldSeparator && isNullOrUndefined(fieldBegin.fieldSeparator.fieldBegin)) {
                            fieldBegin.fieldSeparator.fieldBegin = fieldBegin;
                        }
                        if (!isNullOrUndefined(node.fieldEnd)) {
                            fieldBegin.fieldEnd = node.fieldEnd;
                            fieldBegin.fieldSeparator.fieldEnd = fieldBegin.fieldEnd;
                            return true;
                        }
                    }
                    else {
                        return false;
                    }
                }
            }
        }
        if (line.nextLine) {
            this.linkFieldTraversingForward(line.nextLine, fieldBegin, this, fieldCount);
        }
        else if (line.paragraph.nextRenderedWidget instanceof ParagraphWidget
            && line.paragraph.nextRenderedWidget.childWidgets.length > 0) {
            this.linkFieldTraversingForward(line.paragraph.nextRenderedWidget.childWidgets[0], fieldBegin, this, fieldCount);
        }
        else if (line.paragraph.nextRenderedWidget instanceof TableWidget) {
            var tableWidget = line.paragraph.nextRenderedWidget;
            tableWidget = tableWidget.getSplitWidgets().pop();
            if (!isNullOrUndefined(tableWidget.nextRenderedWidget) && tableWidget.nextRenderedWidget instanceof ParagraphWidget && tableWidget.nextRenderedWidget.childWidgets.length > 0) {
                this.linkFieldTraversingForward(tableWidget.nextRenderedWidget.childWidgets[0], fieldBegin, this, fieldCount);
            }
        }
        return true;
    }
    /**
     * @private
     */
    linkFieldTraversingBackwardSeparator(line, fieldSeparator, previousNode) {
        let index = line.children.length - 1;
        if (line.children.indexOf(previousNode) > -1) {
            index = line.children.indexOf(previousNode) - 1;
        }
        for (let i = index; i >= 0; i--) {
            let childElement = line.children[i];
            if (childElement instanceof FieldElementBox) {
                if (childElement instanceof FieldElementBox && childElement.fieldType === 0) {
                    if (isNullOrUndefined(childElement.fieldSeparator)) {
                        fieldSeparator.fieldBegin = childElement;
                    }
                    return !isNullOrUndefined(fieldSeparator.fieldBegin);
                }
            }
        }
        if (line.previousLine) {
            this.linkFieldTraversingBackwardSeparator(line.previousLine, fieldSeparator, this);
        }
        else if (line.paragraph.previousRenderedWidget instanceof ParagraphWidget
            && line.paragraph.previousRenderedWidget.childWidgets.length > 0) {
            line = line.paragraph.previousRenderedWidget.childWidgets[line.paragraph.previousRenderedWidget.childWidgets.length - 1];
            this.linkFieldTraversingBackwardSeparator(line, fieldSeparator, this);
        }
        else {
            return true;
        }
        return true;
    }
    /**
     * @private
     */
    get length() {
        return this.getLength();
    }
    /**
     * @private
     */
    get indexInOwner() {
        if ((this instanceof ShapeElementBox || this instanceof GroupShapeElementBox || this instanceof ImageElementBox || this instanceof ChartElementBox) && this.containerShape) {
            return this.containerShape.childWidgets.indexOf(this);
        }
        return this.line instanceof LineWidget && this.line.children ? this.line.children.indexOf(this) : -1;
    }
    /**
     * @private
     */
    get previousElement() {
        let index = this.indexInOwner;
        if ((this instanceof ShapeElementBox || this instanceof GroupShapeElementBox || this instanceof ImageElementBox || this instanceof ChartElementBox) && this.containerShape) {
            return (index > 0 && index < this.containerShape.childWidgets.length) ? this.containerShape.childWidgets[index - 1] : undefined;
        }
        else if (index > 0 && index < this.line.children.length) {
            return this.line.children[index - 1];
        }
        return undefined;
    }
    /**
     * @private
     */
    get nextElement() {
        let index = this.indexInOwner;
        if ((this instanceof ShapeElementBox || this instanceof GroupShapeElementBox || this instanceof ImageElementBox || this instanceof ChartElementBox) && this.containerShape) {
            return (index > -1 && index < this.containerShape.childWidgets.length - 1) ? this.containerShape.childWidgets[index + 1] : undefined;
        }
        else if (index > -1 && index < this.line.children.length - 1) {
            return this.line.children[index + 1];
        }
        return undefined;
    }
    /**
     * @private
     */
    get nextNode() {
        if ((this instanceof ShapeElementBox || this instanceof GroupShapeElementBox || this instanceof ImageElementBox || this instanceof ChartElementBox) && this.containerShape) {
            let index = this.containerShape.childWidgets.indexOf(this);
            return (index < this.containerShape.childWidgets.length - 1) ? this.containerShape.childWidgets[index + 1] : undefined;
        }
        else {
            let index = this.line.children.indexOf(this);
            let lineIndex = this.line.paragraph.childWidgets.indexOf(this.line);
            if (index < this.line.children.length - 1) {
                return this.line.children[index + 1];
            }
            else if (lineIndex < this.line.paragraph.childWidgets.length - 1) {
                return this.line.paragraph.childWidgets[lineIndex + 1].children[0];
            }
            return undefined;
        }
    }
    /**
     * @private
     */
    get nextValidNodeForTracking() {
        let elementBox = this;
        while (!isNullOrUndefined(elementBox) && (elementBox instanceof BookmarkElementBox || elementBox instanceof CommentCharacterElementBox || elementBox instanceof EditRangeStartElementBox || elementBox instanceof EditRangeEndElementBox)) {
            elementBox = elementBox.nextNode;
        }
        return elementBox;
    }
    /**
     * @private
     */
    get previousValidNodeForTracking() {
        let elementBox = this;
        while (!isNullOrUndefined(elementBox) && (elementBox instanceof BookmarkElementBox || elementBox instanceof CommentCharacterElementBox || elementBox instanceof EditRangeStartElementBox || elementBox instanceof EditRangeEndElementBox)) {
            elementBox = elementBox.previousNode;
        }
        return elementBox;
    }
    /**
     * @private
     */
    get previousNode() {
        if ((this instanceof ShapeElementBox || this instanceof GroupShapeElementBox || this instanceof ImageElementBox || this instanceof ChartElementBox) && this.containerShape) {
            let index = this.containerShape.childWidgets.indexOf(this);
            return (index > 0) ? this.containerShape.childWidgets[index - 1] : undefined;
        }
        else {
            let index = this.line.children.indexOf(this);
            let lineIndex = this.line.paragraph.childWidgets.indexOf(this.line);
            if (index > 0) {
                return this.line.children[index - 1];
            }
            else if (lineIndex > 0) {
                let lineWidget = this.line.paragraph.childWidgets[lineIndex - 1];
                return lineWidget.children[lineWidget.children.length - 1];
            }
            return undefined;
        }
    }
    /**
     *
     * @private
     */
    get paragraph() {
        if (this.line) {
            return this.line.paragraph;
        }
        return undefined;
    }
    /**
     * @private
     */
    destroy() {
        if (!isNullOrUndefined(this.line) && this.line.children && this.line.children.indexOf(this) > -1) {
            let index = this.line.children.indexOf(this);
            this.line.children.splice(index, 1);
        }
        this.line = undefined;
        if (this.characterFormat) {
            this.characterFormat.destroy();
        }
        this.characterFormat = undefined;
        if (this.margin) {
            this.margin.destroy();
        }
        this.margin = undefined;
        this.x = undefined;
        this.y = undefined;
        this.width = undefined;
        this.height = undefined;
    }
    /**
     * Disposes the internal objects which are maintained.
     * @private
     */
    componentDestroy() {
        if (this.characterFormat) {
            this.characterFormat.destroy();
        }
        this.characterFormat = undefined;
        if (this.margin) {
            this.margin.destroy();
        }
        this.margin = undefined;
        if (this.padding) {
            this.padding.destroy();
        }
        this.padding = undefined;
        this.contentControlProperties = undefined;
        this.line = undefined;
        this.x = undefined;
        this.y = undefined;
        this.width = undefined;
        this.height = undefined;
    }
}
/**
 * @private
 */
ElementBox.objectCharacter = String.fromCharCode(65532);
/**
 * @private
 */
export class FieldElementBox extends ElementBox {
    constructor(type) {
        super();
        /**
         * @private
         */
        this.fieldType = 0;
        /**
         * @private
         */
        this.fieldCodeType = '';
        /**
         * @private
         */
        this.hasFieldEnd = false;
        /**
        * @private
        */
        this.fieldBeginInternal = undefined;
        this.fieldSeparatorInternal = undefined;
        this.fieldEndInternal = undefined;
        this.fieldType = type;
    }
    get fieldBegin() {
        return this.fieldBeginInternal;
    }
    set fieldBegin(field) {
        this.fieldBeginInternal = field;
    }
    get fieldSeparator() {
        return this.fieldSeparatorInternal;
    }
    set fieldSeparator(field) {
        this.fieldSeparatorInternal = field;
    }
    get fieldEnd() {
        return this.fieldEndInternal;
    }
    set fieldEnd(field) {
        this.fieldEndInternal = field;
    }
    /**
     * @private
     */
    get resultText() {
        if (!isNullOrUndefined(this.formFieldData) && this.fieldType === 0 &&
            !isNullOrUndefined(this.fieldSeparator) && !isNullOrUndefined(this.fieldEnd)) {
            let textElement = this.fieldSeparator.nextElement;
            let text = '';
            do {
                if (textElement instanceof TextElementBox) {
                    text += textElement.text;
                }
                textElement = textElement.nextNode;
                if (textElement === this.fieldEnd) {
                    break;
                }
            } while (textElement);
            return text;
        }
        return undefined;
    }
    /**
     * @private
     */
    getLength() {
        return 1;
    }
    /**
     * @private
     */
    clone() {
        let field = new FieldElementBox(this.fieldType);
        if (this.fieldType === 0 && !isNullOrUndefined(this.formFieldData)) {
            field.formFieldData = this.formFieldData.clone();
        }
        field.characterFormat.copyFormat(this.characterFormat);
        if (this.margin) {
            field.margin = this.margin.clone();
        }
        field.width = this.width;
        field.height = this.height;
        // if (!isNullOrUndefined(this.paragraph) && this.paragraph.isInHeaderFooter) {
        //     if (this.revisionLength > 0) {
        //         for (let i: number = 0; i < this.revisionLength; i++) {
        //             let revision: Revision = this.getRevision(i);
        //             field.addRevision(revision.clone());
        //         }
        //     }
        // } else {
        if (this.revisionLength > 0) {
            field.removedIds = Revision.cloneRevisions(this.getAllRevision());
            if (this.fieldEnd) {
                field.hasFieldEnd = this.hasFieldEnd;
            }
        }
        else {
            field.removedIds = this.removedIds.slice();
            if (!(!isNullOrUndefined(this.paragraph) && this.paragraph.isInHeaderFooter) && !isNullOrUndefined(this.fieldEnd) && !isNullOrUndefined(this.fieldEnd.paragraph) && !(this.fieldEnd.paragraph.containerWidget instanceof TableCellWidget)) {
                field.hasFieldEnd = this.hasFieldEnd;
            }
        }
        // }
        field.fieldCodeType = this.fieldCodeType;
        return field;
    }
    /**
     * @private
     */
    destroy() {
        this.fieldType = undefined;
        this.hasFieldEnd = undefined;
        this.fieldBeginInternal = undefined;
        this.fieldEndInternal = undefined;
        this.fieldSeparatorInternal = undefined;
        super.destroy();
    }
    /**
     * Disposes the internal objects which are maintained.
     * @private
     */
    componentDestroy() {
        if (this.formFieldData) {
            this.formFieldData.destroy();
        }
        this.formFieldData = undefined;
        this.fieldCodeType = undefined;
        this.fieldBeginInternal = undefined;
        this.fieldEndInternal = undefined;
        this.fieldSeparatorInternal = undefined;
        super.componentDestroy();
    }
}
/**
 * @private
 */
export class FormField {
    constructor() {
        /*
         * @private
         */
        this.name = '';
        /**
         * @private
         */
        this.enabled = true;
        /**
         * @private
         */
        this.helpText = '';
        /**
         * @private
         */
        this.statusText = '';
    }
    /**
     * @private
     */
    destroy() {
        this.name = undefined;
        this.helpText = undefined;
        this.statusText = undefined;
    }
}
/**
 * @private
 */
export class TextFormField extends FormField {
    constructor() {
        super(...arguments);
        /**
         * @private
         */
        this.type = 'Text';
        /**
         * @private
         */
        this.maxLength = 0;
        /**
         * @private
         */
        this.defaultValue = '';
        /**
         * @private
         */
        this.format = '';
    }
    /**
     * @private
     */
    clone() {
        let textForm = new TextFormField();
        textForm.type = this.type;
        textForm.name = this.name;
        textForm.enabled = this.enabled;
        textForm.helpText = this.helpText;
        textForm.statusText = this.statusText;
        textForm.maxLength = this.maxLength;
        textForm.defaultValue = this.defaultValue;
        textForm.format = this.format;
        return textForm;
    }
    /**
     * @private
     */
    getFormFieldInfo() {
        let textFormField = {
            defaultValue: this.defaultValue,
            enabled: this.enabled,
            format: this.format,
            helpText: this.helpText,
            maxLength: this.maxLength,
            type: this.type,
            name: this.name
        };
        return textFormField;
    }
    /**
     * @private
     */
    copyFieldInfo(info) {
        if (!isNullOrUndefined(info.defaultValue)) {
            this.defaultValue = info.defaultValue;
        }
        if (!isNullOrUndefined(info.enabled)) {
            this.enabled = info.enabled;
        }
        if (!isNullOrUndefined(info.format)) {
            this.format = info.format;
        }
        if (!isNullOrUndefined(info.helpText)) {
            this.helpText = info.helpText;
        }
        if (!isNullOrUndefined(info.maxLength)) {
            this.maxLength = info.maxLength;
        }
        if (!isNullOrUndefined(info.type)) {
            this.type = info.type;
        }
    }
    /**
     * @private
     */
    destroy() {
        this.format = undefined;
        this.defaultValue = undefined;
        super.destroy();
    }
}
/**
 * @private
 */
export class CheckBoxFormField extends FormField {
    constructor() {
        super(...arguments);
        /**
         * @private
         */
        this.sizeType = 'Auto';
        /**
         * @private
         */
        this.size = 11;
        /**
         * @private
         */
        this.defaultValue = false;
        /**
         * @private
         */
        this.checked = false;
    }
    /**
     * @private
     */
    clone() {
        let checkBoxForm = new CheckBoxFormField();
        checkBoxForm.name = this.name;
        checkBoxForm.enabled = this.enabled;
        checkBoxForm.helpText = this.helpText;
        checkBoxForm.statusText = this.statusText;
        checkBoxForm.sizeType = this.sizeType;
        checkBoxForm.size = this.size;
        checkBoxForm.defaultValue = this.defaultValue;
        checkBoxForm.checked = this.checked;
        return checkBoxForm;
    }
    /**
     * @private
     */
    getFormFieldInfo() {
        let checkBoxFormField = {
            defaultValue: this.defaultValue,
            enabled: this.enabled,
            helpText: this.helpText,
            size: this.size,
            sizeType: this.sizeType,
            name: this.name
        };
        return checkBoxFormField;
    }
    /**
     * @private
     */
    copyFieldInfo(info) {
        if (!isNullOrUndefined(info.defaultValue)) {
            this.defaultValue = info.defaultValue;
            this.checked = info.defaultValue;
        }
        if (!isNullOrUndefined(info.enabled)) {
            this.enabled = info.enabled;
        }
        if (!isNullOrUndefined(info.size)) {
            this.size = info.size;
        }
        if (!isNullOrUndefined(info.helpText)) {
            this.helpText = info.helpText;
        }
        if (!isNullOrUndefined(info.sizeType)) {
            this.sizeType = info.sizeType;
        }
    }
    /**
     * @private
     */
    destroy() {
        super.destroy();
    }
}
/**
 * @private
 */
export class DropDownFormField extends FormField {
    constructor() {
        super(...arguments);
        /**
         * @private
         */
        this.dropdownItems = [];
        /**
         * @private
         */
        this.selectedIndex = 0;
    }
    /**
     * @private
     */
    clone() {
        let dropDown = new DropDownFormField();
        dropDown.name = this.name;
        dropDown.enabled = this.enabled;
        dropDown.helpText = this.helpText;
        dropDown.statusText = this.statusText;
        dropDown.dropdownItems = this.dropdownItems.slice();
        dropDown.selectedIndex = this.selectedIndex;
        return dropDown;
    }
    /**
     * @private
     */
    getFormFieldInfo() {
        let dropDownFormField = {
            dropdownItems: this.dropdownItems.slice(),
            enabled: this.enabled,
            helpText: this.helpText,
            name: this.name
        };
        return dropDownFormField;
    }
    /**
     * @private
     */
    copyFieldInfo(info) {
        if (!isNullOrUndefined(info.dropdownItems)) {
            this.dropdownItems = info.dropdownItems;
        }
        if (!isNullOrUndefined(info.enabled)) {
            this.enabled = info.enabled;
        }
        if (!isNullOrUndefined(info.helpText)) {
            this.helpText = info.helpText;
        }
    }
    /**
     * @private
     */
    destroy() {
        this.dropdownItems = [];
        this.dropdownItems = undefined;
        super.destroy();
    }
}
/**
 * @private
 */
export class TextElementBox extends ElementBox {
    constructor() {
        super();
        /**
         * @private
         */
        this.baselineOffset = 0;
        /**
         * @private
         */
        this.text = '';
        /**
         * @private
         */
        this.trimEndWidth = 0;
        /**
         * @private
         */
        this.ignoreOnceItems = [];
        /**
         * @private
         */
        this.istextCombined = false;
        /**
         * @private
         */
        this.scriptType = FontScriptType.English;
        /**
         * @private
         */
        this.renderedFontFamily = undefined;
        this.errorCollection = [];
    }
    /**
     * @private
     */
    getLength() {
        return this.text ? this.text.length : 0;
    }
    /**
     * @private
     */
    clone() {
        let textEle = new TextElementBox();
        textEle.characterFormat.copyFormat(this.characterFormat);
        textEle.text = this.text;
        if (this.margin) {
            textEle.margin = this.margin.clone();
        }
        if (!isNullOrUndefined(this.paragraph) && this.paragraph.isInHeaderFooter) {
            for (let i = 0; i < this.ignoreOnceItems.length; i++) {
                textEle.ignoreOnceItems.push(this.ignoreOnceItems[i]);
            }
            textEle.isChangeDetected = this.isChangeDetected;
        }
        textEle.baselineOffset = this.baselineOffset;
        // if (!isNullOrUndefined(this.paragraph) && this.paragraph.isInHeaderFooter) {
        //     if (this.revisionLength > 0) {
        //         for (let i: number = 0; i < this.revisionLength; i++) {
        //             let revision: Revision = this.getRevision(i);
        //             textEle.addRevision(revision.clone());
        //         }
        //     }
        // } else {
        // Copy the revisions when cloning the header row.
        if (this.paragraph && this.paragraph.isInsideTable && this.paragraph.containerWidget instanceof TableCellWidget && this.paragraph.containerWidget.ownerRow.rowFormat.isHeader) {
            textEle.revisions = this.revisions;
        }
        else {
            if (this.revisionLength > 0) {
                textEle.removedIds = Revision.cloneRevisions(this.getAllRevision());
            }
            else {
                textEle.removedIds = this.removedIds.slice();
            }
        }
        // }
        textEle.width = this.width;
        textEle.height = this.height;
        textEle.errorCollection = this.errorCollection;
        if (this.contentControlProperties) {
            textEle.contentControlProperties = this.contentControlProperties;
        }
        return textEle;
    }
    /**
     * @private
     */
    destroy() {
        this.text = undefined;
        super.destroy();
    }
    /**
     * @private
     */
    componentDestroy() {
        this.text = undefined;
        super.componentDestroy();
    }
}
/**
 * @private
 */
export class Footnote {
    constructor() {
        this.separator = [];
        this.continuationNotice = [];
        this.continuationSeparator = [];
    }
    /**
     * @private
     */
    clear() {
        if (this.separator) {
            for (let i = 0; i < this.separator.length; i++) {
                let bodyWidget = this.separator[i];
                bodyWidget.destroy();
            }
            this.separator = [];
        }
        if (this.continuationSeparator) {
            for (let i = 0; i < this.continuationSeparator.length; i++) {
                let bodyWidget = this.continuationSeparator[i];
                bodyWidget.destroy();
            }
            this.continuationSeparator = [];
        }
        if (this.continuationNotice) {
            for (let i = 0; i < this.continuationNotice.length; i++) {
                let bodyWidget = this.continuationNotice[i];
                bodyWidget.destroy();
            }
            this.continuationNotice = [];
        }
    }
    destroy() {
        this.separator = [];
        this.continuationSeparator = [];
        this.continuationNotice = [];
    }
    /**
     * Disposes the internal objects which are maintained.
     * @private
     */
    componentDestroy() {
        if (this.separator) {
            for (let i = 0; i < this.separator.length; i++) {
                let bodyWidget = this.separator[i];
                bodyWidget.componentDestroy();
            }
            this.separator = [];
        }
        this.separator = undefined;
        if (this.continuationSeparator) {
            for (let i = 0; i < this.continuationSeparator.length; i++) {
                let bodyWidget = this.continuationSeparator[i];
                bodyWidget.componentDestroy();
            }
            this.continuationSeparator = [];
        }
        this.continuationSeparator = undefined;
        if (this.continuationNotice) {
            for (let i = 0; i < this.continuationNotice.length; i++) {
                let bodyWidget = this.continuationNotice[i];
                bodyWidget.componentDestroy();
            }
            this.continuationNotice = [];
        }
        this.continuationNotice = undefined;
    }
}
/**
 * @private
 */
export class FootnoteElementBox extends TextElementBox {
    constructor() {
        super();
        this.isLayout = false;
        this.bodyWidget = new BodyWidget();
        this.bodyWidget.footNoteReference = this;
    }
    clone() {
        let span = new FootnoteElementBox();
        span.text = this.text;
        span.characterFormat.copyFormat(this.characterFormat);
        span.height = this.height;
        span.footnoteType = this.footnoteType;
        span.width = this.width;
        span.symbolCode = this.symbolCode;
        // span.bodyWidget.childWidgets = this.bodyWidget.childWidgets;
        for (let i = 0; i < this.bodyWidget.childWidgets.length; i++) {
            let element = this.bodyWidget.childWidgets[i];
            if (element instanceof ParagraphWidget) {
                element = this.bodyWidget.childWidgets[i].clone();
            }
            else if (element instanceof TableWidget) {
                element = this.bodyWidget.childWidgets[i].clone();
            }
            span.bodyWidget.childWidgets.push(element);
        }
        span.bodyWidget.page = this.bodyWidget.page;
        // if (!isNullOrUndefined(this.paragraph) && this.paragraph.isInHeaderFooter) {
        //     if (this.revisionLength > 0) {
        //         for (let i: number = 0; i < this.revisionLength; i++) {
        //             let revision: Revision = this.getRevision(i);
        //             span.addRevision(revision.clone());
        //         }
        //     }
        // } else {
        if (this.revisionLength > 0) {
            span.removedIds = Revision.cloneRevisions(this.getAllRevision());
        }
        else {
            span.removedIds = this.removedIds.slice();
        }
        // }
        if (this.margin) {
            span.margin = this.margin.clone();
        }
        return span;
    }
    getLength() {
        return 1;
    }
    destroy() {
        this.symbolCode = '';
        this.symbolFontName = '';
        this.customMarker = '';
    }
    /**
     * Disposes the internal objects which are maintained.
     * @private
     */
    componentDestroy() {
        if (this.characterFormat) {
            this.characterFormat.destroy();
            this.characterFormat = undefined;
        }
        this.symbolCode = '';
        this.symbolFontName = '';
        this.customMarker = '';
        if (this.bodyWidget) {
            this.bodyWidget.componentDestroy();
        }
        this.bodyWidget = undefined;
        super.componentDestroy();
    }
}
/**
 * @private
 */
export class ErrorTextElementBox extends TextElementBox {
    constructor() {
        super();
        this.startIn = undefined;
        this.endIn = undefined;
    }
    get start() {
        return this.startIn;
    }
    set start(value) {
        this.startIn = value;
    }
    get end() {
        return this.endIn;
    }
    set end(value) {
        this.endIn = value;
    }
    destroy() {
        this.start = undefined;
        this.end = undefined;
    }
    /**
     * Disposes the internal objects which are maintained.
     * @private
     */
    componentDestroy() {
        if (this.startIn) {
            this.startIn.destroy();
        }
        this.startIn = undefined;
        if (this.endIn) {
            this.endIn.destroy();
        }
        this.endIn = undefined;
        super.componentDestroy();
    }
}
/**
 * @private
 */
export class FieldTextElementBox extends TextElementBox {
    constructor() {
        super();
        this.fieldText = '';
    }
    get text() {
        return this.fieldText;
    }
    set text(value) {
        this.fieldText = value;
    }
    /**
     * @private
     */
    clone() {
        let fieldSpan = new FieldTextElementBox();
        fieldSpan.characterFormat.copyFormat(this.characterFormat);
        fieldSpan.fieldBegin = this.fieldBegin;
        fieldSpan.text = this.text;
        if (this.margin) {
            fieldSpan.margin = this.margin.clone();
        }
        // if (!isNullOrUndefined(this.paragraph) && this.paragraph.isInHeaderFooter) {
        //     if (this.revisionLength > 0) {
        //         for (let i: number = 0; i < this.revisionLength; i++) {
        //             let revisionChanges: Revision = this.getRevision(i);
        //             fieldSpan.addRevision(revisionChanges.clone());
        //         }
        //     }
        // } else {
        if (this.revisionLength > 0) {
            fieldSpan.removedIds = Revision.cloneRevisions(this.getAllRevision());
        }
        else {
            fieldSpan.removedIds = this.removedIds.slice();
        }
        // }
        fieldSpan.width = this.width;
        fieldSpan.height = this.height;
        return fieldSpan;
    }
    /**
     * Disposes the internal objects which are maintained.
     * @private
     */
    componentDestroy() {
        this.fieldText = undefined;
        this.fieldBegin = undefined;
        super.componentDestroy();
    }
}
/**
 * @private
 */
export class TabElementBox extends TextElementBox {
    constructor() {
        super();
        /**
         * @private
         */
        this.tabText = '';
        /**
         * @private
         */
        this.tabLeader = 'None';
    }
    /**
     * @private
     */
    destroy() {
        this.tabText = undefined;
        this.tabLeader = undefined;
    }
    /**
     * @private
     */
    componentDestroy() {
        this.tabText = undefined;
        this.tabLeader = undefined;
        super.componentDestroy();
    }
    /**
     * @private
     */
    clone() {
        let tabSpan = new TabElementBox();
        tabSpan.characterFormat.copyFormat(this.characterFormat);
        tabSpan.tabText = this.tabText;
        tabSpan.tabLeader = this.tabLeader;
        tabSpan.text = this.text;
        if (this.margin) {
            tabSpan.margin = this.margin.clone();
        }
        tabSpan.width = this.width;
        tabSpan.height = this.height;
        // if (!isNullOrUndefined(this.paragraph) && this.paragraph.isInHeaderFooter) {
        //     if (this.revisionLength > 0) {
        //         for (let i: number = 0; i < this.revisionLength; i++) {
        //             let revision: Revision = this.getRevision(i);
        //             tabSpan.addRevision(revision.clone());
        //         }
        //     }
        // } else {
        if (this.revisionLength > 0) {
            tabSpan.removedIds = Revision.cloneRevisions(this.getAllRevision());
        }
        else {
            tabSpan.removedIds = this.removedIds.slice();
        }
        // }
        return tabSpan;
    }
}
/**
 * @private
 */
export class BookmarkElementBox extends ElementBox {
    constructor(type) {
        super();
        this.bookmarkTypeIn = 0;
        this.refereneceIn = undefined;
        this.nameIn = '';
        this.bookmarkTypeIn = type;
    }
    /**
     * @private
     */
    get bookmarkType() {
        return this.bookmarkTypeIn;
    }
    /**
     * @private
     */
    get properties() {
        return this.propertiesIn;
    }
    /**
     * @private
     */
    set properties(properties) {
        this.propertiesIn = properties;
    }
    /**
     * @private
     */
    get name() {
        return this.nameIn;
    }
    /**
     * @private
     */
    set name(name) {
        this.nameIn = name;
    }
    /**
     * @private
     */
    get reference() {
        return this.refereneceIn;
    }
    /**
     * @private
     */
    set reference(reference) {
        this.refereneceIn = reference;
    }
    /**
     * @private
     */
    getLength() {
        return 1;
    }
    /**
     * @private
     */
    destroy() {
        this.name = undefined;
        this.reference = undefined;
        this.bookmarkTypeIn = undefined;
    }
    /**
     * @private
     */
    componentDestroy() {
        this.name = undefined;
        this.reference = undefined;
        this.bookmarkTypeIn = undefined;
        super.componentDestroy();
    }
    /**
     * Clones the bookmark element box.
     * @param element - book mark element
     */
    /**
     * @private
     */
    clone() {
        let span = new BookmarkElementBox(this.bookmarkType);
        span.name = this.name;
        span.reference = this.reference;
        span.properties = this.properties;
        if (this.margin) {
            span.margin = this.margin.clone();
        }
        if (this.revisionLength > 0) {
            span.removedIds = Revision.cloneRevisions(this.getAllRevision());
        }
        else {
            span.removedIds = this.removedIds.slice();
        }
        span.width = this.width;
        span.height = this.height;
        if (this.contentControlProperties) {
            span.contentControlProperties = this.contentControlProperties;
        }
        return span;
    }
}
/**
 * @private
 */
export class ContentControl extends ElementBox {
    constructor(widgetType) {
        super();
        this.contentControlWidgetType = widgetType;
        this.contentControlProperties = new ContentControlProperties(widgetType);
    }
    /**
     * @private
     */
    getLength() {
        return 1;
    }
    /**
     * @private
     */
    clone() {
        let span = new ContentControl(this.contentControlWidgetType);
        span.characterFormat.copyFormat(this.characterFormat);
        span.contentControlProperties = this.contentControlProperties;
        span.contentControlWidgetType = this.contentControlWidgetType;
        if (this.margin) {
            span.margin = this.margin.clone();
        }
        // if (!isNullOrUndefined(this.paragraph) && this.paragraph.isInHeaderFooter) {
        //     if (this.revisionLength > 0) {
        //         for (let i: number = 0; i < this.revisionLength; i++) {
        //             let revisionChange: Revision = this.getRevision(i);
        //             span.addRevision(revisionChange.clone());
        //         }
        //     }
        // } else {
        if (this.revisionLength > 0) {
            span.removedIds = Revision.cloneRevisions(this.getAllRevision());
        }
        else {
            span.removedIds = this.removedIds.slice();
        }
        // }
        span.type = this.type;
        span.width = this.width;
        span.height = this.height;
        span.reference = this.reference;
        return span;
    }
    /**
     * @private
     */
    destroy() {
        this.contentControlProperties = undefined;
        this.contentControlWidgetType = undefined;
        super.destroy();
    }
    /**
     * Disposes the internal objects which are maintained.
     * @private
     */
    componentDestroy() {
        if (this.contentControlProperties) {
            this.contentControlProperties.destroy();
            this.contentControlProperties = undefined;
        }
        this.contentControlWidgetType = undefined;
        super.componentDestroy();
    }
}
/**
 * @private
 */
/**
 * @private
 */
export class ContentControlProperties {
    constructor(widgetType) {
        /**
         * @private
         */
        this.contentControlListItems = [];
        this.contentControlWidgetType = widgetType;
        this.characterFormat = new WCharacterFormat();
    }
    /**
     * @private
     */
    destroy() {
        if (this.characterFormat) {
            this.characterFormat.destroy();
            this.characterFormat = undefined;
        }
        if (this.xmlMapping) {
            this.xmlMapping.destroy();
            this.xmlMapping = undefined;
        }
        this.lockContentControl = undefined;
        this.lockContents = undefined;
        this.tag = undefined;
        this.color = undefined;
        this.title = undefined;
        this.appearance = undefined;
        this.type = undefined;
        this.hasPlaceHolderText = undefined;
        this.multiline = undefined;
        this.isTemporary = undefined;
        this.isChecked = undefined;
        this.dateCalendarType = undefined;
        this.dateStorageFormat = undefined;
        this.dateDisplayLocale = undefined;
        this.dateDisplayFormat = undefined;
    }
    /**
     * @private
     */
    clone() {
        let span = new ContentControlProperties(this.contentControlWidgetType);
        span.lockContentControl = this.lockContentControl;
        span.lockContents = this.lockContents;
        span.tag = this.tag;
        span.color = this.color;
        span.title = this.title;
        span.appearance = this.appearance;
        span.type = this.type;
        span.hasPlaceHolderText = this.hasPlaceHolderText;
        span.multiline = this.multiline;
        span.isTemporary = this.isTemporary;
        span.isChecked = this.isChecked;
        span.dateCalendarType = this.dateCalendarType;
        span.dateStorageFormat = this.dateStorageFormat;
        span.dateDisplayLocale = this.dateDisplayLocale;
        span.dateDisplayFormat = this.dateDisplayFormat;
        if (this.contentControlListItems.length > 0) {
            for (let i = 0; i < this.contentControlListItems.length; i++) {
                span.contentControlListItems.push(this.contentControlListItems[i].clone());
            }
        }
        if (this.checkedState) {
            span.checkedState = this.checkedState.clone();
        }
        if (this.uncheckedState) {
            span.uncheckedState = this.uncheckedState.clone();
        }
        if (this.xmlMapping) {
            span.xmlMapping = this.xmlMapping.clone();
        }
        return span;
    }
}
/**
 * @private
 */
export class ContentControlListItems {
    /**
     * @private
     */
    destroy() {
        this.displayText = undefined;
        this.value = undefined;
    }
    /**
     * @private
     */
    clone() {
        let span = new ContentControlListItems();
        span.displayText = this.displayText;
        span.value = this.value;
        return span;
    }
}
/**
 * @private
 */
export class CheckBoxState {
    /**
     * @private
     */
    destroy() {
        this.font = undefined;
        this.value = undefined;
    }
    /**
     * @private
     */
    clone() {
        let span = new CheckBoxState();
        span.font = this.font;
        span.value = this.value;
        return span;
    }
}
/**
 * @private
 */
export class XmlMapping {
    /**
     * @private
     */
    destroy() {
        this.isMapped = undefined;
        this.isWordMl = undefined;
        this.prefixMapping = undefined;
        this.xPath = undefined;
        this.storeItemId = undefined;
        this.customXmlPart = undefined;
    }
    /**
     * @private
     */
    clone() {
        let span = new XmlMapping();
        span.isMapped = this.isMapped;
        span.isWordMl = this.isWordMl;
        span.prefixMapping = this.prefixMapping;
        span.xPath = this.xPath;
        span.storeItemId = this.storeItemId;
        if (this.customXmlPart) {
            span.customXmlPart = this.customXmlPart.clone();
        }
        return span;
    }
}
/**
 * @private
 */
export class CustomXmlPart {
    /**
     * @private
     */
    destroy() {
        this.id = undefined;
        this.xml = undefined;
    }
    /**
     * @private
     */
    clone() {
        let span = new CustomXmlPart();
        span.id = this.id;
        span.xml = this.xml;
        return span;
    }
}
/**
 * @private
 */
export class ShapeCommon extends ElementBox {
    constructor() {
        super(...arguments);
        /**
         * @private
         */
        this.name = '';
        /**
         * @private
         */
        this.alternateText = '';
        /**
         * @private
         */
        this.title = '';
    }
    /**
     *
     * @private
     */
    getLength() {
        return 1;
    }
    /**
     * @private
     */
    clone() {
        let shape = this instanceof GroupShapeElementBox ? new GroupShapeElementBox() : new ShapeElementBox();
        return shape;
    }
}
/**
 * @private
 */
export class ShapeBase extends ShapeCommon {
    constructor() {
        super(...arguments);
        /**
         * @private
         */
        this.verticalPosition = 0;
        /**
         * @private
         */
        this.horizontalPosition = 0;
        /**
         * @private
         */
        this.textWrappingStyle = 'Inline';
        /**
         * @private
         */
        this.distanceBottom = 0;
        /**
         * @private
         */
        this.distanceLeft = 0;
        /**
         * @private
         */
        this.distanceRight = 0;
        /**
         * @private
         */
        this.distanceTop = 0;
    }
}
/**
 * @private
 */
export class ShapeElementBox extends ShapeBase {
    /**
     * @private
     */
    clone() {
        let shape = new ShapeElementBox();
        shape.characterFormat.copyFormat(this.characterFormat);
        shape.x = this.x;
        shape.y = this.y;
        shape.width = this.width;
        shape.height = this.height;
        shape.shapeId = this.shapeId;
        shape.name = this.name;
        shape.alternateText = this.alternateText;
        shape.title = this.title;
        shape.widthScale = this.widthScale;
        shape.heightScale = this.heightScale;
        shape.visible = this.visible;
        shape.verticalPosition = this.verticalPosition;
        shape.verticalAlignment = this.verticalAlignment;
        shape.verticalOrigin = this.verticalOrigin;
        shape.verticalRelativePercent = this.verticalRelativePercent;
        shape.horizontalPosition = this.horizontalPosition;
        shape.horizontalAlignment = this.horizontalAlignment;
        shape.horizontalOrigin = this.horizontalOrigin;
        shape.horizontalRelativePercent = this.horizontalRelativePercent;
        shape.heightRelativePercent = this.heightRelativePercent;
        shape.widthRelativePercent = this.widthRelativePercent;
        shape.zOrderPosition = this.zOrderPosition;
        shape.allowOverlap = this.allowOverlap;
        shape.textWrappingStyle = this.textWrappingStyle;
        shape.textWrappingType = this.textWrappingType;
        shape.distanceBottom = this.distanceBottom;
        shape.distanceLeft = this.distanceLeft;
        shape.distanceRight = this.distanceRight;
        shape.distanceTop = this.distanceTop;
        shape.editingPoints = this.editingPoints;
        shape.layoutInCell = this.layoutInCell;
        shape.lockAnchor = this.lockAnchor;
        shape.autoShapeType = this.autoShapeType;
        shape.shapeX = this.shapeX;
        shape.shapeY = this.shapeY;
        shape.shapeHeight = this.shapeHeight;
        shape.shapeWidth = this.shapeWidth;
        if (this.lineFormat) {
            shape.lineFormat = this.lineFormat.clone();
        }
        if (this.fillFormat) {
            shape.fillFormat = this.fillFormat.clone();
        }
        if (this.textFrame) {
            shape.textFrame = this.textFrame.clone();
            shape.textFrame.containerShape = shape;
        }
        if (this.margin) {
            shape.margin = this.margin.clone();
        }
        // if (!isNullOrUndefined(this.paragraph) && this.paragraph.isInHeaderFooter) {
        //     if (this.revisionLength > 0) {
        //         for (let i: number = 0; i < this.revisionLength; i++) {
        //             let revision: Revision = this.getRevision(i);
        //             shape.addRevision(revision.clone());
        //         }
        //     }
        // } else {
        if (this.revisionLength > 0) {
            shape.removedIds = Revision.cloneRevisions(this.getAllRevision());
        }
        else {
            shape.removedIds = this.removedIds.slice();
        }
        // }
        return shape;
    }
}
/**
 * @private
 */
export class GroupShapeElementBox extends ShapeBase {
    constructor() {
        super(...arguments);
        /**
         * @private
         */
        this.childWidgets = [];
    }
    /**
     * @private
     */
    clone() {
        const group = new GroupShapeElementBox();
        group.characterFormat.copyFormat(this.characterFormat);
        group.x = this.x;
        group.y = this.y;
        group.width = this.width;
        group.height = this.height;
        group.shapeId = this.shapeId;
        group.name = this.name;
        group.alternateText = this.alternateText;
        group.title = this.title;
        group.widthScale = this.widthScale;
        group.heightScale = this.heightScale;
        group.visible = this.visible;
        group.verticalPosition = this.verticalPosition;
        group.verticalAlignment = this.verticalAlignment;
        group.verticalOrigin = this.verticalOrigin;
        group.verticalRelativePercent = this.verticalRelativePercent;
        group.horizontalPosition = this.horizontalPosition;
        group.horizontalAlignment = this.horizontalAlignment;
        group.horizontalOrigin = this.horizontalOrigin;
        group.horizontalRelativePercent = this.horizontalRelativePercent;
        group.heightRelativePercent = this.heightRelativePercent;
        group.widthRelativePercent = this.widthRelativePercent;
        group.zOrderPosition = this.zOrderPosition;
        group.allowOverlap = this.allowOverlap;
        group.textWrappingStyle = this.textWrappingStyle;
        group.textWrappingType = this.textWrappingType;
        group.distanceBottom = this.distanceBottom;
        group.distanceLeft = this.distanceLeft;
        group.distanceRight = this.distanceRight;
        group.distanceTop = this.distanceTop;
        group.editingPoints = this.editingPoints;
        group.layoutInCell = this.layoutInCell;
        group.lockAnchor = this.lockAnchor;
        group.isZeroHeight = this.isZeroHeight;
        group.autoShapeType = this.autoShapeType;
        group.offsetXValue = this.offsetXValue;
        group.offsetYValue = this.offsetYValue;
        group.extentXValue = this.extentXValue;
        group.extentYValue = this.extentYValue;
        group.shapeX = this.shapeX;
        group.shapeY = this.shapeY;
        group.shapeHeight = this.shapeHeight;
        group.shapeWidth = this.shapeWidth;
        if (this.lineFormat) {
            group.lineFormat = this.lineFormat.clone();
        }
        if (this.fillFormat) {
            group.fillFormat = this.fillFormat.clone();
        }
        if (this.margin) {
            group.margin = this.margin.clone();
        }
        if (!isNullOrUndefined(this.paragraph) && this.paragraph.isInHeaderFooter) {
            if (this.revisions.length > 0) {
                for (let i = 0; i < this.revisions.length; i++) {
                    let revision = this.revisions[i];
                    group.revisions.push(revision.clone());
                }
            }
        }
        else {
            if (this.revisions.length > 0) {
                group.removedIds = Revision.cloneRevisions(this.revisions);
            }
            else {
                group.removedIds = this.removedIds.slice();
            }
        }
        for (let i = 0; i < this.childWidgets.length; i++) {
            let child = this.childWidgets[i];
            child = child.clone();
            if (isNullOrUndefined(child.line)) {
                child.line = this.line;
            }
            child.containerShape = group;
            group.childWidgets.push(child);
        }
        return group;
    }
    destroy() {
        this.isZeroHeight = undefined;
        this.autoShapeType = undefined;
        this.childWidgets = undefined;
        this.offsetXValue = undefined;
        this.offsetYValue = undefined;
        this.extentXValue = undefined;
        this.extentYValue = undefined;
        super.destroy();
    }
}
/**
 * @private
 */
export class TextFrame extends Widget {
    constructor() {
        super(...arguments);
        /**
         * @private
         */
        this.marginLeft = 0;
        /**
         * @private
         */
        this.marginRight = 0;
        /**
         * @private
         */
        this.marginTop = 0;
        /**
         * @private
         */
        this.marginBottom = 0;
    }
    equals() {
        return false;
    }
    destroyInternal() {
        //return;
    }
    getHierarchicalIndex(index) {
        let line = this.containerShape.line;
        let offset = line.getOffset(this.containerShape, 0).toString();
        return line.getHierarchicalIndex(offset);
    }
    getTableCellWidget() {
        return undefined;
    }
    /**
     * @private
     */
    clone() {
        let textFrame = new TextFrame();
        textFrame.textVerticalAlignment = this.textVerticalAlignment;
        textFrame.marginBottom = this.marginBottom;
        textFrame.marginLeft = this.marginLeft;
        textFrame.marginRight = this.marginRight;
        textFrame.marginTop = this.marginTop;
        for (let i = 0; i < this.childWidgets.length; i++) {
            let block = this.childWidgets[i].clone();
            textFrame.childWidgets.push(block);
            block.index = i;
            block.containerWidget = textFrame;
        }
        return textFrame;
    }
}
/**
 * @private
 */
export class LineFormat {
    /**
     * @private
     */
    clone() {
        let lineFormat = new LineFormat();
        lineFormat.lineFormatType = this.lineFormatType;
        lineFormat.color = this.color;
        lineFormat.weight = this.weight;
        lineFormat.dashStyle = this.dashStyle;
        lineFormat.line = this.line;
        return lineFormat;
    }
}
/**
 * @private
 */
export class FillFormat {
    /**
     * @private
     */
    clone() {
        let fillFormat = new FillFormat();
        fillFormat.color = this.color;
        fillFormat.fill = this.fill;
        return fillFormat;
    }
}
/**
 * @private
 */
export class ImageElementBox extends ShapeBase {
    constructor(isInlineImage) {
        super();
        this.imageStr = '';
        this.imgElement = undefined;
        this.isInlineImageIn = true;
        this.crop = false;
        /**
         * @private
         */
        this.left = 0;
        /**
         * @private
         */
        this.top = 0;
        /**
         * @private
         */
        this.right = 0;
        /**
         * @private
         */
        this.bottom = 0;
        /**
         * @private
         */
        this.isMetaFile = false;
        /**
         * @private
         */
        this.isCompressed = false;
        this.isInlineImageIn = isInlineImage;
    }
    /**
     * @private
     */
    get isCrop() {
        return this.crop;
    }
    set isCrop(value) {
        this.crop = value;
        if (value) {
            let right = 0;
            let bottom = 0;
            if (this.left !== 0) {
                this.cropX = (this.left * this.cropWidthScale) / 100;
            }
            else {
                this.cropX = 0;
            }
            if (this.top !== 0) {
                this.cropY = (this.top * this.cropHeightScale) / 100;
            }
            else {
                this.cropY = 0;
            }
            if (this.right !== 0) {
                right = (this.right * this.cropWidthScale) / 100;
            }
            if (this.bottom !== 0) {
                bottom = (this.bottom * this.cropHeightScale) / 100;
            }
            this.cropWidth = (this.cropWidthScale - (this.cropX + right));
            this.cropHeight = (this.cropHeightScale - (this.cropY + bottom));
        }
    }
    /**
     * @private
     */
    get isInlineImage() {
        return this.isInlineImageIn;
    }
    /**
     * @private
     */
    get element() {
        if (isNullOrUndefined(this.imgElement)) {
            this.imgElement = document.createElement('img');
        }
        return this.imgElement;
    }
    /**
     * @private
     */
    get length() {
        return 1;
    }
    /**
     * @private
     */
    get imageString() {
        return this.imageStr;
    }
    /**
     * @private
     */
    set imageString(value) {
        this.imageStr = value;
    }
    /**
     * @private
     */
    getLength() {
        return 1;
    }
    /**
     * @private
     */
    clone() {
        let image = new ImageElementBox(this.isInlineImage);
        image.characterFormat.copyFormat(this.characterFormat);
        image.imageString = this.imageString;
        image.element.src = this.element.src;
        image.isMetaFile = this.isMetaFile;
        image.isCompressed = this.isCompressed;
        image.metaFileImageString = this.metaFileImageString;
        image.width = this.width;
        image.height = this.height;
        image.top = this.top;
        image.left = this.left;
        image.bottom = this.bottom;
        image.right = this.right;
        image.cropHeightScale = this.cropHeightScale;
        image.cropWidthScale = this.cropWidthScale;
        image.cropX = this.cropX;
        image.cropY = this.cropY;
        image.isCrop = this.isCrop;
        image.x = this.x;
        image.y = this.y;
        image.shapeX = this.shapeX;
        image.shapeY = this.shapeY;
        image.shapeHeight = this.shapeHeight;
        image.shapeWidth = this.shapeWidth;
        if (this.margin) {
            image.margin = this.margin.clone();
        }
        // if (!isNullOrUndefined(this.paragraph) && this.paragraph.isInHeaderFooter) {
        //     if (this.revisionLength > 0) {
        //         for (let i: number = 0; i < this.revisionLength; i++) {
        //             let revision: Revision = this.getRevision(i);
        //             image.addRevision(revision.clone());
        //         }
        //     }
        // } else {
        if (this.revisionLength > 0) {
            image.removedIds = Revision.cloneRevisions(this.getAllRevision());
        }
        else {
            image.removedIds = this.removedIds.slice();
        }
        // }
        image.name = this.name;
        image.alternateText = this.alternateText;
        image.title = this.title;
        image.visible = this.visible;
        image.widthScale = this.widthScale;
        image.heightScale = this.heightScale;
        image.verticalPosition = this.verticalPosition;
        image.verticalOrigin = this.verticalOrigin;
        image.verticalAlignment = this.verticalAlignment;
        image.horizontalPosition = this.horizontalPosition;
        image.horizontalOrigin = this.horizontalOrigin;
        image.horizontalAlignment = this.horizontalAlignment;
        image.allowOverlap = this.allowOverlap;
        image.textWrappingStyle = this.textWrappingStyle;
        image.textWrappingType = this.textWrappingType;
        image.layoutInCell = this.layoutInCell;
        image.zOrderPosition = this.zOrderPosition;
        return image;
    }
    /**
     * @private
     */
    destroy() {
        this.imgElement = undefined;
        this.imageString = undefined;
        this.isInlineImageIn = undefined;
        super.destroy();
    }
}
/**
 * @private
 */
export class ListTextElementBox extends ElementBox {
    constructor(listLevel, isListFollowCharacter) {
        super();
        /**
         * @private
         */
        this.baselineOffset = 0;
        /**
         * @private
         */
        this.trimEndWidth = 0;
        /**
         * @private
         */
        this.isFollowCharacter = false;
        this.listLevel = listLevel;
        this.isFollowCharacter = isListFollowCharacter;
    }
    /**
     * @private
     */
    getLength() {
        return this.text ? this.text.length : 0;
    }
    /**
     * @private
     */
    clone() {
        let list = new ListTextElementBox(this.listLevel, this.isFollowCharacter);
        list.text = this.text;
        list.baselineOffset = this.baselineOffset;
        if (this.margin) {
            list.margin = this.margin.clone();
        }
        list.width = this.width;
        list.height = this.height;
        return list;
    }
    /**
     * @private
     */
    destroy() {
        this.text = undefined;
        super.destroy();
    }
}
/**
 * @private
 */
export class EditRangeEndElementBox extends ElementBox {
    constructor() {
        super();
        /**
         * @private
         */
        this.editRangeStart = undefined;
        this.editRangeId = -1;
    }
    /**
     * @private
     */
    getLength() {
        return 1;
    }
    /**
     * @private
     */
    destroy() {
        this.editRangeStart = undefined;
    }
    /**
     * @private
     */
    clone() {
        let end = new EditRangeEndElementBox();
        if (this.editRangeStart) {
            this.editRangeStart.editRangeEnd = end;
        }
        end.editRangeStart = this.editRangeStart;
        end.editRangeId = this.editRangeId;
        return end;
    }
}
/**
 * @private
 */
export class EditRangeStartElementBox extends ElementBox {
    constructor() {
        super();
        /**
         * @private
         */
        this.columnFirst = -1;
        /**
         * @private
         */
        this.columnLast = -1;
        /**
         * @private
         */
        this.user = '';
        /**
         * @private
         */
        this.group = '';
        this.editRangeId = -1;
    }
    /**
     * @private
     */
    getLength() {
        return 1;
    }
    /**
     * @private
     */
    renderLockMark(currentUser, locale) {
        if (isNullOrUndefined(this.editRangeMark)) {
            let user = currentUser === this.user ? 'you' : this.user;
            this.editRangeMark = document.createElement('div');
            this.editRangeMark.style.display = 'none';
            this.editRangeMark.classList.add('e-de-lock-mark');
            let span = document.createElement('span');
            span.className = 'e-icons e-de-ctnr-lock';
            this.editRangeMark.appendChild(span);
            this.editRangeMark.title = locale.getConstant('This region is locked by') + ' ' + user;
        }
        if (this.line && isNullOrUndefined(this.editRangeMark.parentElement)) {
            let documentHelper = this.line.paragraph.bodyWidget.page.documentHelper;
            documentHelper.pageContainer.appendChild(this.editRangeMark);
        }
    }
    /**
     * @private
     */
    removeEditRangeMark() {
        if (this.editRangeMark) {
            this.editRangeMark.parentElement.removeChild(this.editRangeMark);
            this.editRangeMark = undefined;
        }
    }
    /**
     * @private
     */
    destroy() {
        this.user = undefined;
        this.columnFirst = undefined;
        this.columnLast = undefined;
    }
    /**
     * @private
     */
    clone() {
        let start = new EditRangeStartElementBox();
        start.columnFirst = this.columnFirst;
        start.columnLast = this.columnLast;
        start.user = this.user;
        start.group = this.group;
        if (this.editRangeEnd) {
            this.editRangeEnd.editRangeStart = start;
        }
        start.editRangeEnd = this.editRangeEnd;
        start.editRangeId = this.editRangeId;
        return start;
    }
}
/**
 * @private
 */
export class ChartElementBox extends ImageElementBox {
    /**
     * @private
     */
    constructor() {
        super();
        /**
         * @private
         */
        this.chartTitle = '';
        /**
         * @private
         */
        this.chartType = '';
        /**
         * @private
         */
        this.chartElement = undefined;
        /**
         * @private
         */
        this.chartCategory = [];
        /**
         * @private
         */
        this.chartSeries = [];
        this.chartArea = new ChartArea();
        this.chartPlotArea = new ChartArea();
        this.chartTitleArea = new ChartTitleArea();
        this.chartLegend = new ChartLegend();
        this.chartPrimaryCategoryAxis = new ChartCategoryAxis();
        this.chartPrimaryValueAxis = new ChartCategoryAxis();
        this.chartDataTable = new ChartDataTable();
    }
    /**
     * @private
     */
    getLength() {
        return 1;
    }
    /**
     * @private
     */
    get title() {
        return this.chartTitle;
    }
    /**
     * @private
     */
    set title(value) {
        this.chartTitle = value;
    }
    /**
     * @private
     */
    get type() {
        return this.chartType;
    }
    /**
     * @private
     */
    set type(value) {
        this.chartType = value;
    }
    /**
     * @private
     */
    get chartGapWidth() {
        return this.gapWidth;
    }
    /**
     * @private
     */
    set chartGapWidth(value) {
        this.gapWidth = value;
    }
    /**
     * @private
     */
    get chartOverlap() {
        return this.overlap;
    }
    /**
     * @private
     */
    set chartOverlap(value) {
        this.overlap = value;
    }
    /**
     * @private
     */
    get targetElement() {
        if (isNullOrUndefined(this.div)) {
            this.div = createElement('div');
        }
        return this.div;
    }
    /**
     * @private
     */
    get officeChart() {
        return this.officeChartInternal;
    }
    /**
     * @private
     */
    set officeChart(value) {
        if (value) {
            this.officeChartInternal = value;
            this.officeChartInternal.chart.loaded = this.onChartLoaded.bind(this);
        }
    }
    onChartLoaded() {
        this.officeChart.convertChartToImage(this.officeChart.chart, this.width, this.height).then((dataURL) => {
            this.imageString = dataURL;
            this.element.src = dataURL;
        });
    }
    /**
     * @private
     */
    clone() {
        let chart = new ChartElementBox();
        chart.x = this.x;
        chart.y = this.y;
        chart.chartTitle = this.chartTitle;
        chart.chartType = this.chartType;
        chart.height = this.height;
        chart.width = this.width;
        chart.gapWidth = this.gapWidth;
        chart.overlap = this.overlap;
        chart.imageString = this.imageString;
        chart.element.src = this.imageString;
        chart.officeChart = this.officeChart;
        chart.shapeX = this.shapeX;
        chart.shapeY = this.shapeY;
        chart.shapeHeight = this.shapeHeight;
        chart.shapeWidth = this.shapeWidth;
        for (let i = 0; i < this.chartCategory.length; i++) {
            let chartCategory = this.chartCategory[i].clone();
            chart.chartCategory.push(chartCategory);
        }
        for (let i = 0; i < this.chartSeries.length; i++) {
            let series = this.chartSeries[i].clone();
            chart.chartSeries.push(series);
        }
        chart.chartArea = this.chartArea.clone();
        chart.chartPlotArea = this.chartPlotArea.clone();
        chart.chartLegend = this.chartLegend.clone();
        chart.chartTitleArea = this.chartTitleArea.clone();
        chart.chartPrimaryCategoryAxis = this.chartPrimaryCategoryAxis.clone();
        chart.chartPrimaryValueAxis = this.chartPrimaryValueAxis.clone();
        chart.chartDataTable = this.chartDataTable.clone();
        return chart;
    }
    /**
     * @private
     */
    destroy() {
        super.destroy();
        if (!isNullOrUndefined(this.officeChartInternal)) {
            this.officeChartInternal.chart.loaded = undefined;
            this.officeChartInternal.destroy();
            this.officeChartInternal = undefined;
        }
        if (this.div) {
            this.div = undefined;
        }
        this.chartTitle = undefined;
        this.chartType = undefined;
        this.chartArea = undefined;
        this.chartPlotArea = undefined;
        this.chartCategory = [];
        this.chartSeries = [];
        this.chartTitleArea = undefined;
        this.chartLegend = undefined;
        this.chartPrimaryCategoryAxis = undefined;
        this.chartPrimaryValueAxis = undefined;
        this.chartDataTable = undefined;
        this.chartElement = undefined;
    }
}
/**
 * @private
 */
export class ChartArea {
    /**
     * @private
     */
    get chartForeColor() {
        return this.foreColor;
    }
    /**
     * @private
     */
    set chartForeColor(value) {
        this.foreColor = value;
    }
    /**
     * @private
     */
    clone() {
        let chart = new ChartArea();
        chart.foreColor = this.foreColor;
        return chart;
    }
    /**
     * @private
     */
    destroy() {
        this.foreColor = undefined;
    }
}
/**
 * @private
 */
export class ChartCategory {
    constructor() {
        /**
         * @private
         */
        this.categoryXName = '';
        /**
         * @private
         */
        this.chartData = [];
    }
    /**
     * @private
     */
    get xName() {
        return this.categoryXName;
    }
    /**
     * @private
     */
    set xName(value) {
        this.categoryXName = value;
    }
    /**
     * @private
     */
    clone() {
        let chart = new ChartCategory();
        chart.categoryXName = this.categoryXName;
        for (let i = 0; i < this.chartData.length; i++) {
            let chartData = this.chartData[i].clone();
            chart.chartData.push(chartData);
        }
        return chart;
    }
    /**
     * @private
     */
    destroy() {
        this.categoryXName = undefined;
        this.chartData = [];
    }
}
/**
 * @private
 */
export class ChartData {
    /**
     * @private
     */
    get yAxisValue() {
        return this.yValue;
    }
    /**
     * @private
     */
    set yAxisValue(value) {
        this.yValue = value;
    }
    /**
     * @private
     */
    get xAxisValue() {
        return this.xValue;
    }
    /**
     * @private
     */
    set xAxisValue(value) {
        this.xValue = value;
    }
    /**
     * @private
     */
    get bubbleSize() {
        return this.size;
    }
    /**
     * @private
     */
    set bubbleSize(value) {
        this.size = value;
    }
    /**
     * @private
     */
    clone() {
        let chart = new ChartData();
        chart.yValue = this.yValue;
        chart.xValue = this.xValue;
        chart.size = this.size;
        return chart;
    }
    /**
     * @private
     */
    destroy() {
        this.xValue = undefined;
        this.yValue = undefined;
        this.size = undefined;
    }
}
/**
 * @private
 */
export class ChartLegend {
    /**
     * @private
     */
    get chartLegendPostion() {
        return this.legendPostion;
    }
    /**
     * @private
     */
    set chartLegendPostion(value) {
        this.legendPostion = value;
    }
    /**
     * @private
     */
    constructor() {
        this.chartTitleArea = new ChartTitleArea();
    }
    /**
     * @private
     */
    clone() {
        let chart = new ChartLegend();
        chart.legendPostion = this.legendPostion;
        chart.chartTitleArea = this.chartTitleArea.clone();
        return chart;
    }
    /**
     * @private
     */
    destroy() {
        this.legendPostion = undefined;
        this.chartTitleArea = undefined;
    }
}
/**
 * @private
 */
export class ChartSeries {
    constructor() {
        /**
         * @private
         */
        this.chartDataFormat = [];
        /**
         * @private
         */
        this.trendLines = [];
        this.errorBar = new ChartErrorBar();
        this.dataLabels = new ChartDataLabels();
        this.seriesFormat = new ChartSeriesFormat();
    }
    /**
     * @private
     */
    get seriesName() {
        return this.name;
    }
    /**
     * @private
     */
    set seriesName(value) {
        this.name = value;
    }
    /**
     * @private
     */
    get firstSliceAngle() {
        return this.sliceAngle;
    }
    /**
     * @private
     */
    set firstSliceAngle(value) {
        this.sliceAngle = value;
    }
    /**
     * @private
     */
    get doughnutHoleSize() {
        return this.holeSize;
    }
    /**
     * @private
     */
    set doughnutHoleSize(value) {
        this.holeSize = value;
    }
    /**
     * @private
     */
    clone() {
        let chart = new ChartSeries();
        chart.name = this.name;
        chart.sliceAngle = this.sliceAngle;
        chart.holeSize = this.holeSize;
        chart.errorBar = this.errorBar.clone();
        chart.dataLabels = this.dataLabels.clone();
        chart.seriesFormat = this.seriesFormat.clone();
        for (let i = 0; i < this.chartDataFormat.length; i++) {
            let format = (this.chartDataFormat[i].clone());
            chart.chartDataFormat.push(format);
        }
        for (let i = 0; i < this.trendLines.length; i++) {
            let trendLine = (this.trendLines[i].clone());
            chart.trendLines.push(trendLine);
        }
        return chart;
    }
    /**
     * @private
     */
    destroy() {
        this.name = undefined;
        this.errorBar = undefined;
        this.trendLines = undefined;
        this.chartDataFormat = [];
    }
}
/**
 * @private
 */
export class ChartErrorBar {
    /**
     * @private
     */
    get errorType() {
        return this.type;
    }
    /**
     * @private
     */
    set errorType(value) {
        this.type = value;
    }
    /**
     * @private
     */
    get errorDirection() {
        return this.direction;
    }
    /**
     * @private
     */
    set errorDirection(value) {
        this.direction = value;
    }
    /**
     * @private
     */
    get errorEndStyle() {
        return this.endStyle;
    }
    /**
     * @private
     */
    set errorEndStyle(value) {
        this.endStyle = value;
    }
    get numberValue() {
        return this.errorValue;
    }
    /**
     * @private
     */
    set numberValue(value) {
        this.errorValue = value;
    }
    /**
     * @private
     */
    clone() {
        let chart = new ChartErrorBar();
        chart.type = this.type;
        chart.errorDirection = this.errorDirection;
        chart.endStyle = this.endStyle;
        chart.errorValue = this.errorValue;
        return chart;
    }
    /**
     * @private
     */
    destroy() {
        this.type = undefined;
        this.errorDirection = undefined;
        this.endStyle = undefined;
    }
}
/**
 * @private
 */
export class ChartSeriesFormat {
    /**
     * @private
     */
    get markerStyle() {
        return this.style;
    }
    /**
     * @private
     */
    set markerStyle(value) {
        this.style = value;
    }
    /**
     * @private
     */
    get markerColor() {
        return this.color;
    }
    /**
     * @private
     */
    set markerColor(value) {
        this.color = value;
    }
    /**
     * @private
     */
    get numberValue() {
        return this.size;
    }
    /**
     * @private
     */
    set numberValue(value) {
        this.size = value;
    }
    /**
     * @private
     */
    clone() {
        let chart = new ChartSeriesFormat();
        chart.style = this.style;
        chart.color = this.color;
        chart.size = this.size;
        return chart;
    }
    /**
     * @private
     */
    destroy() {
        this.style = undefined;
        this.color = undefined;
        this.size = undefined;
    }
}
/**
 * @private
 */
export class ChartDataLabels {
    /**
     * @private
     */
    get labelPosition() {
        return this.position;
    }
    /**
     * @private
     */
    set labelPosition(value) {
        this.position = value;
    }
    /**
     * @private
     */
    get fontName() {
        return this.name;
    }
    /**
     * @private
     */
    set fontName(value) {
        this.name = value;
    }
    /**
     * @private
     */
    get fontColor() {
        return this.color;
    }
    /**
     * @private
     */
    set fontColor(value) {
        this.color = value;
    }
    /**
     * @private
     */
    get fontSize() {
        return this.size;
    }
    /**
     * @private
     */
    set fontSize(value) {
        this.size = value;
    }
    /**
     * @private
     */
    get isLegendKey() {
        return this.isLegend;
    }
    /**
     * @private
     */
    set isLegendKey(value) {
        this.isLegend = value;
    }
    /**
     * @private
     */
    get isBubbleSize() {
        return this.isBubble;
    }
    /**
     * @private
     */
    set isBubbleSize(value) {
        this.isBubble = value;
    }
    /**
     * @private
     */
    get isCategoryName() {
        return this.isCategory;
    }
    /**
     * @private
     */
    set isCategoryName(value) {
        this.isCategory = value;
    }
    /**
     * @private
     */
    get isSeriesName() {
        return this.isSeries;
    }
    /**
     * @private
     */
    set isSeriesName(value) {
        this.isSeries = value;
    }
    /**
     * @private
     */
    get isValue() {
        return this.isValueEnabled;
    }
    /**
     * @private
     */
    set isValue(value) {
        this.isValueEnabled = value;
    }
    /**
     * @private
     */
    get isPercentage() {
        return this.isPercentageEnabled;
    }
    /**
     * @private
     */
    set isPercentage(value) {
        this.isPercentageEnabled = value;
    }
    /**
     * @private
     */
    get isLeaderLines() {
        return this.showLeaderLines;
    }
    /**
     * @private
     */
    set isLeaderLines(value) {
        this.showLeaderLines = value;
    }
    /**
     * @private
     */
    clone() {
        let chart = new ChartDataLabels();
        chart.position = this.position;
        chart.name = this.name;
        chart.color = this.color;
        chart.size = this.size;
        chart.isBubble = this.isBubble;
        chart.isLegend = this.isLegend;
        chart.isCategory = this.isCategory;
        chart.isSeries = this.isSeries;
        chart.isValueEnabled = this.isValueEnabled;
        chart.isPercentageEnabled = this.isPercentageEnabled;
        chart.showLeaderLines = this.showLeaderLines;
        return chart;
    }
    /**
     * @private
     */
    destroy() {
        this.position = undefined;
    }
}
/**
 * @private
 */
export class ChartTrendLines {
    /**
     * @private
     */
    get trendLineType() {
        return this.type;
    }
    /**
     * @private
     */
    set trendLineType(value) {
        this.type = value;
    }
    /**
     * @private
     */
    get trendLineName() {
        return this.name;
    }
    /**
     * @private
     */
    set trendLineName(value) {
        this.name = value;
    }
    /**
     * @private
     */
    get interceptValue() {
        return this.intercept;
    }
    /**
     * @private
     */
    set interceptValue(value) {
        this.intercept = value;
    }
    /**
     * @private
     */
    get forwardValue() {
        return this.forward;
    }
    /**
     * @private
     */
    set forwardValue(value) {
        this.forward = value;
    }
    /**
     * @private
     */
    get backwardValue() {
        return this.backward;
    }
    /**
     * @private
     */
    set backwardValue(value) {
        this.backward = value;
    }
    /**
     * @private
     */
    get isDisplayRSquared() {
        return this.displayRSquared;
    }
    /**
     * @private
     */
    set isDisplayRSquared(value) {
        this.displayRSquared = value;
    }
    /**
     * @private
     */
    get isDisplayEquation() {
        return this.displayEquation;
    }
    /**
     * @private
     */
    set isDisplayEquation(value) {
        this.displayEquation = value;
    }
    /**
     * @private
     */
    clone() {
        let chart = new ChartTrendLines();
        chart.type = this.type;
        chart.name = this.name;
        chart.forward = this.forward;
        chart.backward = this.backward;
        chart.intercept = this.intercept;
        chart.displayEquation = this.displayEquation;
        chart.displayRSquared = this.displayRSquared;
        return chart;
    }
    /**
     * @private
     */
    destroy() {
        this.type = undefined;
        this.name = undefined;
        this.forward = undefined;
        this.backward = undefined;
    }
}
/**
 * @private
 */
export class ChartTitleArea {
    /**
     * @private
     */
    get chartfontName() {
        return this.fontName;
    }
    /**
     * @private
     */
    set chartfontName(value) {
        this.fontName = value;
    }
    /**
     * @private
     */
    get chartFontSize() {
        return this.fontSize;
    }
    /**
     * @private
     */
    set chartFontSize(value) {
        this.fontSize = value;
    }
    /**
     * @private
     */
    constructor() {
        this.dataFormat = new ChartDataFormat();
        this.layout = new ChartLayout();
    }
    /**
     * @private
     */
    clone() {
        let chart = new ChartTitleArea();
        chart.fontName = this.fontName;
        chart.fontSize = this.fontSize;
        chart.dataFormat = this.dataFormat.clone();
        chart.layout = this.layout.clone();
        return chart;
    }
    /**
     * @private
     */
    destroy() {
        this.fontName = undefined;
        this.fontSize = undefined;
        this.dataFormat = undefined;
        this.layout = undefined;
    }
}
/**
 * @private
 */
export class ChartDataFormat {
    /**
     * @private
     */
    constructor() {
        this.fill = new ChartFill();
        this.line = new ChartFill();
    }
    /**
     * @private
     */
    clone() {
        let chart = new ChartDataFormat();
        chart.fill = this.fill.clone();
        chart.line = this.line.clone();
        return chart;
    }
    /**
     * @private
     */
    destroy() {
        this.fill = undefined;
        this.line = undefined;
    }
}
/**
 * @private
 */
export class ChartFill {
    /**
     * @private
     */
    get color() {
        return this.fillColor;
    }
    /**
     * @private
     */
    set color(value) {
        this.fillColor = value;
    }
    /**
     * @private
     */
    get rgb() {
        return this.fillRGB;
    }
    /**
     * @private
     */
    set rgb(value) {
        this.fillRGB = value;
    }
    /**
     * @private
     */
    clone() {
        let chart = new ChartFill();
        chart.fillColor = this.fillColor;
        chart.fillRGB = this.fillRGB;
        return chart;
    }
    /**
     * @private
     */
    destroy() {
        this.fillColor = undefined;
        this.fillRGB = undefined;
    }
}
/**
 * @private
 */
export class ChartLayout {
    /**
     * @private
     */
    get chartLayoutLeft() {
        return this.layoutX;
    }
    /**
     * @private
     */
    set chartLayoutLeft(value) {
        this.layoutX = value;
    }
    /**
     * @private
     */
    get chartLayoutTop() {
        return this.layoutY;
    }
    /**
     * @private
     */
    set chartLayoutTop(value) {
        this.layoutY = value;
    }
    /**
     * @private
     */
    clone() {
        let chart = new ChartLayout();
        chart.layoutX = this.layoutX;
        chart.layoutY = this.layoutY;
        return chart;
    }
    /**
     * @private
     */
    destroy() {
        this.layoutX = undefined;
        this.layoutY = undefined;
    }
}
/**
 * @private
 */
export class ChartCategoryAxis {
    /**
     * @private
     */
    get majorTick() {
        return this.majorTickMark;
    }
    /**
     * @private
     */
    set majorTick(value) {
        this.majorTickMark = value;
    }
    /**
     * @private
     */
    get minorTick() {
        return this.minorTickMark;
    }
    /**
     * @private
     */
    set minorTick(value) {
        this.minorTickMark = value;
    }
    /**
     * @private
     */
    get tickPosition() {
        return this.tickLabelPostion;
    }
    /**
     * @private
     */
    set tickPosition(value) {
        this.tickLabelPostion = value;
    }
    /**
     * @private
     */
    get minorGridLines() {
        return this.hasMinorGridLines;
    }
    /**
     * @private
     */
    set minorGridLines(value) {
        this.hasMinorGridLines = value;
    }
    /**
     * @private
     */
    get majorGridLines() {
        return this.hasMajorGridLines;
    }
    /**
     * @private
     */
    set majorGridLines(value) {
        this.hasMajorGridLines = value;
    }
    /**
     * @private
     */
    get interval() {
        return this.majorUnit;
    }
    /**
     * @private
     */
    set interval(value) {
        this.majorUnit = value;
    }
    /**
     * @private
     */
    get isAutoInternal() {
        return this.isAutoMajor;
    }
    /**
     * @private
     */
    set isAutoInternal(value) {
        this.isAutoMajor = value;
    }
    /**
     * @private
     */
    get max() {
        return this.maximumValue;
    }
    /**
     * @private
     */
    set max(value) {
        this.maximumValue = value;
    }
    /**
     * @private
     */
    get min() {
        return this.minimumValue;
    }
    /**
     * @private
     */
    set min(value) {
        this.minimumValue = value;
    }
    /**
     * @private
     */
    get categoryAxisTitle() {
        return this.title;
    }
    /**
     * @private
     */
    set categoryAxisTitle(value) {
        this.title = value;
    }
    /**
     * @private
     */
    get categoryAxisType() {
        return this.categoryType;
    }
    /**
     * @private
     */
    set categoryAxisType(value) {
        this.categoryType = value;
    }
    /**
     * @private
     */
    get categoryNumberFormat() {
        return this.numberFormat;
    }
    /**
     * @private
     */
    set categoryNumberFormat(value) {
        this.numberFormat = value;
    }
    /**
     * @private
     */
    get axisFontSize() {
        return this.fontSize;
    }
    /**
     * @private
     */
    set axisFontSize(value) {
        this.fontSize = value;
    }
    /**
     * @private
     */
    get axisFontName() {
        return this.fontName;
    }
    /**
     * @private
     */
    set axisFontName(value) {
        this.fontName = value;
    }
    constructor() {
        this.chartTitleArea = new ChartTitleArea();
    }
    /**
     * @private
     */
    clone() {
        let chart = new ChartCategoryAxis();
        chart.title = this.title;
        chart.categoryType = this.categoryType;
        chart.numberFormat = this.numberFormat;
        chart.fontSize = this.fontSize;
        chart.fontName = this.fontName;
        chart.hasMajorGridLines = this.hasMajorGridLines;
        chart.hasMinorGridLines = this.hasMinorGridLines;
        chart.minimumValue = this.minimumValue;
        chart.maximumValue = this.maximumValue;
        chart.majorUnit = this.majorUnit;
        chart.isAutoMajor = this.isAutoMajor;
        chart.majorTickMark = this.majorTickMark;
        chart.minorTickMark = this.minorTickMark;
        chart.tickLabelPostion = this.tickLabelPostion;
        chart.chartTitleArea = this.chartTitleArea.clone();
        return chart;
    }
    /**
     * @private
     */
    destroy() {
        this.title = undefined;
        this.categoryType = undefined;
        this.numberFormat = undefined;
        this.chartTitleArea = undefined;
        this.minimumValue = undefined;
        this.maximumValue = undefined;
        this.fontSize = undefined;
        this.fontName = undefined;
        this.majorUnit = undefined;
        this.majorTickMark = undefined;
        this.minorTickMark = undefined;
        this.tickLabelPostion = undefined;
    }
}
/**
 * @private
 */
export class ChartDataTable {
    /**
     * @private
     */
    get showSeriesKeys() {
        return this.isSeriesKeys;
    }
    /**
     * @private
     */
    set showSeriesKeys(value) {
        this.isSeriesKeys = value;
    }
    /**
     * @private
     */
    get hasHorzBorder() {
        return this.isHorzBorder;
    }
    /**
     * @private
     */
    set hasHorzBorder(value) {
        this.isHorzBorder = value;
    }
    /**
     * @private
     */
    get hasVertBorder() {
        return this.isVertBorder;
    }
    /**
     * @private
     */
    set hasVertBorder(value) {
        this.isVertBorder = value;
    }
    /**
     * @private
     */
    get hasBorders() {
        return this.isBorders;
    }
    /**
     * @private
     */
    set hasBorders(value) {
        this.isBorders = value;
    }
    /**
     * @private
     */
    clone() {
        let chart = new ChartDataTable();
        chart.isSeriesKeys = this.isSeriesKeys;
        chart.isHorzBorder = this.isHorzBorder;
        chart.isVertBorder = this.isVertBorder;
        chart.isBorders = this.isBorders;
        return chart;
    }
    /**
     * @private
     */
    destroy() {
        this.isSeriesKeys = undefined;
        this.isHorzBorder = undefined;
        this.isVertBorder = undefined;
        this.isBorders = undefined;
    }
}
/**
 * @private
 */
export class CommentCharacterElementBox extends ElementBox {
    constructor(type) {
        super();
        this.commentType = 0;
        this.commentId = '';
        this.commentType = type;
    }
    get comment() {
        return this.commentInternal;
    }
    set comment(value) {
        this.commentInternal = value;
    }
    getLength() {
        return 1;
    }
    clone() {
        let comment = new CommentCharacterElementBox(this.commentType);
        comment.commentId = this.commentId;
        comment.commentType = this.commentType;
        if (!isNullOrUndefined(this.commentInternal)) {
            comment.commentInternal = this.commentInternal.clone();
        }
        return comment;
    }
    renderCommentMark(topPosition, leftPosition) {
        let documentHelper = this.line.paragraph.bodyWidget.page.documentHelper;
        let commentMarkDictionary = documentHelper.render.commentMarkDictionary;
        if (this.commentType === 0 && isNullOrUndefined(this.commentMark)) {
            this.commentMark = document.createElement('div');
            this.commentMark.style.display = 'none';
            this.commentMark.classList.add('e-de-cmt-mark');
            let span = document.createElement('span');
            span.classList.add('e-icons');
            span.classList.add('e-de-cmt-mark-icon');
            this.commentMark.appendChild(span);
        }
        if (this.line && isNullOrUndefined(this.commentMark.parentElement)) {
            documentHelper.pageContainer.appendChild(this.commentMark);
            this.commentMark.addEventListener('click', this.selectComment.bind(this));
        }
        let positionOverlap = false;
        let overlapKey;
        for (let index = 0; index < commentMarkDictionary.length; index++) {
            if (this.elementsOverlap(commentMarkDictionary.keys[index], topPosition, leftPosition)) {
                positionOverlap = true;
                overlapKey = commentMarkDictionary.keys[index];
                break;
            }
        }
        if (positionOverlap) {
            let ifNotPresent = true;
            for (let index = 0; index < commentMarkDictionary.get(overlapKey).length; index++) {
                if (commentMarkDictionary.get(overlapKey)[index] === this) {
                    ifNotPresent = false;
                    break;
                }
            }
            if (ifNotPresent) {
                commentMarkDictionary.get(overlapKey).push(this);
            }
        }
        else {
            commentMarkDictionary.add(this.commentMark, [this]);
        }
        for (let index = 0; index < commentMarkDictionary.length; index++) {
            let element = commentMarkDictionary.keys[index];
            if (commentMarkDictionary.get(element).length == 1) {
                if (commentMarkDictionary.get(element)[0].commentMark) {
                    if (commentMarkDictionary.get(element)[0].commentMark.firstElementChild.classList.contains('e-de-multi-cmt-mark')) {
                        classList(commentMarkDictionary.get(element)[0].commentMark.firstElementChild, ['e-de-cmt-mark-icon'], ['e-de-multi-cmt-mark']);
                    }
                    else if (commentMarkDictionary.get(element)[0].commentInternal.isResolved && commentMarkDictionary.get(element)[0].commentMark.firstElementChild.classList.contains('e-de-cmt-mark-icon')) {
                        classList(commentMarkDictionary.get(element)[0].commentMark.
                            firstElementChild, ['e-de-cmt-resolve-icon'], ['e-de-cmt-mark-icon']);
                    }
                    else if (!commentMarkDictionary.get(element)[0].commentInternal.isResolved && commentMarkDictionary.get(element)[0].commentMark.firstElementChild.classList.contains('e-de-cmt-resolve-icon')) {
                        classList(commentMarkDictionary.get(element)[0].commentMark.firstElementChild, ['e-de-cmt-mark-icon'], ['e-de-cmt-resolve-icon']);
                    }
                }
            }
            if (commentMarkDictionary.get(element).length > 1) {
                for (let z = 0; z < commentMarkDictionary.get(element).length; z++) {
                    let resolve = true;
                    for (var z_1 = 0; z_1 < commentMarkDictionary.get(element).length; z_1++) {
                        if (commentMarkDictionary.get(element)[z_1].commentInternal && !commentMarkDictionary.get(element)[z_1].commentInternal.isResolved) {
                            resolve = false;
                            break;
                        }
                    }
                    if (commentMarkDictionary.get(element)[z].commentMark) {
                        if (commentMarkDictionary.get(element)[z].commentMark.firstElementChild.classList.contains('e-de-cmt-mark-icon')) {
                            classList(commentMarkDictionary.get(element)[z].commentMark.firstElementChild, ['e-de-multi-cmt-mark'], ['e-de-cmt-mark-icon']);
                        }
                        else if (!resolve && commentMarkDictionary.get(element)[z].commentMark.firstElementChild.classList.contains('e-de-multi-cmt-resolve')) {
                            classList(commentMarkDictionary.get(element)[z].commentMark.firstElementChild, ['e-de-multi-cmt-mark'], ['e-de-multi-cmt-resolve']);
                        }
                        else if (resolve) {
                            classList(commentMarkDictionary.get(element)[z].commentMark.firstElementChild, ['e-de-multi-cmt-resolve'], ['e-de-multi-cmt-mark']);
                        }
                    }
                }
            }
        }
    }
    elementsOverlap(elementOne, top, left) {
        const width = elementOne.offsetWidth;
        const height = elementOne.offsetHeight;
        const elementOneTop = parseFloat(elementOne.style.top);
        const elementOneLeft = parseFloat(elementOne.style.left);
        const elementOneBottom = elementOneTop + height;
        const elementOneRight = elementOneLeft + width;
        const elementTwoTop = parseFloat(top);
        const elementTwoLeft = parseFloat(left);
        const elementTwoBottom = elementTwoTop + height;
        const elementTwoRight = elementTwoLeft + width;
        return !(elementOneTop > elementTwoBottom ||
            elementOneRight < elementTwoLeft ||
            elementOneBottom < elementTwoTop ||
            elementOneLeft > elementTwoRight);
    }
    selectComment() {
        let documentHelper = this.line.paragraph.bodyWidget.page.documentHelper;
        let commentMarkDictionary = documentHelper.render.commentMarkDictionary;
        let topPosition = this.commentMark.style.top;
        let leftPosition = this.commentMark.style.left;
        let currentIndex = 0;
        let navigationArray = [];
        for (let index = 0; index < commentMarkDictionary.keys.length; index++) {
            if (this.elementsOverlap(commentMarkDictionary.keys[index], topPosition, leftPosition)) {
                navigationArray = commentMarkDictionary.get(commentMarkDictionary.keys[index]);
                break;
            }
        }
        if (!documentHelper.owner.documentHelper.currentSelectedComment) {
            currentIndex = 0;
        }
        else {
            for (let index = 0; index < navigationArray.length; index++) {
                if (navigationArray[index].comment === documentHelper.owner.documentHelper.currentSelectedComment) {
                    currentIndex = index;
                    break;
                }
            }
            if (currentIndex < (navigationArray.length - 1)) {
                currentIndex += 1;
            }
            else {
                currentIndex = 0;
            }
        }
        if (documentHelper.owner) {
            if (!documentHelper.owner.commentReviewPane.commentPane.isEditMode) {
                documentHelper.selectComment(navigationArray[currentIndex].comment);
            }
            else {
                documentHelper.owner.showComments = true;
            }
        }
    }
    removeCommentMark() {
        if (this.commentMark && this.commentMark.parentElement) {
            this.commentMark.removeEventListener('click', this.selectComment.bind(this));
            this.commentMark.parentElement.removeChild(this.commentMark);
        }
    }
    destroy() {
        if (this.commentMark) {
            this.removeCommentMark();
        }
        this.commentMark = undefined;
        this.commentInternal = undefined;
        this.commentId = undefined;
        super.componentDestroy();
    }
}
/**
 * @private
 */
export class CommentElementBox extends CommentCharacterElementBox {
    constructor(date) {
        super(0);
        this.authorIn = '';
        this.initialIn = '';
        this.done = false;
        this.posted = false;
        this.textIn = '';
        this.isReply = false;
        this.ownerComment = undefined;
        this.mentionsIn = [];
        this.createdDate = date;
        this.replyComments = [];
    }
    get commentStart() {
        return this.commentStartIn;
    }
    set commentStart(value) {
        this.commentStartIn = value;
    }
    get commentEnd() {
        return this.commentEndIn;
    }
    set commentEnd(value) {
        this.commentEndIn = value;
    }
    get author() {
        return this.authorIn;
    }
    set author(value) {
        this.authorIn = value;
    }
    get initial() {
        return this.initialIn;
    }
    set initial(value) {
        this.initialIn = value;
    }
    get isResolved() {
        return this.done;
    }
    set isResolved(value) {
        this.done = value;
    }
    get date() {
        return this.createdDate;
    }
    get text() {
        return this.textIn;
    }
    set text(value) {
        this.textIn = value;
    }
    get mentions() {
        return this.mentionsIn;
    }
    set mentions(value) {
        this.mentionsIn = value;
    }
    get isPosted() {
        return this.posted;
    }
    set isPosted(value) {
        this.posted = value;
    }
    getLength() {
        return 1;
    }
    clone() {
        let comment = new CommentElementBox(this.date);
        comment.author = this.author;
        comment.initial = this.initial;
        comment.commentId = this.commentId;
        comment.replyComments = this.replyComments;
        comment.isResolved = this.isResolved;
        comment.text = this.text;
        return comment;
    }
    destroy() {
        if (this.replyComments && this.replyComments.length > 0) {
            for (let i = 0; i < this.replyComments.length; i++) {
                let replyComment = this.replyComments[i];
                replyComment.destroy();
            }
            this.replyComments = [];
        }
        this.replyComments = undefined;
        if (this.commentStartIn) {
            this.commentStartIn.destroy();
            this.commentStartIn = undefined;
        }
        if (this.commentEndIn) {
            this.commentEndIn.destroy();
            this.commentEndIn = undefined;
        }
        this.commentId = undefined;
        this.createdDate = undefined;
        this.initialIn = undefined;
        this.textIn = undefined;
        this.authorIn = undefined;
        this.ownerComment = undefined;
        super.destroy();
    }
}
/**
 * @private
 */
export class Page {
    /**
     * Initialize the constructor of Page
     */
    constructor(documentHelper) {
        /**
         * Specifies the Bonding Rectangle
         * @private
         */
        this.boundingRectangle = new Rect(96, 96, 816, 1056);
        /**
         * @private
         */
        this.repeatHeaderRowTableWidget = false;
        /**
         * Specifies the bodyWidgets
         * @default []
         * @private
         */
        this.bodyWidgets = [];
        /**
         * @private
         */
        this.headerWidgetIn = undefined;
        /**
         * @private
         */
        this.footerWidgetIn = undefined;
        /**
         * @private
         */
        this.footnoteWidget = undefined;
        /**
         * @private
         */
        this.endnoteWidget = undefined;
        /**
         * @private
         */
        this.currentPageNum = 1;
        /**
         * @private
         */
        this.allowNextPageRendering = true;
        this.documentHelper = documentHelper;
        // let text: string = 'DocumentEditor';
    }
    /**
     * @private
     */
    get headerWidget() {
        if (!isNullOrUndefined(this.headerWidgetIn)) {
            if (this.headerWidgetIn.parentHeaderFooter) {
                return this.headerWidgetIn.parentHeaderFooter;
            }
        }
        return this.headerWidgetIn;
    }
    /**
     * @private
     */
    set headerWidget(value) {
        this.headerWidgetIn = value;
    }
    /**
     * @private
     */
    get footerWidget() {
        if (!isNullOrUndefined(this.footerWidgetIn)) {
            if (this.footerWidgetIn.parentHeaderFooter) {
                return this.footerWidgetIn.parentHeaderFooter;
            }
        }
        return this.footerWidgetIn;
    }
    /**
     * @private
     */
    set footerWidget(value) {
        this.footerWidgetIn = value;
    }
    /**
     * @private
     */
    get index() {
        if (this.documentHelper) {
            return this.documentHelper.pages.indexOf(this);
        }
        return -1;
    }
    /**
     * @private
     */
    get previousPage() {
        let index = this.index;
        if (index > 0) {
            return this.documentHelper.pages[index - 1];
        }
        return undefined;
    }
    /**
     * @private
     */
    get nextPage() {
        let index = this.index;
        if (index < this.documentHelper.pages.length - 1) {
            return this.documentHelper.pages[index + 1];
        }
        return undefined;
    }
    /**
     * @private
     */
    get sectionIndex() {
        if (this.bodyWidgets.length > 0) {
            return this.bodyWidgets[0].index;
        }
        return -1;
    }
    get viewer() {
        return this.documentHelper.owner.viewer;
    }
    destroy() {
        if (this.headerWidget && this.headerWidget.page === this) {
            this.headerWidget.page = undefined;
        }
        if (this.footerWidget && this.footerWidget.page === this) {
            this.footerWidget.page = undefined;
        }
        if (this.headerWidgetIn && !isNullOrUndefined(this.headerWidgetIn.parentHeaderFooter)) {
            if (this.viewer && this.documentHelper.owner.editorModule) {
                this.documentHelper.owner.editorModule.removeFieldInWidget(this.headerWidgetIn);
                // Remove content control
                this.documentHelper.owner.editorModule.removeFieldInWidget(this.headerWidgetIn, false, true);
            }
            this.headerWidgetIn.destroy();
            this.headerWidget = undefined;
        }
        if (this.footerWidgetIn && !isNullOrUndefined(this.footerWidgetIn.parentHeaderFooter)) {
            if (this.viewer && this.documentHelper.owner.editorModule) {
                this.documentHelper.owner.editorModule.removeFieldInWidget(this.footerWidgetIn);
                // Remove content control
                this.documentHelper.owner.editorModule.removeFieldInWidget(this.footerWidgetIn, false, true);
            }
            this.footerWidgetIn.destroy();
            this.footerWidgetIn = undefined;
        }
        this.bodyWidgets = [];
        this.bodyWidgets = undefined;
        if (!isNullOrUndefined(this.documentHelper)) {
            if (!isNullOrUndefined(this.documentHelper.pages)) {
                this.documentHelper.removePage(this);
            }
        }
        this.documentHelper = undefined;
    }
    /**
     * Disposes the internal objects which are maintained.
     * @private
     */
    componentDestroy() {
        if (this.headerWidgetIn) {
            this.headerWidgetIn.componentDestroy();
            this.headerWidgetIn = undefined;
        }
        if (this.footerWidgetIn) {
            this.footerWidgetIn.componentDestroy();
            this.footerWidgetIn = undefined;
        }
        if (this.bodyWidgets) {
            for (let i = 0; i < this.bodyWidgets.length; i++) {
                let bodyWidget = this.bodyWidgets[i];
                bodyWidget.componentDestroy();
            }
            this.bodyWidgets = [];
            this.bodyWidgets = undefined;
        }
        this.documentHelper = undefined;
    }
}
/**
 * @private
 */
export class WTableHolder {
    constructor() {
        this.tableColumns = [];
        /**
         * @private
         */
        this.tableWidth = 0;
    }
    get columns() {
        return this.tableColumns;
    }
    /**
     * @private
     */
    resetColumns() {
        for (let i = 0; i < this.tableColumns.length; i++) {
            this.tableColumns[i].destroy();
        }
        this.tableColumns = [];
    }
    /**
     * @private
     */
    getPreviousSpannedCellWidth(previousColumnIndex, curColumnIndex) {
        let width = 0;
        for (let i = previousColumnIndex; i < curColumnIndex; i++) {
            width += this.tableColumns[i].preferredWidth;
        }
        return width;
    }
    /**
     * @private
     */
    addColumns(currentColumnIndex, columnSpan, width, sizeInfo, offset, preferredWidthType, isAutoWidth) {
        for (let i = this.columns.length; i < columnSpan; i++) {
            this.columns.push(new WColumn());
        }
        let availableWidth = 0;
        for (let j = currentColumnIndex; j < columnSpan; j++) {
            availableWidth += this.columns[j].preferredWidth;
        }
        // If width to add is greater than preferred width, then preferred width will be increased.
        // In case of Grid span > 1, only last grid column width will be updated.
        let gridSpan = columnSpan - currentColumnIndex;
        let isSpannedCell = !isAutoWidth || !(gridSpan > 1) || preferredWidthType === 'Auto';
        if (!(gridSpan > 1) && availableWidth < width) {
            this.columns[columnSpan - 1].preferredWidth += (width - availableWidth);
        }
        // Sets minimum word width for cell with one span, because content from spanned cells are not consider as minimum word of the column
        if (isSpannedCell && sizeInfo.minimumWordWidth > this.columns[columnSpan - 1].minimumWordWidth) {
            this.columns[columnSpan - 1].minimumWordWidth = sizeInfo.minimumWordWidth;
        }
        // Sets maximum word width for cell with one span, because content from spanned cells are not consider as maximum word of the column
        if (isSpannedCell && sizeInfo.maximumWordWidth > this.columns[columnSpan - 1].maximumWordWidth) {
            this.columns[columnSpan - 1].maximumWordWidth = sizeInfo.maximumWordWidth;
        }
        if (sizeInfo.minimumWidth > this.columns[columnSpan - 1].minimumWidth) {
            this.columns[columnSpan - 1].minimumWidth = sizeInfo.minimumWidth;
        }
        if (offset > this.columns[columnSpan - 1].endOffset) {
            this.columns[columnSpan - 1].endOffset = offset;
        }
        this.columns[columnSpan - 1].widthType = preferredWidthType;
    }
    /**
     * @private
     */
    getTotalWidth(type) {
        let width = 0;
        for (let i = 0; i < this.columns.length; i++) {
            let column = this.columns[i];
            width += type === 0 ? column.preferredWidth :
                type === 1 ? column.minimumWordWidth :
                    type === 2 ? column.maximumWordWidth : column.minimumWidth;
        }
        return width;
    }
    /**
     * @private
     */
    isFitColumns(containerWidth, preferredTableWidth, isAutoWidth) {
        // Gets total preferred width.
        let totalColumnWidth = this.getTotalWidth(0);
        // If auto table width, based on total column widths, minimum value will be updated.
        if (isAutoWidth) {
            this.tableWidth = preferredTableWidth > totalColumnWidth ? totalColumnWidth : preferredTableWidth;
        }
        else {
            this.tableWidth = preferredTableWidth;
        }
        // If total columns width doesn't match table width, then all grid column widths will be updated by even factor.
        // If totalColumnWidth < TableWidth, all grid columns are enlarged. Otherwise shrinked.
        if (totalColumnWidth !== this.tableWidth) {
            let factor = this.tableWidth / totalColumnWidth;
            factor = isNaN(factor) || factor === Infinity ? 1 : factor;
            for (let i = 0; i < this.columns.length; i++) {
                let column = this.columns[i];
                //column.PreferredWidth = factor * column.PreferredWidth;
                if (factor * column.preferredWidth < column.minWidth) {
                    return false;
                }
            }
            return true;
        }
        else {
            return true;
        }
    }
    /**
     * @private
     */
    isAllColumnHasPointWidthType() {
        let isPointWidthType = true;
        for (let i = 0; i < this.columns.length; i++) {
            if (this.columns[i].widthType != 'Point') {
                isPointWidthType = false;
            }
        }
        return isPointWidthType;
    }
    /**
     * @private
     */
    autoFitColumn(containerWidth, preferredTableWidth, isAuto, isNestedTable, isAutoFit, hasSpannedCells, clientWidth, indent, pageContainerWidth, tablePreferredWidthType, gridBeforeWidth) {
        // Cell's preferred width should be considered until the table width fits to the container width.
        let maxTotal = 0;
        let minTotal = 0;
        // For preferred width set as 0 pixels (not auto), then minimum word width only need to be considered.
        // But currently there is no way to find any one of cell in particular column has 0 px preferred width set.
        // If all columns are set as 0 pixels, then this will work.
        let remainingWidthTotal = 0;
        let isAllColumnPointWidth = this.columns.every(column => column.widthType === 'Point');
        let minWidthExceedCellWidth = 0;
        let columnIndexCollection = [];
        let totalColumnsPreferredWidth = this.getTotalWidth(0);
        let isTableHasPointWidth = !isAuto && tablePreferredWidthType === "Point" && isAllColumnPointWidth && !hasSpannedCells && HelperMethods.round(preferredTableWidth, 2) < HelperMethods.round(totalColumnsPreferredWidth, 2);
        for (let i = 0; i < this.columns.length; i++) {
            let column = this.columns[i];
            // If preferred width of column is less than column minimum width and also column is empty, considered column preferred width
            if (column.minimumWordWidth === 0 && column.maximumWordWidth === 0 && column.minWidth === 0) {
                if (isAllColumnPointWidth) {
                    column.minimumWordWidth = column.minimumWidth > column.preferredWidth ? column.minimumWidth : column.preferredWidth;
                    column.maximumWordWidth = column.minimumWidth > column.preferredWidth ? column.minimumWidth : column.preferredWidth;
                    column.minWidth = column.minimumWidth > column.preferredWidth ? column.minimumWidth : column.preferredWidth;
                }
                else {
                    column.minimumWordWidth = column.minimumWidth > 0 ? column.minimumWidth : column.preferredWidth;
                    column.maximumWordWidth = column.minimumWidth > 0 ? column.minimumWidth : column.preferredWidth;
                    column.minWidth = column.minimumWidth > 0 ? column.minimumWidth : column.preferredWidth;
                }
            }
            if (isTableHasPointWidth) {
                this.columns[i].preferredWidth = (this.columns[i].preferredWidth / totalColumnsPreferredWidth) * preferredTableWidth;
            }
            let difference = 0;
            maxTotal += column.preferredWidth > column.maximumWordWidth ? column.preferredWidth : column.maximumWordWidth;
            minTotal += column.preferredWidth > column.minimumWordWidth ? column.preferredWidth : column.minimumWordWidth;
            let preferred = column.preferredWidth === 0 ? column.minimumWordWidth : column.preferredWidth > column.minimumWordWidth ? column.preferredWidth : column.minimumWordWidth;
            difference = column.maximumWordWidth - preferred;
            remainingWidthTotal += difference > 0 ? difference : 0;
            if (column.preferredWidth < column.minimumWordWidth) {
                minWidthExceedCellWidth += column.minimumWordWidth - column.preferredWidth;
            }
            else {
                columnIndexCollection.push(i);
            }
        }
        // Try to fit maximum word width to match preferredTableWidth.
        if (maxTotal <= preferredTableWidth) {
            for (let i = 0; i < this.columns.length; i++) {
                let column = this.columns[i];
                if (column.widthType === 'Point') {
                    if (column.preferredWidth < column.minimumWordWidth) {
                        column.preferredWidth = column.minimumWordWidth;
                    }
                    continue;
                }
                if (column.preferredWidth < column.maximumWordWidth) {
                    // if (isNestedTable) {
                    //     column.preferredWidth = column.minimumWidth + column.minimumWordWidth;
                    // } else {
                    column.preferredWidth = column.maximumWordWidth;
                    //}
                }
            }
            // If the width is defined for table(cells undefined) then fit the columns to preferred table width using FitColumns.
            if (!isAuto) {
                this.fitColumns(containerWidth, preferredTableWidth, isAuto, isAutoFit);
            }
        }
        else {
            let totalPreferredWidth = this.getTotalWidth(0);
            if (isAllColumnPointWidth && !hasSpannedCells) {
                if (minTotal > containerWidth) {
                    if (containerWidth > totalPreferredWidth) {
                        minWidthExceedCellWidth -= (containerWidth - (totalPreferredWidth));
                    }
                    if (columnIndexCollection.length > 0 && minWidthExceedCellWidth > 0) {
                        let averageWidth = minWidthExceedCellWidth / this.columns.length;
                        for (let i = 0; i < this.columns.length; i++) {
                            let column = this.columns[i];
                            if (columnIndexCollection.indexOf(i) === -1) {
                                // Bug 891720: If minimum word width is greater than total preferred width, then set preferred width to resolve the layout issue.
                                if (totalPreferredWidth > column.minimumWordWidth) {
                                    column.preferredWidth = column.minimumWordWidth;
                                }
                            }
                            else {
                                column.preferredWidth = (column.preferredWidth - averageWidth);
                                // Bug 890447: If the preferred width is less than minimum word width, then set minimum word width as preferred width.
                                if (column.preferredWidth < column.minimumWordWidth) {
                                    column.preferredWidth = column.minimumWordWidth;
                                }
                            }
                        }
                        isTableHasPointWidth = !isAuto && tablePreferredWidthType === "Point" && HelperMethods.round(preferredTableWidth, 2) <= HelperMethods.round(totalColumnsPreferredWidth, 2);
                        totalPreferredWidth = this.getTotalWidth(0);
                    }
                }
            }
            // If the table preferred table width is set, then check its greater than total minimum word width. 
            // If yes then set table preferred table width as container width. Else, check whether the total minimum word width is less than container width.
            // If yes, then set total minimum word width as container width. Else, set the container width to container width.
            if (!isAuto) {
                //let totalMinimumWordWidth: number = this.getTotalWidth(1);
                //if (preferredTableWidth > totalMinimumWordWidth && totalMinimumWordWidth < containerWidth) {
                let considerMinAsTableWidth = preferredTableWidth < minTotal && minTotal + (isNullOrUndefined(indent) ? 0 : indent) < containerWidth;
                if (isTableHasPointWidth && considerMinAsTableWidth) {
                    if (minTotal > preferredTableWidth && minWidthExceedCellWidth > 0) {
                        if (preferredTableWidth > totalPreferredWidth) {
                            minWidthExceedCellWidth -= (preferredTableWidth - totalPreferredWidth);
                        }
                        let averageWidth = minWidthExceedCellWidth / columnIndexCollection.length;
                        for (let i = 0; i < this.columns.length; i++) {
                            let column = this.columns[i];
                            if (columnIndexCollection.indexOf(i) === -1) {
                                column.preferredWidth = column.minimumWordWidth;
                            }
                            else {
                                column.preferredWidth = (column.preferredWidth - averageWidth);
                            }
                        }
                        totalPreferredWidth = this.getTotalWidth(0);
                    }
                    return;
                }
                this.fitColumns(containerWidth, considerMinAsTableWidth ? minTotal : preferredTableWidth, isAuto, isAutoFit);
                return;
                //}
                //containerWidth = preferredTableWidth < totalMinimumWordWidth ? totalMinimumWordWidth < containerWidth ? totalMinimumWordWidth : containerWidth : preferredTableWidth;
            }
            // Try to fit minimum word width to match preferredTableWidth or containerWidth.
            if (minTotal <= preferredTableWidth || minTotal <= containerWidth) {
                let availableWidth = containerWidth > preferredTableWidth ? containerWidth : preferredTableWidth;
                availableWidth = availableWidth - minTotal;
                for (let i = 0; i < this.columns.length; i++) {
                    let column = this.columns[i];
                    if (column.widthType === 'Point') {
                        continue;
                    }
                    if (column.preferredWidth === 0) {
                        column.preferredWidth = column.minimumWordWidth;
                    }
                    else {
                        if (column.preferredWidth < column.minimumWordWidth) {
                            column.preferredWidth = column.minimumWordWidth;
                        }
                    }
                    let difference = column.maximumWordWidth - column.preferredWidth;
                    difference = difference > 0 ? difference : 0;
                    let factor = availableWidth * (difference / remainingWidthTotal);
                    column.preferredWidth += isNaN(factor) ? 0 : factor;
                }
            }
            else {
                // Try to fit minimum width for each column and allot remaining space to columns based on their minimum word width.
                let totalMinimumWordWidth = this.getTotalWidth(1);
                let totalMinWidth = this.getTotalWidth(3);
                let totalMaximumWordWidth = this.getTotalWidth(2);
                if (totalMinWidth > 2112) {
                    let cellWidth = 2112 / this.columns.length;
                    for (let i = 0; i < this.columns.length; i++) {
                        this.columns[i].preferredWidth = cellWidth;
                    }
                }
                else {
                    let availableWidth = 0;
                    if (((totalMinWidth < containerWidth) && ((containerWidth - totalMinWidth) >= 1) && !isAllColumnPointWidth)
                        || (isAllColumnPointWidth && !hasSpannedCells && totalMinimumWordWidth > containerWidth)
                        || (hasSpannedCells && Math.round(totalPreferredWidth) > Math.round(containerWidth) && totalMaximumWordWidth > clientWidth)
                        || (hasSpannedCells && isAuto && totalMinimumWordWidth > totalPreferredWidth && Math.round(containerWidth) > Math.round(totalPreferredWidth) && !gridBeforeWidth && totalMinimumWordWidth < clientWidth)) {
                        if (isNestedTable || !hasSpannedCells || !isAllColumnPointWidth) {
                            availableWidth = containerWidth - totalMinWidth;
                            for (let i = 0; i < this.columns.length; i++) {
                                let column = this.columns[i];
                                // The factor depends of current column's minimum word width and total minimum word width.
                                let factor = availableWidth * column.minimumWordWidth / totalMinimumWordWidth;
                                factor = isNaN(factor) ? 0 : factor;
                                column.preferredWidth = (column.minimumWidth == 0 ? 1 : column.minimumWidth) + factor;
                            }
                        }
                        else {
                            // Case 1: When the total minimum word width is less than the container width
                            // The remaining space is distributed across columns based on how much extra width each column is allowed beyond its minimum.
                            // Each column's share of the extra space is determined by comparing its preferred width to its minimum word width.
                            // The final preferred width is updated by adding the calculated share of extra space to the column's minimum word width.
                            if (totalMinimumWordWidth <= preferredTableWidth || totalMinimumWordWidth <= containerWidth) {
                                let targetwidth = containerWidth > preferredTableWidth ? containerWidth : preferredTableWidth;
                                let extraSpace = targetwidth - totalMinimumWordWidth;
                                let totalDifference = Math.abs(totalPreferredWidth - totalMinimumWordWidth);
                                for (let i = 0; i < this.columns.length; i++) {
                                    let column = this.columns[i];
                                    if (column.preferredWidth === 0) {
                                        column.preferredWidth = column.minimumWordWidth;
                                    }
                                    else {
                                        if (column.preferredWidth < column.minimumWordWidth) {
                                            column.preferredWidth = column.minimumWordWidth;
                                        }
                                    }
                                    let balance = column.preferredWidth - column.minimumWordWidth;
                                    let factor = extraSpace * balance / totalDifference;
                                    factor = isNaN(factor) ? 0 : factor;
                                    column.preferredWidth = column.minimumWordWidth + factor;
                                }
                                // Case 2: When the total minimum word width exceeds the container width
                                // Each column's content width is considered to understand how much space it ideally needs
                                // The final preferred width is calculated by adding a proportion of the available space to the column's minimum width, based on how much content it holds relative to the total content.
                            }
                            else if (totalPreferredWidth > containerWidth || totalPreferredWidth < totalMinimumWordWidth) {
                                availableWidth = containerWidth - totalMinWidth;
                                const contentWidths = [];
                                let totalContentWidth = 0;
                                for (let i = 0; i < this.columns.length; i++) {
                                    const col = this.columns[i];
                                    const contentWidth = col.minimumWordWidth - col.minimumWidth === 0 ? col.minimumWidth : Math.abs(col.minimumWordWidth - col.minimumWidth);
                                    contentWidths[i] = contentWidth;
                                    totalContentWidth += contentWidth;
                                }
                                for (let i = 0; i < this.columns.length; i++) {
                                    let column = this.columns[i];
                                    // The factor depends of current column's content width and total content width.
                                    let factor = availableWidth * contentWidths[i] / totalContentWidth;
                                    factor = isNaN(factor) ? 0 : factor;
                                    column.preferredWidth = (column.minimumWidth == 0 ? 1 : column.minimumWidth) + factor;
                                }
                            }
                        }
                        // table width exceeds container width
                    }
                    else if (totalPreferredWidth > containerWidth) {
                        let factor = containerWidth / totalPreferredWidth;
                        for (let i = 0; i < this.columns.length; i++) {
                            let column = this.columns[i];
                            column.preferredWidth = column.preferredWidth * factor;
                        }
                    }
                }
            }
        }
        this.tableWidth = this.getTotalWidth(0);
    }
    /**
     * @private
     */
    getValidColumnIndex(index) {
        let endOffset = 0;
        for (let i = 0; i < this.columns.length; i++) {
            let column = this.columns[i];
            if (i < index) {
                endOffset = column.endOffset;
            }
            else if (endOffset === column.endOffset) {
                //Increment the columnIndex if next column has zero width.
                index++;
            }
            else {
                break;
            }
        }
        return index;
    }
    /**
     * @private
     */
    fitColumns(containerWidth, preferredTableWidth, isAutoWidth, isAutoFit, indent) {
        if (isNullOrUndefined(indent)) {
            indent = 0;
        }
        // Gets total preferred width.
        let totalColumnWidth = this.getTotalWidth(0);
        // Neglected left indent value, because in preferred table width left indent value is neglected
        if (isAutoWidth) {
            totalColumnWidth -= indent;
        }
        // If auto table width, based on total column widths, minimum value will be updated.
        if (isAutoWidth) {
            this.tableWidth = totalColumnWidth;
        }
        else {
            this.tableWidth = preferredTableWidth;
        }
        // If total columns width doesn't match table width, then all grid column widths will be updated by even factor.
        // If totalColumnWidth < TableWidth, all grid columns are enlarged. Otherwise shrinked.
        if (totalColumnWidth !== this.tableWidth) {
            let factor = this.tableWidth / totalColumnWidth;
            factor = isNaN(factor) || factor === Infinity ? 1 : factor;
            for (let i = 0; i < this.columns.length; i++) {
                let column = this.columns[i];
                if (column.widthType === 'Percent' && !isAutoWidth && !isAutoFit && totalColumnWidth > this.tableWidth) {
                    if (i !== 0 && column.endOffset > this.tableWidth) {
                        let totalCellWidth = this.getCellWidth(0, i + 1, preferredTableWidth);
                        if (totalCellWidth > this.tableWidth) {
                            column.preferredWidth -= (totalCellWidth - this.tableWidth);
                            if (column.preferredWidth === 0 || column.preferredWidth < column.minimumWidth) {
                                column.preferredWidth = column.minimumWidth > 0 ? column.minimumWidth : 1;
                                this.columns[0].preferredWidth -= column.preferredWidth;
                            }
                        }
                    }
                }
                else {
                    column.preferredWidth = factor * column.preferredWidth;
                }
            }
        }
    }
    /**
     * @private
     */
    getCellWidth(columnIndex, columnSpan, preferredTableWidth, isTableResizing) {
        let width = 0;
        for (let i = 0; i < columnSpan; i++) {
            width += isTableResizing ? HelperMethods.round(this.tableColumns[i + columnIndex].preferredWidth, 2)
                : this.tableColumns[i + columnIndex].preferredWidth;
        }
        return width;
    }
    /**
     * @private
     */
    validateColumnWidths() {
        for (let i = 0; i < this.columns.length; i++) {
            if (i === 0) {
                if (this.columns[i].preferredWidth !== this.columns[i].endOffset) {
                    this.columns[i].preferredWidth = this.columns[i].endOffset;
                }
            }
            else {
                // If Previous column offset + current column preferred width is less than current column offset, 
                // Then current column preferred width is set to current column offset - previous column offset.
                if (this.columns[i - 1].endOffset + this.columns[i].preferredWidth < this.columns[i].endOffset) {
                    if (this.columns[i - 1].endOffset === 0) {
                        this.columns[i].preferredWidth = this.columns[i].endOffset - this.getPreviousValidOffset(i - 2);
                    }
                    else {
                        this.columns[i].preferredWidth = this.columns[i].endOffset - this.columns[i - 1].endOffset;
                    }
                }
            }
        }
    }
    getPreviousValidOffset(columnIndex) {
        for (let j = columnIndex; j >= 0; j--) {
            if (this.columns[j].endOffset !== 0) {
                return this.columns[j].endOffset;
            }
        }
        return 0;
    }
    /**
     * @private
     */
    clone() {
        let tableHolder = new WTableHolder();
        tableHolder.tableWidth = this.tableWidth;
        for (let i = 0; i < this.columns.length; i++) {
            tableHolder.columns.push(this.columns[i].clone());
        }
        return tableHolder;
    }
    /**
     * @private
     */
    destroy() {
        if (!isNullOrUndefined(this.tableColumns)) {
            for (let i = 0; i < this.tableColumns.length; i++) {
                let column = this.tableColumns[i];
                column.destroy();
            }
        }
        this.tableColumns = [];
        this.tableColumns = undefined;
        this.tableWidth = undefined;
    }
}
/**
 * @private
 */
export class WColumn {
    constructor() {
        /**
         * @private
         */
        this.preferredWidth = 0;
        /**
         * @private
         */
        this.minWidth = 0;
        /**
         * @private
         */
        this.maxWidth = 0;
        /**
         * @private
         */
        this.endOffset = 0;
        /**
         * @private
         */
        this.minimumWordWidth = 0;
        /**
         * @private
         */
        this.maximumWordWidth = 0;
        /**
         * @private
         */
        this.minimumWidth = 0;
    }
    /**
     * @private
     */
    clone() {
        let column = new WColumn();
        column.preferredWidth = this.preferredWidth;
        column.minWidth = this.minWidth;
        column.maxWidth = this.maxWidth;
        return column;
    }
    /**
     * @private
     */
    destroy() {
        this.preferredWidth = undefined;
        this.minWidth = undefined;
        this.maxWidth = undefined;
    }
}
/**
 * @private
 */
export class ColumnSizeInfo {
    constructor() {
        /**
         * @private
         */
        this.minimumWordWidth = 0;
        /**
         * @private
         */
        this.maximumWordWidth = 0;
        /**
         * @private
         */
        this.minimumWidth = 0;
        /**
         * @private
         */
        this.hasMinimumWidth = false;
        /**
         * @private
         */
        this.hasMinimumWordWidth = false;
        /**
         * @private
         */
        this.hasMaximumWordWidth = false;
    }
}
/**
 * @private
 */
export class CommentEditInfo {
}
/**
 * @private
 */
export class MentionDataEditInfo {
}
/**
 * @private
 */
export class BreakElementBox extends TextElementBox {
    constructor() {
        super();
    }
    /**
     * @private
     */
    clone() {
        let breakElement = super.clone();
        breakElement.breakClearType = this.breakClearType;
        return breakElement;
    }
    /*
    * @Private
    */
    destroy() {
        this.breakClearType = undefined;
        super.destroy();
    }
    /*
    * @Private
    */
    componentDestroy() {
        this.breakClearType = undefined;
        super.componentDestroy();
    }
}
/**
 * @private
 */
export class TabStopListInfo {
}
/**
 * @private
 */
export class FootnoteEndnoteMarkerElementBox extends TextElementBox {
    /**
     * @private
     */
    getLength() {
        return 1;
    }
    /**
     * @private
     */
    clone() {
        // return super.clone();
        let footEndEle = new FootnoteEndnoteMarkerElementBox();
        footEndEle.characterFormat.copyFormat(this.characterFormat);
        footEndEle.text = this.text;
        if (this.margin) {
            footEndEle.margin = this.margin.clone();
        }
        footEndEle.baselineOffset = this.baselineOffset;
        // if (!isNullOrUndefined(this.paragraph) && this.paragraph.isInHeaderFooter) {
        //     if (this.revisionLength > 0) {
        //         for (let i: number = 0; i < this.revisionLength; i++) {
        //             let revision: Revision = this.getRevision(i);
        //             footEndEle.addRevision(revision.clone());
        //         }
        //     }
        // } else {
        if (this.revisionLength > 0) {
            footEndEle.removedIds = Revision.cloneRevisions(this.getAllRevision());
        }
        else {
            footEndEle.removedIds = this.removedIds.slice();
        }
        // }
        footEndEle.width = this.width;
        footEndEle.height = this.height;
        if (this.contentControlProperties) {
            footEndEle.contentControlProperties = this.contentControlProperties;
        }
        return footEndEle;
    }
}
